import { Knex } from "knex";

/*
 * This file was generated by a tool.
 * Rerun `yarn generate-types` to regenerate this file.
 */
/** A class on Outschool */
export interface ActivitiesRow {
  age_max: number | null;
  age_min: number | null;
  allow_waitlist: boolean;
  allows_late_enrollments_for_fixed_length_classes: boolean;
  allows_recurring_payment: boolean | null;
  archived_at: Date | null;
  assessment: string | null;
  attribution: any | null;
  auto_scheduling_days_notice_max: number | null;
  auto_scheduling_days_notice_min: number | null;
  checklist: any | null;
  class_experience: string | null;
  class_featured_at: Date | null;
  class_request_uid: string | null;
  club_banner_image_uid: string | null;
  club_welcome_video_uid: string | null;
  created_at: Date | null;
  created_by_uid: string | null;
  deleted_at: Date | null;
  details: any | null;
  disclaimer: string | null;
  duration_minutes: number | null;
  duration_weeks: number | null;
  english_proficiency_level: english_proficiency_level | null;
  /** Time when activity was first listed on the marketplace */
  first_listed_at: Date | null;
  /** The highest grade level in the range. */
  grade_level_max: string | null;
  /** The lowest grade level in the range. */
  grade_level_min: string | null;
  grading_policy: string | null;
  has_building_content: boolean;
  has_external_resources: boolean | null;
  homework: string | null;
  is_auto_scheduling_enabled: boolean;
  is_club: boolean;
  is_ongoing_weekly: boolean | null;
  is_online: boolean | null;
  is_self_paced: boolean | null;
  is_waitlist_allowed: boolean | null;
  language_of_instruction: string | null;
  learning_goals: string | null;
  location: any | null;
  parental_guidance: string | null;
  /** Attachment with the square photo for this activity */
  photo_square_uid: string | null;
  /** Attachment with the photo for this activity */
  photo_uid: string | null;
  prerequisites: string | null;
  price_cents: number | null;
  /** JSON object with class proficiency level and notes by teacher. */
  proficiency_level: any | null;
  published_at: Date | null;
  refund_policy_type: refund_policy;
  requested_listing_at: Date | null;
  sample_club_post: any | null;
  /** Only non-null for flex classes (weekly_meetings &#x3D; 0). If not null, is the time that the class will be available to have self-paced enrollments occur.  If null, self-paced enrollments are not currently available. */
  self_paced_enrollment_enabled_at: Date | null;
  size_max: number | null;
  size_min: number | null;
  slug_id: string;
  sources: string | null;
  strict_age_max: number | null;
  strict_age_min: number | null;
  subject: string | null;
  summary: string | null;
  summary_for_learners: string | null;
  tags: string | null;
  title: string;
  uid: string;
  updated_at: Date | null;
  upsell_activity_uid: string | null;
  /** The provider of the class (could be a teacher or an organization) */
  user_uid: string;
  uses_teacher_scheduling: boolean;
  /** Marketing video attachment shown to learners */
  video_for_learners_uid: string | null;
  /** Marketing video attachment shown to parents */
  video_uid: string | null;
  weekly_meetings: number | null;
  welcome_message: any | null;
  why_me: string | null;
}
export interface CreateActivitiesRow {
  age_max?: number | null;
  age_min?: number | null;
  allow_waitlist?: boolean;
  allows_late_enrollments_for_fixed_length_classes?: boolean;
  allows_recurring_payment?: boolean | null;
  archived_at?: Date | null;
  assessment?: string | null;
  attribution?: any | null;
  auto_scheduling_days_notice_max?: number | null;
  auto_scheduling_days_notice_min?: number | null;
  checklist?: any | null;
  class_experience?: string | null;
  class_featured_at?: Date | null;
  class_request_uid?: string | null;
  club_banner_image_uid?: string | null;
  club_welcome_video_uid?: string | null;
  created_at?: Date | null;
  created_by_uid?: string | null;
  deleted_at?: Date | null;
  details?: any | null;
  disclaimer?: string | null;
  duration_minutes?: number | null;
  duration_weeks?: number | null;
  english_proficiency_level?: english_proficiency_level | null;
  /** Time when activity was first listed on the marketplace */
  first_listed_at?: Date | null;
  /** The highest grade level in the range. */
  grade_level_max?: string | null;
  /** The lowest grade level in the range. */
  grade_level_min?: string | null;
  grading_policy?: string | null;
  has_building_content?: boolean;
  has_external_resources?: boolean | null;
  homework?: string | null;
  is_auto_scheduling_enabled?: boolean;
  is_club?: boolean;
  is_ongoing_weekly?: boolean | null;
  is_online?: boolean | null;
  is_self_paced?: boolean | null;
  is_waitlist_allowed?: boolean | null;
  language_of_instruction?: string | null;
  learning_goals?: string | null;
  location?: any | null;
  parental_guidance?: string | null;
  /** Attachment with the square photo for this activity */
  photo_square_uid?: string | null;
  /** Attachment with the photo for this activity */
  photo_uid?: string | null;
  prerequisites?: string | null;
  price_cents?: number | null;
  /** JSON object with class proficiency level and notes by teacher. */
  proficiency_level?: any | null;
  published_at?: Date | null;
  refund_policy_type?: refund_policy;
  requested_listing_at?: Date | null;
  sample_club_post?: any | null;
  /** Only non-null for flex classes (weekly_meetings &#x3D; 0). If not null, is the time that the class will be available to have self-paced enrollments occur.  If null, self-paced enrollments are not currently available. */
  self_paced_enrollment_enabled_at?: Date | null;
  size_max?: number | null;
  size_min?: number | null;
  slug_id?: string;
  sources?: string | null;
  strict_age_max?: number | null;
  strict_age_min?: number | null;
  subject?: string | null;
  summary?: string | null;
  summary_for_learners?: string | null;
  tags?: string | null;
  title: string;
  uid?: string;
  updated_at?: Date | null;
  upsell_activity_uid?: string | null;
  /** The provider of the class (could be a teacher or an organization) */
  user_uid: string;
  uses_teacher_scheduling?: boolean;
  /** Marketing video attachment shown to learners */
  video_for_learners_uid?: string | null;
  /** Marketing video attachment shown to parents */
  video_uid?: string | null;
  weekly_meetings?: number | null;
  welcome_message?: any | null;
  why_me?: string | null;
}
export interface ActivitiesAsSearchDocumentRow {
  document: any | null;
  uid: string | null;
}
export interface CreateActivitiesAsSearchDocumentRow {
  document?: any | null;
  uid?: string | null;
}
export interface ActivityActionsRow {
  action: string;
  activity_uid: string;
  created_at: Date | null;
  html_snapshot_s3_key: string | null;
  llm_response: string | null;
  message_to_teacher: string | null;
  notes: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string;
}
export interface CreateActivityActionsRow {
  action: string;
  activity_uid: string;
  created_at?: Date | null;
  html_snapshot_s3_key?: string | null;
  llm_response?: string | null;
  message_to_teacher?: string | null;
  notes?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid: string;
}
export interface ActivityExternalResourcesRow {
  activity_uid: string;
  created_at: Date | null;
  deleted_at: Date | null;
  name: string | null;
  policy_uid: string | null;
  uid: string;
  updated_at: Date | null;
  url: string | null;
}
export interface CreateActivityExternalResourcesRow {
  activity_uid: string;
  created_at?: Date | null;
  deleted_at?: Date | null;
  name?: string | null;
  policy_uid?: string | null;
  uid?: string;
  updated_at?: Date | null;
  url?: string | null;
}
export interface ActivityGtinsRow {
  /** The activity this GTIN is assigned to */
  activity_uid: string;
  created_at: Date;
  /** UPC-A stored zero-padded to 14 digits (GS1 GTIN-14 format) */
  gtin: string;
  /** Monotonically increasing sequence used to derive the item reference portion of the GTIN */
  sequence_number: string;
  uid: string;
}
export interface CreateActivityGtinsRow {
  /** The activity this GTIN is assigned to */
  activity_uid: string;
  created_at?: Date;
  /** UPC-A stored zero-padded to 14 digits (GS1 GTIN-14 format) */
  gtin: string;
  /** Monotonically increasing sequence used to derive the item reference portion of the GTIN */
  sequence_number: string;
  uid?: string;
}
/** Stores public funding eligibility for a leader teaching an activity. */
export interface ActivityLeaderFundingEligibilitiesRow {
  /** Activity whose funding eligibility is being evaluated. */
  activity_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  /** Whether this leader is eligible for this activity/program. */
  eligible: boolean;
  /** Leader whose funding eligibility is being evaluated. */
  leader_uid: string;
  /** Funding program slug used for the eligibility evaluation. */
  program_slug: string;
  uid: string;
  updated_at: Date;
}
export interface CreateActivityLeaderFundingEligibilitiesRow {
  /** Activity whose funding eligibility is being evaluated. */
  activity_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Whether this leader is eligible for this activity/program. */
  eligible: boolean;
  /** Leader whose funding eligibility is being evaluated. */
  leader_uid: string;
  /** Funding program slug used for the eligibility evaluation. */
  program_slug: string;
  uid?: string;
  updated_at?: Date;
}
/** Activity-level potential funding eligibility: whether at least one org teacher could qualify for the activity/program even if not currently assigned. For internal tracking and staffing nudges only; NOT bookable/search/checkout eligibility. */
export interface ActivityPotentialFundingEligibilitiesRow {
  /** Activity whose potential funding eligibility is captured. */
  activity_uid: string;
  /** When the daily job first observed potentially_eligible &#x3D; true (null if never). */
  became_potentially_eligible_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  /** Count of org teachers who could individually qualify, for nudge prioritization. */
  eligible_org_teacher_count: number;
  /** Whether at least one org teacher could individually qualify for this activity/program, even if not currently assigned. */
  potentially_eligible: boolean;
  /** Funding program slug used for the eligibility evaluation. */
  program_slug: string;
  uid: string;
  updated_at: Date;
}
export interface CreateActivityPotentialFundingEligibilitiesRow {
  /** Activity whose potential funding eligibility is captured. */
  activity_uid: string;
  /** When the daily job first observed potentially_eligible &#x3D; true (null if never). */
  became_potentially_eligible_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Count of org teachers who could individually qualify, for nudge prioritization. */
  eligible_org_teacher_count: number;
  /** Whether at least one org teacher could individually qualify for this activity/program, even if not currently assigned. */
  potentially_eligible: boolean;
  /** Funding program slug used for the eligibility evaluation. */
  program_slug: string;
  uid?: string;
  updated_at?: Date;
}
export interface ActivityScheduleSettingsRow {
  activity_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  published_at: Date | null;
  schedule_maximum_notice: any;
  schedule_mininum_notice: any;
  suggested_weekly_meetings: number | null;
  teacher_schedule_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateActivityScheduleSettingsRow {
  activity_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  published_at?: Date | null;
  schedule_maximum_notice: any;
  schedule_mininum_notice: any;
  suggested_weekly_meetings?: number | null;
  teacher_schedule_uid: string;
  uid?: string;
  updated_at?: Date;
}
/** Scores for activities calculated with some external process or system (used for ranking and recommendations) */
export interface ActivityScoresRow {
  activity_uid: string | null;
  created_at: Date | null;
  deleted_at: Date | null;
  /** Additional scoring dimensions and metadata in JSON format */
  dimensions: any | null;
  /** The numerical score value for the activity under this strategy */
  score: number | null;
  /** The scoring strategy/algorithm used to generate this score (e.g. popularity, relevance, quality) */
  strategy: string | null;
  uid: string;
  updated_at: Date | null;
}
export interface CreateActivityScoresRow {
  activity_uid?: string | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  /** Additional scoring dimensions and metadata in JSON format */
  dimensions?: any | null;
  /** The numerical score value for the activity under this strategy */
  score?: number | null;
  /** The scoring strategy/algorithm used to generate this score (e.g. popularity, relevance, quality) */
  strategy?: string | null;
  uid?: string;
  updated_at?: Date | null;
}
export interface ActivitySimilarityRow {
  activity_uid: string;
  other_activity_uid: string;
  score: string;
  type: string;
}
export interface CreateActivitySimilarityRow {
  activity_uid: string;
  other_activity_uid: string;
  score: string;
  type: string;
}
export interface ActivityStatsRow {
  activity_uid: string | null;
  average_star_rating: string | null;
  completed_enrollment_count: number | null;
  eligible_for_review_count: number | null;
  fraction_poor_reviews: string | null;
  review_rate: string | null;
  reviews_count: number | null;
  reviews_count_90d: number | null;
  reviews_with_text_count: number | null;
}
export interface CreateActivityStatsRow {
  activity_uid?: string | null;
  average_star_rating?: string | null;
  completed_enrollment_count?: number | null;
  eligible_for_review_count?: number | null;
  fraction_poor_reviews?: string | null;
  review_rate?: string | null;
  reviews_count?: number | null;
  reviews_count_90d?: number | null;
  reviews_with_text_count?: number | null;
}
export interface ActivityTagsRow {
  activity_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  key: string;
  uid: string;
  updated_at: Date;
  value: string;
}
export interface CreateActivityTagsRow {
  activity_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  key: string;
  uid?: string;
  updated_at?: Date;
  value: string;
}
export interface ActivityTopicsRow {
  activity_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  topic_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateActivityTopicsRow {
  activity_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  topic_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface ActivityTranslationsRow {
  activity_uid: string;
  created_at: Date | null;
  language_code: string;
  summary: string | null;
  title: string | null;
  updated_at: Date | null;
}
export interface CreateActivityTranslationsRow {
  activity_uid: string;
  created_at?: Date | null;
  language_code: string;
  summary?: string | null;
  title?: string | null;
  updated_at?: Date | null;
}
export interface AdminEnrollmentPaymentRefundActionsRow {
  action: string;
  admin_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  enrollment_payment_refund_uid: string;
  notes: string | null;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateAdminEnrollmentPaymentRefundActionsRow {
  action: string;
  admin_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  enrollment_payment_refund_uid: string;
  notes?: string | null;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface AdminUserActionsRow {
  action: string;
  admin_uid: string;
  created_at: Date | null;
  notes: string | null;
  uid: string;
  updated_at: Date | null;
  user_incident_uid: string | null;
  user_uid: string;
}
export interface CreateAdminUserActionsRow {
  action: string;
  admin_uid: string;
  created_at?: Date | null;
  notes?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_incident_uid?: string | null;
  user_uid: string;
}
export interface AdminUserRolesRow {
  created_at: Date;
  deleted_at: Date | null;
  google_id: string;
  role: string;
  uid: string;
  updated_at: Date;
}
export interface CreateAdminUserRolesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  google_id: string;
  role: string;
  uid?: string;
  updated_at?: Date;
}
export interface AgreementTemplatesRow {
  created_at: Date;
  name: string;
  template: string;
  uid: string;
  updated_at: Date;
}
export interface CreateAgreementTemplatesRow {
  created_at?: Date;
  name: string;
  template: string;
  uid?: string;
  updated_at?: Date;
}
/** Index for quick lookups by updated time */
export interface AiActivityListingSummariesRow {
  /** Reference to the activity this summary is for */
  activity_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  /** Version identifier for the prompt used to generate this summary */
  prompt_version: number;
  /** AI-generated summary of the activity listing */
  summary: string;
  /** Type of summary: &#x27;quick_summary&#x27; for short 1-2 sentence summaries, other types to come */
  summary_type: string;
  uid: string;
  updated_at: Date;
}
export interface CreateAiActivityListingSummariesRow {
  /** Reference to the activity this summary is for */
  activity_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Version identifier for the prompt used to generate this summary */
  prompt_version: number;
  /** AI-generated summary of the activity listing */
  summary: string;
  /** Type of summary: &#x27;quick_summary&#x27; for short 1-2 sentence summaries, other types to come */
  summary_type: string;
  uid?: string;
  updated_at?: Date;
}
export interface AppleAttestationsRow {
  created_at: Date;
  key_id: string;
  public_key: string;
  sign_count: number;
}
export interface CreateAppleAttestationsRow {
  created_at?: Date;
  key_id: string;
  public_key: string;
  sign_count: number;
}
export interface AppleUsersRow {
  access_token: string;
  apple_app_id: string;
  apple_id: string;
  created_at: Date;
  deleted_at: Date | null;
  email: string;
  id_token: string;
  id_token_decoded: any;
  learner_uid: string | null;
  refresh_token: string;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateAppleUsersRow {
  access_token: string;
  apple_app_id: string;
  apple_id: string;
  created_at?: Date;
  deleted_at?: Date | null;
  email: string;
  id_token: string;
  id_token_decoded: any;
  learner_uid?: string | null;
  refresh_token: string;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
/** Conversion of a video attachment */
export interface AttachmentConversionsRow {
  /** The type of conversion action performed (filestack_video_convert) */
  action: string | null;
  created_at: Date | null;
  deleted_at: Date | null;
  /** Additional details or metadata about the conversion */
  details: any | null;
  /** The original attachment */
  original_uid: string;
  /** The resulting attachment after conversion */
  result_uid: string | null;
  /** Status of the conversion (new, started, completed, failed) */
  status: string | null;
  uid: string;
  updated_at: Date | null;
}
export interface CreateAttachmentConversionsRow {
  /** The type of conversion action performed (filestack_video_convert) */
  action?: string | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  /** Additional details or metadata about the conversion */
  details?: any | null;
  /** The original attachment */
  original_uid: string;
  /** The resulting attachment after conversion */
  result_uid?: string | null;
  /** Status of the conversion (new, started, completed, failed) */
  status?: string | null;
  uid?: string;
  updated_at?: Date | null;
}
/** Files uploaded by users or a converted version of a file */
export interface AttachmentsRow {
  created_at: Date | null;
  deleted_at: Date | null;
  /** File metadata and storage information */
  file: any | null;
  filestack_handle: string | null;
  filestack_video_thumbnail_handle: string | null;
  /** If this flag is set to true, the file can be publicly accessible, otherwise the file is private and must be served securely */
  is_public: boolean | null;
  /** Set to deleted when the file has been hard-deleted from S3; set to failed when error occurred; null means file has not attempted hard deletion */
  s3_file_hard_deletion_status: string | null;
  /** The exact path to where this file is stored in S3, not including the bucket name */
  s3_path: string | null;
  uid: string;
  updated_at: Date | null;
  /** The user who uploaded the attachment */
  user_uid: string;
  /** The exact path to where this the thumbnail for this file is stored in S3, not including the bucket name */
  video_thumbnail_s3_path: string | null;
  /** Optional transcript text for video attachments */
  video_transcript: string | null;
}
export interface CreateAttachmentsRow {
  created_at?: Date | null;
  deleted_at?: Date | null;
  /** File metadata and storage information */
  file?: any | null;
  filestack_handle?: string | null;
  filestack_video_thumbnail_handle?: string | null;
  /** If this flag is set to true, the file can be publicly accessible, otherwise the file is private and must be served securely */
  is_public?: boolean | null;
  /** Set to deleted when the file has been hard-deleted from S3; set to failed when error occurred; null means file has not attempted hard deletion */
  s3_file_hard_deletion_status?: string | null;
  /** The exact path to where this file is stored in S3, not including the bucket name */
  s3_path?: string | null;
  uid?: string;
  updated_at?: Date | null;
  /** The user who uploaded the attachment */
  user_uid: string;
  /** The exact path to where this the thumbnail for this file is stored in S3, not including the bucket name */
  video_thumbnail_s3_path?: string | null;
  /** Optional transcript text for video attachments */
  video_transcript?: string | null;
}
export interface AttendancesRow {
  attended_at: Date | null;
  created_at: Date | null;
  deleted_at: Date | null;
  learner_uid: string;
  meeting_uid: string;
  uid: string;
  updated_at: Date | null;
}
export interface CreateAttendancesRow {
  attended_at?: Date | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  learner_uid: string;
  meeting_uid: string;
  uid?: string;
  updated_at?: Date | null;
}
export interface BundleElementsRow {
  activity_uid: string;
  bundle_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  order_in_bundle: number;
  uid: string;
  updated_at: Date;
}
export interface CreateBundleElementsRow {
  activity_uid: string;
  bundle_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  order_in_bundle: number;
  uid?: string;
  updated_at?: Date;
}
export interface BundlesRow {
  created_at: Date;
  created_by_uid: string;
  deleted_at: Date | null;
  description: string | null;
  is_ordered: boolean | null;
  published_at: Date | null;
  thumbnail: string | null;
  /** Attachment with the thumbnail for this bundle */
  thumbnail_uid: string | null;
  title: string;
  uid: string;
  updated_at: Date;
}
export interface CreateBundlesRow {
  created_at?: Date;
  created_by_uid: string;
  deleted_at?: Date | null;
  description?: string | null;
  is_ordered?: boolean | null;
  published_at?: Date | null;
  thumbnail?: string | null;
  /** Attachment with the thumbnail for this bundle */
  thumbnail_uid?: string | null;
  title: string;
  uid?: string;
  updated_at?: Date;
}
export interface CategoriesRow {
  address: string | null;
  base_path: string | null;
  below_fold_description: string | null;
  below_fold_title: string | null;
  city: string | null;
  created_at: Date;
  deleted_at: Date | null;
  description_override: string | null;
  display_strategy: string;
  end_grade: string | null;
  hero_image_uid: string | null;
  hero_title: string | null;
  hero_value_props: string | null;
  inclusion_strategy: string;
  name: string;
  name_sentence_cased_override: string | null;
  name_title_cased_override: string | null;
  published_at: Date | null;
  redirect_to_path: string | null;
  saved_search_uid: string | null;
  school_level: string | null;
  slug: string;
  start_grade: string | null;
  state: string | null;
  title_override: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateCategoriesRow {
  address?: string | null;
  base_path?: string | null;
  below_fold_description?: string | null;
  below_fold_title?: string | null;
  city?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  description_override?: string | null;
  display_strategy: string;
  end_grade?: string | null;
  hero_image_uid?: string | null;
  hero_title?: string | null;
  hero_value_props?: string | null;
  inclusion_strategy: string;
  name: string;
  name_sentence_cased_override?: string | null;
  name_title_cased_override?: string | null;
  published_at?: Date | null;
  redirect_to_path?: string | null;
  saved_search_uid?: string | null;
  school_level?: string | null;
  slug: string;
  start_grade?: string | null;
  state?: string | null;
  title_override?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface CategoryActionsRow {
  action: string;
  category_uid: string;
  created_at: Date | null;
  notes: string | null;
  uid: string;
  updated_at: Date | null;
  updated_by: string;
}
export interface CreateCategoryActionsRow {
  action: string;
  category_uid: string;
  created_at?: Date | null;
  notes?: string | null;
  uid?: string;
  updated_at?: Date | null;
  updated_by: string;
}
export interface CategoryRelationshipsRow {
  created_at: Date;
  deleted_at: Date | null;
  from_category_uid: string;
  relationship_type: string;
  taxonomy_type: string;
  to_category_uid: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateCategoryRelationshipsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  from_category_uid: string;
  relationship_type: string;
  taxonomy_type: string;
  to_category_uid?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface CharterSchoolsRow {
  address: string | null;
  created_at: Date | null;
  invoice_email: string | null;
  logo_url: string | null;
  name: string | null;
  notes: string | null;
  state: string | null;
  uid: string | null;
  updated_at: Date | null;
  url_name: string | null;
}
export interface CreateCharterSchoolsRow {
  address?: string | null;
  created_at?: Date | null;
  invoice_email?: string | null;
  logo_url?: string | null;
  name?: string | null;
  notes?: string | null;
  state?: string | null;
  uid?: string | null;
  updated_at?: Date | null;
  url_name?: string | null;
}
export interface ClassInquiriesRow {
  created_at: Date;
  deleted_at: Date | null;
  inquiry_text: string;
  learner_uid: string | null;
  status: string | null;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateClassInquiriesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  inquiry_text: string;
  learner_uid?: string | null;
  status?: string | null;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface ClassInquiryTeachersRow {
  class_inquiry_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  reply_message_uid: string | null;
  teacher_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateClassInquiryTeachersRow {
  class_inquiry_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  reply_message_uid?: string | null;
  teacher_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface ClassPostCommentsRow {
  audit_log: any | null;
  background_color: string | null;
  class_post_uid: string | null;
  content_safety_check_completed_at: Date | null;
  content_safety_check_failed_at: Date | null;
  created_at: Date | null;
  deleted_at: Date | null;
  learner_uid: string | null;
  learning_assignment_class_post_uid: string | null;
  mentioned_enrollment_uids: string[] | null;
  mentioned_teacher_uid: string | null;
  message: any | null;
  message_content_uid: string;
  thread_parent_comment_uid: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string;
}
export interface CreateClassPostCommentsRow {
  audit_log?: any | null;
  background_color?: string | null;
  class_post_uid?: string | null;
  content_safety_check_completed_at?: Date | null;
  content_safety_check_failed_at?: Date | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  learner_uid?: string | null;
  learning_assignment_class_post_uid?: string | null;
  mentioned_enrollment_uids?: string[] | null;
  mentioned_teacher_uid?: string | null;
  message?: any | null;
  message_content_uid: string;
  thread_parent_comment_uid?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid: string;
}
export interface ClassPostLearnerStateRow {
  /** Reference to the class post being tracked */
  class_post_uid: string;
  /** Timestamp of when the post was marked complete */
  completed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  /** Timestamp of when the learner hearted/favorited this post */
  hearted_at: Date | null;
  /** Timestamp of when the learner last viewed this post */
  last_viewed_at: Date;
  /** Reference to the learner whose state is tracked */
  learner_uid: string;
  uid: string;
  updated_at: Date;
  /** Video watch progress as percentage (0-100) */
  video_progress: number;
  /** Number of times the video has been watched */
  video_watch_count: number;
}
export interface CreateClassPostLearnerStateRow {
  /** Reference to the class post being tracked */
  class_post_uid: string;
  /** Timestamp of when the post was marked complete */
  completed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Timestamp of when the learner hearted/favorited this post */
  hearted_at?: Date | null;
  /** Timestamp of when the learner last viewed this post */
  last_viewed_at?: Date;
  /** Reference to the learner whose state is tracked */
  learner_uid: string;
  uid?: string;
  updated_at?: Date;
  /** Video watch progress as percentage (0-100) */
  video_progress?: number;
  /** Number of times the video has been watched */
  video_watch_count?: number;
}
export interface ClassPostScoresRow {
  class_post_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  /** Shows the facets of how the score has been calculated. For example, let&#x27;s say a metric is (views + comments), you may store it as score &#x3D; 42, dimension &#x3D; {
  &quot;viewMultiplier&quot;: 1,
  &quot;views&quot;: {
    &quot;2bdd0d81-5893-431b-8cad-0f689c8a2a75&quot;: 1,
    &quot;022df19b-2985-423d-afcf-2334705ccc7f&quot;: 1
  },
  &quot;commentMultiplier&quot;: 10,
  &quot;comments&quot;: {
    &quot;2bdd0d81-5893-431b-8cad-0f689c8a2a75&quot;: 2,
    &quot;022df19b-2985-423d-afcf-2334705ccc7f&quot;: 2
  }
} */
  dimensions: any;
  score: number;
  strategy: string;
  uid: string;
  updated_at: Date;
}
export interface CreateClassPostScoresRow {
  class_post_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Shows the facets of how the score has been calculated. For example, let&#x27;s say a metric is (views + comments), you may store it as score &#x3D; 42, dimension &#x3D; {
  &quot;viewMultiplier&quot;: 1,
  &quot;views&quot;: {
    &quot;2bdd0d81-5893-431b-8cad-0f689c8a2a75&quot;: 1,
    &quot;022df19b-2985-423d-afcf-2334705ccc7f&quot;: 1
  },
  &quot;commentMultiplier&quot;: 10,
  &quot;comments&quot;: {
    &quot;2bdd0d81-5893-431b-8cad-0f689c8a2a75&quot;: 2,
    &quot;022df19b-2985-423d-afcf-2334705ccc7f&quot;: 2
  }
} */
  dimensions?: any;
  score: number;
  strategy: string;
  uid?: string;
  updated_at?: Date;
}
export interface ClassPostsRow {
  audit_log: any | null;
  background_color: string | null;
  /** Type of content block (e.g., text, video) for the async layout. */
  block_type: string | null;
  content_safety_check_completed_at: Date | null;
  content_safety_check_failed_at: Date | null;
  created_at: Date | null;
  created_by_learner_uid: string | null;
  deleted_at: Date | null;
  /** Estimated time to complete this post in minutes. */
  estimated_duration: number | null;
  is_welcome_post: boolean;
  lesson_post_uid: string | null;
  lesson_uid: string | null;
  mentioned_enrollment_uids: string[] | null;
  message: any | null;
  message_content_uid: string;
  /** Position of this block within its section lesson on the live V2 classroom. Shares one sequence with learning_assignment_class_posts.order_in_lesson. Null outside live V2 lessons. */
  order_in_lesson: number | null;
  pinned_at: Date | null;
  promoted_at: Date | null;
  published_at: Date;
  section_uid: string;
  title: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string;
}
export interface CreateClassPostsRow {
  audit_log?: any | null;
  background_color?: string | null;
  /** Type of content block (e.g., text, video) for the async layout. */
  block_type?: string | null;
  content_safety_check_completed_at?: Date | null;
  content_safety_check_failed_at?: Date | null;
  created_at?: Date | null;
  created_by_learner_uid?: string | null;
  deleted_at?: Date | null;
  /** Estimated time to complete this post in minutes. */
  estimated_duration?: number | null;
  is_welcome_post?: boolean;
  lesson_post_uid?: string | null;
  lesson_uid?: string | null;
  mentioned_enrollment_uids?: string[] | null;
  message?: any | null;
  message_content_uid: string;
  /** Position of this block within its section lesson on the live V2 classroom. Shares one sequence with learning_assignment_class_posts.order_in_lesson. Null outside live V2 lessons. */
  order_in_lesson?: number | null;
  pinned_at?: Date | null;
  promoted_at?: Date | null;
  published_at?: Date;
  section_uid: string;
  title?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid: string;
}
export interface ClassRecordingInsightsRow {
  class_recording_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  details: any;
  educator_user_uid: string | null;
  learner_uid: string | null;
  /** Full explanation of the insight for parents/learners */
  long_summary: string;
  /** Short label for the insight */
  short_summary: string;
  thumbnail_attachment_uid: string | null;
  /** Insight category: &#x27;action_item&#x27; or &#x27;highlight&#x27; */
  type: string;
  uid: string;
  updated_at: Date;
  video_end_timestamp: string | null;
  video_start_timestamp: string | null;
}
export interface CreateClassRecordingInsightsRow {
  class_recording_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  details?: any;
  educator_user_uid?: string | null;
  learner_uid?: string | null;
  /** Full explanation of the insight for parents/learners */
  long_summary: string;
  /** Short label for the insight */
  short_summary: string;
  thumbnail_attachment_uid?: string | null;
  /** Insight category: &#x27;action_item&#x27; or &#x27;highlight&#x27; */
  type: string;
  uid?: string;
  updated_at?: Date;
  video_end_timestamp?: string | null;
  video_start_timestamp?: string | null;
}
export interface ClassRecordingsRow {
  created_at: Date;
  deleted_at: Date | null;
  duration: number | null;
  /** Progress of different kinds of insights generation processes. Key the value by insight type. */
  insights_progress: any | null;
  is_mux_video_ready: boolean;
  meeting_uid: string | null;
  mux_asset_id: string | null;
  mux_attempts: number;
  mux_errored_at: Date | null;
  mux_playback_id: string | null;
  mux_ready_at: Date | null;
  mux_uploaded_at: Date | null;
  s3_audio_key: string | null;
  s3_bucket_name: string;
  s3_chat_key: string | null;
  s3_json_transcript_key: string | null;
  s3_transcript_key: string | null;
  s3_video_key: string | null;
  section_uid: string | null;
  start_time: Date | null;
  uid: string;
  updated_at: Date;
}
export interface CreateClassRecordingsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  duration?: number | null;
  /** Progress of different kinds of insights generation processes. Key the value by insight type. */
  insights_progress?: any | null;
  is_mux_video_ready?: boolean;
  meeting_uid?: string | null;
  mux_asset_id?: string | null;
  mux_attempts?: number;
  mux_errored_at?: Date | null;
  mux_playback_id?: string | null;
  mux_ready_at?: Date | null;
  mux_uploaded_at?: Date | null;
  s3_audio_key?: string | null;
  s3_bucket_name: string;
  s3_chat_key?: string | null;
  s3_json_transcript_key?: string | null;
  s3_transcript_key?: string | null;
  s3_video_key?: string | null;
  section_uid?: string | null;
  start_time?: Date | null;
  uid?: string;
  updated_at?: Date;
}
export interface ClassRequestsRow {
  age: number | null;
  approved_at: Date | null;
  content: string | null;
  created_at: Date | null;
  deleted_at: Date | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreateClassRequestsRow {
  age?: number | null;
  approved_at?: Date | null;
  content?: string | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface ClassScheduleRequestsRow {
  activity_uid: string;
  created_at: Date | null;
  deleted_at: Date | null;
  message: string | null;
  timetable: any | null;
  timeZone: string;
  uid: string;
  updated_at: Date | null;
  user_uid: string;
}
export interface CreateClassScheduleRequestsRow {
  activity_uid: string;
  created_at?: Date | null;
  deleted_at?: Date | null;
  message?: string | null;
  timetable?: any | null;
  timeZone: string;
  uid?: string;
  updated_at?: Date | null;
  user_uid: string;
}
export interface ClubAttributesRow {
  activity_uid: string;
  club_preview_content: any;
  created_at: Date;
  deleted_at: Date | null;
  uid: string;
  updated_at: Date;
}
export interface CreateClubAttributesRow {
  activity_uid: string;
  club_preview_content: any;
  created_at?: Date;
  deleted_at?: Date | null;
  uid?: string;
  updated_at?: Date;
}
export interface CouponActivityConstraintsRow {
  activity_uid: string;
  coupon_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  uid: string;
  updated_at: Date;
}
export interface CreateCouponActivityConstraintsRow {
  activity_uid: string;
  coupon_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  uid?: string;
  updated_at?: Date;
}
export interface CouponCodesRow {
  code: string;
  coupon_uid: string;
  created_at: Date;
  created_by: string;
  deleted_at: Date | null;
  expires_at: Date | null;
  max_uses: number | null;
  uid: string;
  updated_at: Date;
  user_uid: string | null;
}
export interface CreateCouponCodesRow {
  code: string;
  coupon_uid: string;
  created_at?: Date;
  created_by: string;
  deleted_at?: Date | null;
  expires_at?: Date | null;
  max_uses?: number | null;
  uid?: string;
  updated_at?: Date;
  user_uid?: string | null;
}
export interface CouponsRow {
  class_formats_allowed: string[] | null;
  coupon_type: string;
  created_at: Date;
  created_by: string;
  deleted_at: Date | null;
  description: string | null;
  expires_at: Date | null;
  is_buyer_first_purchase_of_class_format_only: boolean;
  is_first_purchase_only: boolean;
  max_amount_cents_per_use: number | null;
  max_uses: number | null;
  max_uses_per_user: number;
  /** Minimum purchase amount in cents required to use this coupon */
  min_purchase_amount_cents: number | null;
  name: string;
  percent_off: number | null;
  starts_at: Date | null;
  subjects_allowed: string[] | null;
  uid: string;
  updated_at: Date;
}
export interface CreateCouponsRow {
  class_formats_allowed?: string[] | null;
  coupon_type: string;
  created_at?: Date;
  created_by: string;
  deleted_at?: Date | null;
  description?: string | null;
  expires_at?: Date | null;
  is_buyer_first_purchase_of_class_format_only?: boolean;
  is_first_purchase_only?: boolean;
  max_amount_cents_per_use?: number | null;
  max_uses?: number | null;
  max_uses_per_user?: number;
  /** Minimum purchase amount in cents required to use this coupon */
  min_purchase_amount_cents?: number | null;
  name: string;
  percent_off?: number | null;
  starts_at?: Date | null;
  subjects_allowed?: string[] | null;
  uid?: string;
  updated_at?: Date;
}
/** An account of credits belonging to a user from a specific funding source which they can spend on purchases */
export interface CreditAccountsRow {
  /** Source of the credits. *os_cash*: miscellaneous one-offs, like referral bonuses. Unique by user_uid. *subscription*: from a Stripe subscription (subscriptions). Unique by user_uid + subscription_credit_value. *esa_subscription*: from an ESA membership (esa_memberships). Unique by learner_uid + subscription_credit_value. */
  account_type: string;
  /** The current balance in USD cents (excludes pending transactions) */
  balance: number;
  created_at: Date;
  deleted_at: Date | null;
  /** Generalized learner funding program row that owns this wallet when account_type is esa_membership */
  learner_funding_program_uid: string | null;
  /** Learner that the credit account is restricted to (e.g. for ESA funds) */
  learner_uid: string | null;
  /** The balance that is safe to spend in USD cents (includes pending transactions) */
  open_to_buy: number;
  /** The conversion rate from actual USD price to credits within this account (in cents per credit). This must be immutable for accounting to track discounts correctly, so a new account must be created if this ever changes */
  subscription_credit_value: number | null;
  uid: string;
  updated_at: Date;
  /** User the account belongs to */
  user_uid: string | null;
}
export interface CreateCreditAccountsRow {
  /** Source of the credits. *os_cash*: miscellaneous one-offs, like referral bonuses. Unique by user_uid. *subscription*: from a Stripe subscription (subscriptions). Unique by user_uid + subscription_credit_value. *esa_subscription*: from an ESA membership (esa_memberships). Unique by learner_uid + subscription_credit_value. */
  account_type?: string;
  /** The current balance in USD cents (excludes pending transactions) */
  balance?: number;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Generalized learner funding program row that owns this wallet when account_type is esa_membership */
  learner_funding_program_uid?: string | null;
  /** Learner that the credit account is restricted to (e.g. for ESA funds) */
  learner_uid?: string | null;
  /** The balance that is safe to spend in USD cents (includes pending transactions) */
  open_to_buy?: number;
  /** The conversion rate from actual USD price to credits within this account (in cents per credit). This must be immutable for accounting to track discounts correctly, so a new account must be created if this ever changes */
  subscription_credit_value?: number | null;
  uid?: string;
  updated_at?: Date;
  /** User the account belongs to */
  user_uid?: string | null;
}
export interface CreditPurchaseRefundsRow {
  amount_cents: number;
  amount_in_local_currency: number;
  created_at: Date;
  credit_purchase_uid: string;
  credit_transaction_uid: string | null;
  currency_code: string;
  deleted_at: Date | null;
  exchange_rate: number;
  note: string | null;
  reason: string;
  refunded_at: Date;
  stripe_refund_id: string | null;
  uid: string;
  updated_at: Date;
  user_role: string;
  user_uid: string;
  voucher_name: string | null;
}
export interface CreateCreditPurchaseRefundsRow {
  amount_cents: number;
  amount_in_local_currency: number;
  created_at?: Date;
  credit_purchase_uid: string;
  credit_transaction_uid?: string | null;
  currency_code: string;
  deleted_at?: Date | null;
  exchange_rate: number;
  note?: string | null;
  reason: string;
  refunded_at: Date;
  stripe_refund_id?: string | null;
  uid?: string;
  updated_at?: Date;
  user_role: string;
  user_uid: string;
  voucher_name?: string | null;
}
export interface CreditPurchasesRow {
  amount_cents: number;
  amount_granted_cents: number;
  canceled_at: Date | null;
  confirmed_at: Date | null;
  created_at: Date;
  credit_account_uid: string;
  deleted_at: Date | null;
  deposit_credit_transaction_uid: string | null;
  /** Funding framing captured at order creation. true: ESA wallet-dollar, false: legacy credit. */
  is_wallet_funding: boolean;
  order_slug_id: string;
  uid: string;
  updated_at: Date;
  voucher_name: string | null;
}
export interface CreateCreditPurchasesRow {
  amount_cents: number;
  amount_granted_cents: number;
  canceled_at?: Date | null;
  confirmed_at?: Date | null;
  created_at?: Date;
  credit_account_uid: string;
  deleted_at?: Date | null;
  deposit_credit_transaction_uid?: string | null;
  /** Funding framing captured at order creation. true: ESA wallet-dollar, false: legacy credit. */
  is_wallet_funding?: boolean;
  order_slug_id: string;
  uid?: string;
  updated_at?: Date;
  voucher_name?: string | null;
}
/** Change in balance of a credit account */
export interface CreditTransactionsRow {
  admin_note: string | null;
  /** The amount added to (positive) or removed from (negative) the account */
  amount_cents: number;
  canceled_at: Date | null;
  captured_at: Date | null;
  created_at: Date;
  credit_account_uid: string;
  deleted_at: Date | null;
  expires_at: Date | null;
  order_slug_id: string | null;
  /** Stripe invoice id (in_...) for membership/credit purchases. */
  stripe_invoice_id: string | null;
  /** Reason the balance changed. Common types include... *purchase*: using credit to buy something *redemption*: adding credit from a gift card *admin* / *voucher*: added manually by an outschool admin *refund*: user chose to be refunded in OS credit *deposit*: users can purchase credit *referral*: we reward referrals with credit *expiration*: when another credit expires, the account is debited these transactions */
  transaction_type: string;
  uid: string;
  updated_at: Date;
}
export interface CreateCreditTransactionsRow {
  admin_note?: string | null;
  /** The amount added to (positive) or removed from (negative) the account */
  amount_cents: number;
  canceled_at?: Date | null;
  captured_at?: Date | null;
  created_at?: Date;
  credit_account_uid: string;
  deleted_at?: Date | null;
  expires_at?: Date | null;
  order_slug_id?: string | null;
  /** Stripe invoice id (in_...) for membership/credit purchases. */
  stripe_invoice_id?: string | null;
  /** Reason the balance changed. Common types include... *purchase*: using credit to buy something *redemption*: adding credit from a gift card *admin* / *voucher*: added manually by an outschool admin *refund*: user chose to be refunded in OS credit *deposit*: users can purchase credit *referral*: we reward referrals with credit *expiration*: when another credit expires, the account is debited these transactions */
  transaction_type: string;
  uid?: string;
  updated_at?: Date;
}
export interface CurrencyExchangeRatesRow {
  created_at: Date;
  currency_code: string;
  deleted_at: Date | null;
  exchange_rate: number;
  uid: string;
  updated_at: Date;
}
export interface CreateCurrencyExchangeRatesRow {
  created_at?: Date;
  currency_code: string;
  deleted_at?: Date | null;
  exchange_rate: number;
  uid?: string;
  updated_at?: Date;
}
export interface DeletionLogRow {
  /** Explains the action that was taken on the entity. Scrubbed &#x3D; data has been scrubbed, but the row itself is preserved in order to satisfy table relationship constraints. Hard-deleted &#x3D; row has been completed deleted from database. Reverted &#x3D; the data was previously deleted or scrubbed but now has been re-added to the state it was previously in. Incomplete-soft-deleted &#x3D; row has been soft deleted but not all of the data has gone through rigorous scrubbing process. This action indicates this row may need to be revisited in order to properly be scrubbed or hard-deleted. */
  action: string;
  created_at: Date;
  /** References the name of the database table being hard deleted or scrubbed */
  entity_table: string;
  /** References the uid of the row being hard deleted or scrubbed */
  entity_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateDeletionLogRow {
  /** Explains the action that was taken on the entity. Scrubbed &#x3D; data has been scrubbed, but the row itself is preserved in order to satisfy table relationship constraints. Hard-deleted &#x3D; row has been completed deleted from database. Reverted &#x3D; the data was previously deleted or scrubbed but now has been re-added to the state it was previously in. Incomplete-soft-deleted &#x3D; row has been soft deleted but not all of the data has gone through rigorous scrubbing process. This action indicates this row may need to be revisited in order to properly be scrubbed or hard-deleted. */
  action: string;
  created_at?: Date;
  /** References the name of the database table being hard deleted or scrubbed */
  entity_table: string;
  /** References the uid of the row being hard deleted or scrubbed */
  entity_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface DimEducatorUsersRow {
  educator_user_id: string;
  is_in_good_standing: boolean | null;
  is_new_on_outschool: boolean | null;
  is_popular: boolean | null;
  is_rising_star: boolean | null;
  is_star: boolean | null;
  updated_at: Date;
}
export interface CreateDimEducatorUsersRow {
  educator_user_id: string;
  is_in_good_standing?: boolean | null;
  is_new_on_outschool?: boolean | null;
  is_popular?: boolean | null;
  is_rising_star?: boolean | null;
  is_star?: boolean | null;
  updated_at?: Date;
}
export interface DirectoryMembershipRow {
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string;
  organization_uid: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateDirectoryMembershipRow {
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid: string;
  organization_uid?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface DonationsRow {
  amount_cents: number;
  confirmed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  order_slug_id: string;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateDonationsRow {
  amount_cents: number;
  confirmed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  order_slug_id: string;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
/** Teacher the funding program approved when a ClassWallet order was placed. Settlement records this teacher on the payments instead of rechecking. */
export interface EnrollmentClassWalletFundingLeadersRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Enrollment the ClassWallet order funds */
  enrollment_uid: string;
  /** Teacher the funding program approved at order time */
  leader_uid: string;
  /** ClassWallet order that was placed */
  order_slug_id: string;
  uid: string;
  updated_at: Date;
}
export interface CreateEnrollmentClassWalletFundingLeadersRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Enrollment the ClassWallet order funds */
  enrollment_uid: string;
  /** Teacher the funding program approved at order time */
  leader_uid: string;
  /** ClassWallet order that was placed */
  order_slug_id: string;
  uid?: string;
  updated_at?: Date;
}
export interface EnrollmentMeetingPurchasesRow {
  activity_uid: string | null;
  /** Used for the 1-on-1 migration to indicate whether associated meetings can be cancelled or rescheduled. */
  can_parent_update: boolean;
  confirmed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  end_time: Date;
  enrollment_uid: string | null;
  funding_program: string | null;
  meeting_uid: string | null;
  order_slug_id: string;
  org_teacher_uid: string | null;
  start_time: Date;
  uid: string;
  updated_at: Date;
}
export interface CreateEnrollmentMeetingPurchasesRow {
  activity_uid?: string | null;
  /** Used for the 1-on-1 migration to indicate whether associated meetings can be cancelled or rescheduled. */
  can_parent_update?: boolean;
  confirmed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  end_time: Date;
  enrollment_uid?: string | null;
  funding_program?: string | null;
  meeting_uid?: string | null;
  order_slug_id: string;
  org_teacher_uid?: string | null;
  start_time: Date;
  uid?: string;
  updated_at?: Date;
}
export interface EnrollmentPauseWindowsRow {
  created_at: Date;
  deleted_at: Date | null;
  enrollment_uid: string;
  pause_reason: string;
  uid: string;
  unpaused_at: Date | null;
  updated_at: Date;
  window_end: Date;
  window_start: Date;
}
export interface CreateEnrollmentPauseWindowsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  enrollment_uid: string;
  pause_reason: string;
  uid?: string;
  unpaused_at?: Date | null;
  updated_at?: Date;
  window_end: Date;
  window_start: Date;
}
export interface EnrollmentPaymentRefundsRow {
  amount_cents: number;
  amount_in_local_currency: number;
  created_at: Date;
  credit_transaction_uid: string | null;
  currency_code: string;
  deleted_at: Date | null;
  enrollment_payment_uid: string;
  exchange_rate: number;
  note: string | null;
  reason: string | null;
  reduces_teacher_payout: boolean;
  refunded_at: Date;
  stripe_refund_id: string | null;
  uid: string;
  updated_at: Date;
  user_role: string;
  user_uid: string;
  voucher_name: string | null;
}
export interface CreateEnrollmentPaymentRefundsRow {
  amount_cents?: number;
  amount_in_local_currency: number;
  created_at?: Date;
  credit_transaction_uid?: string | null;
  currency_code: string;
  deleted_at?: Date | null;
  enrollment_payment_uid: string;
  exchange_rate: number;
  note?: string | null;
  reason?: string | null;
  reduces_teacher_payout?: boolean;
  refunded_at: Date;
  stripe_refund_id?: string | null;
  uid?: string;
  updated_at?: Date;
  user_role: string;
  user_uid: string;
  voucher_name?: string | null;
}
export interface EnrollmentPaymentsRow {
  amount_cents: number;
  amount_in_local_currency: number | null;
  captured_at: Date | null;
  charter_school_uid: string | null;
  confirmed_at: Date | null;
  coupon_code_uid: string | null;
  created_at: Date;
  credit_transaction_uid: string | null;
  currency_code: string;
  deleted_at: Date | null;
  details: any | null;
  disbursed_at: Date | null;
  disbursed_cents: number | null;
  end_time: Date | null;
  enrollment_meeting_purchase_uid: string | null;
  enrollment_uid: string;
  esa_order_id: string | null;
  exchange_rate: number;
  /** Teacher the funding program approved when this funded payment was made. Null when the teacher was not approved, such as a substitute. */
  funding_leader_uid: string | null;
  funding_program_invoice_uid: string | null;
  intercom_url: string | null;
  invoice_uid: string | null;
  last4: string | null;
  order_slug_id: string | null;
  organization_uid: string | null;
  paid_at: Date;
  payout_uid: string | null;
  pricing_offer_uid: string | null;
  purchase_order_id: string | null;
  service_fee_percentage: number;
  start_time: Date | null;
  stripe_charge_id: string | null;
  uid: string;
  updated_at: Date;
  user_uid: string | null;
  voucher_name: string | null;
}
export interface CreateEnrollmentPaymentsRow {
  amount_cents?: number;
  amount_in_local_currency?: number | null;
  captured_at?: Date | null;
  charter_school_uid?: string | null;
  confirmed_at?: Date | null;
  coupon_code_uid?: string | null;
  created_at?: Date;
  credit_transaction_uid?: string | null;
  currency_code: string;
  deleted_at?: Date | null;
  details?: any | null;
  disbursed_at?: Date | null;
  disbursed_cents?: number | null;
  end_time?: Date | null;
  enrollment_meeting_purchase_uid?: string | null;
  enrollment_uid: string;
  esa_order_id?: string | null;
  exchange_rate: number;
  /** Teacher the funding program approved when this funded payment was made. Null when the teacher was not approved, such as a substitute. */
  funding_leader_uid?: string | null;
  funding_program_invoice_uid?: string | null;
  intercom_url?: string | null;
  invoice_uid?: string | null;
  last4?: string | null;
  order_slug_id?: string | null;
  organization_uid?: string | null;
  paid_at: Date;
  payout_uid?: string | null;
  pricing_offer_uid?: string | null;
  purchase_order_id?: string | null;
  service_fee_percentage?: number;
  start_time?: Date | null;
  stripe_charge_id?: string | null;
  uid?: string;
  updated_at?: Date;
  user_uid?: string | null;
  voucher_name?: string | null;
}
export interface EnrollmentsRow {
  accept_gift_slug_id: string | null;
  amount_in_local_currency: number;
  attribution: any | null;
  charter_school_uid: string | null;
  confirmed_at: Date | null;
  created_at: Date;
  currency_code: string;
  deleted_at: Date | null;
  details: any | null;
  exchange_rate: number;
  gift_claimed_at: Date | null;
  is_late: boolean;
  learner_uid: string | null;
  ongoing_end_time: Date | null;
  ongoing_start_time: Date | null;
  ongoing_stopped_at: Date | null;
  order_slug_id: string | null;
  organization_uid: string | null;
  pause_window_uid: string | null;
  payment_schedule_uid: string | null;
  price_cents: number;
  pricing_offer: string | null;
  pricing_offer_uid: string | null;
  purchased_as_gift: boolean;
  purchased_by_user_uid: string;
  recording_for_clubs_verification_approved_at: Date | null;
  recording_for_clubs_verification_flagged_at: Date | null;
  recording_for_clubs_verification_rejected_at: Date | null;
  recording_for_clubs_verification_uid: string | null;
  refund_policy_type: refund_policy;
  section_uid: string | null;
  service_fee_percentage: number;
  stripe_payment_intent_id: string | null;
  uid: string;
  updated_at: Date;
  user_uid: string | null;
  withdrawn_at: Date | null;
}
export interface CreateEnrollmentsRow {
  accept_gift_slug_id?: string | null;
  amount_in_local_currency: number;
  attribution?: any | null;
  charter_school_uid?: string | null;
  confirmed_at?: Date | null;
  created_at?: Date;
  currency_code: string;
  deleted_at?: Date | null;
  details?: any | null;
  exchange_rate: number;
  gift_claimed_at?: Date | null;
  is_late?: boolean;
  learner_uid?: string | null;
  ongoing_end_time?: Date | null;
  ongoing_start_time?: Date | null;
  ongoing_stopped_at?: Date | null;
  order_slug_id?: string | null;
  organization_uid?: string | null;
  pause_window_uid?: string | null;
  payment_schedule_uid?: string | null;
  price_cents?: number;
  pricing_offer?: string | null;
  pricing_offer_uid?: string | null;
  purchased_as_gift?: boolean;
  purchased_by_user_uid: string;
  recording_for_clubs_verification_approved_at?: Date | null;
  recording_for_clubs_verification_flagged_at?: Date | null;
  recording_for_clubs_verification_rejected_at?: Date | null;
  recording_for_clubs_verification_uid?: string | null;
  refund_policy_type?: refund_policy;
  section_uid?: string | null;
  service_fee_percentage?: number;
  stripe_payment_intent_id?: string | null;
  uid?: string;
  updated_at?: Date;
  user_uid?: string | null;
  withdrawn_at?: Date | null;
}
/** A dynamically-defined property using the Entity-Attribute-Value pattern. Used for flexible tagging and reverse ETL data */
export interface EntityAttributesRow {
  created_at: Date;
  deleted_at: Date | null;
  entity_type: string;
  entity_uid: string;
  key: string;
  source: string | null;
  uid: string;
  updated_at: Date;
  value: string;
}
export interface CreateEntityAttributesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  entity_type: string;
  entity_uid: string;
  key: string;
  source?: string | null;
  uid?: string;
  updated_at?: Date;
  value: string;
}
export interface EntityAvailabilitiesRow {
  created_at: Date;
  day: number;
  deleted_at: Date | null;
  end_hour: number;
  end_minute: number;
  entity_availability_schedule_uid: string;
  start_hour: number;
  start_minute: number;
  uid: string;
  updated_at: Date;
}
export interface CreateEntityAvailabilitiesRow {
  created_at?: Date;
  day: number;
  deleted_at?: Date | null;
  end_hour: number;
  end_minute: number;
  entity_availability_schedule_uid: string;
  start_hour: number;
  start_minute: number;
  uid?: string;
  updated_at?: Date;
}
export interface EntityAvailabilitySchedulesRow {
  created_at: Date;
  deleted_at: Date | null;
  entity_type: string;
  entity_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateEntityAvailabilitySchedulesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  entity_type: string;
  entity_uid: string;
  uid?: string;
  updated_at?: Date;
}
/** A membership funded by an ESA program */
export interface EsaMembershipsRow {
  attribution: any | null;
  canceled_at: Date | null;
  confirmed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  /** Program with jurisdiction over the funds (e.g. two-letter code for a US state program) */
  funding_program: string;
  inactive_starting_at: Date | null;
  /** Generalized learner funding program row that backs this ESA membership */
  learner_funding_program_uid: string | null;
  learner_uid: string;
  organization_uid: string | null;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateEsaMembershipsRow {
  attribution?: any | null;
  canceled_at?: Date | null;
  confirmed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Program with jurisdiction over the funds (e.g. two-letter code for a US state program) */
  funding_program: string;
  inactive_starting_at?: Date | null;
  /** Generalized learner funding program row that backs this ESA membership */
  learner_funding_program_uid?: string | null;
  learner_uid: string;
  organization_uid?: string | null;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface ExperimentOverridesRow {
  created_at: Date;
  deleted_at: Date | null;
  experiment_uid: string;
  randomization_unit_id: string;
  uid: string;
  updated_at: Date;
  variant: string;
}
export interface CreateExperimentOverridesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  experiment_uid: string;
  randomization_unit_id: string;
  uid?: string;
  updated_at?: Date;
  variant: string;
}
export interface ExperimentsRow {
  analytics_dashboard_url: string | null;
  audit_log: any;
  created_at: Date;
  deleted_at: Date | null;
  experiment_doc_url: string | null;
  exposure_pct: number;
  name: string;
  ownership_team: string | null;
  product_area: string | null;
  randomization_unit: string;
  release_variant: string | null;
  status: string;
  uid: string;
  updated_at: Date;
  variants: string[];
}
export interface CreateExperimentsRow {
  analytics_dashboard_url?: string | null;
  audit_log: any;
  created_at?: Date;
  deleted_at?: Date | null;
  experiment_doc_url?: string | null;
  exposure_pct: number;
  name: string;
  ownership_team?: string | null;
  product_area?: string | null;
  randomization_unit: string;
  release_variant?: string | null;
  status?: string;
  uid?: string;
  updated_at?: Date;
  variants: string[];
}
export interface ExternalActivitiesRow {
  created_at: Date;
  external_activity_id: string;
  post: Object | null;
  source: string;
  status: string;
  uid: string;
  updated_at: Date | null;
  user_uid: string;
}
export interface CreateExternalActivitiesRow {
  created_at?: Date;
  external_activity_id: string;
  post?: Object | null;
  source: string;
  status: string;
  uid?: string;
  updated_at?: Date | null;
  user_uid: string;
}
export interface ExternalResourcePoliciesRow {
  category: string | null;
  created_at: Date;
  deleted_at: Date | null;
  name: string;
  policy_type: string;
  uid: string;
  updated_at: Date;
  urls: string[];
}
export interface CreateExternalResourcePoliciesRow {
  category?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  name: string;
  policy_type: string;
  uid?: string;
  updated_at?: Date;
  urls: string[];
}
export interface FacebookUsersRow {
  access_token: string | null;
  created_at: Date | null;
  deleted_at: Date | null;
  email: string | null;
  facebook_id: string | null;
  learner_uid: string | null;
  profile: any | null;
  refresh_token: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreateFacebookUsersRow {
  access_token?: string | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  email?: string | null;
  facebook_id?: string | null;
  learner_uid?: string | null;
  profile?: any | null;
  refresh_token?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface FailedContentSecurityChecksRow {
  attachment_uid: string | null;
  comprehend_response: any | null;
  content_source_table: string;
  content_source_uid: string;
  content_type: string;
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string | null;
  marked_safe_manually_at: Date | null;
  moderator_id: string | null;
  rejected_manually_at: Date | null;
  rejection_severity: string | null;
  review_started_at: Date | null;
  static_check_response: any | null;
  twohat_content_id: string;
  twohat_response: any | null;
  uid: string;
  updated_at: Date;
  user_uid: string | null;
}
export interface CreateFailedContentSecurityChecksRow {
  attachment_uid?: string | null;
  comprehend_response?: any | null;
  content_source_table: string;
  content_source_uid: string;
  content_type: string;
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid?: string | null;
  marked_safe_manually_at?: Date | null;
  moderator_id?: string | null;
  rejected_manually_at?: Date | null;
  rejection_severity?: string | null;
  review_started_at?: Date | null;
  static_check_response?: any | null;
  twohat_content_id: string;
  twohat_response?: any | null;
  uid?: string;
  updated_at?: Date;
  user_uid?: string | null;
}
export interface FailedInboundMessagesRow {
  created_at: Date | null;
  error: any | null;
  from_email: string;
  message: any | null;
  uid: string;
}
export interface CreateFailedInboundMessagesRow {
  created_at?: Date | null;
  error?: any | null;
  from_email: string;
  message?: any | null;
  uid?: string;
}
export interface FailedOutboundMessagesRow {
  created_at: Date | null;
  deleted_at: Date | null;
  error: any | null;
  message: any | null;
  retried_at: Date | null;
  retry_count: number | null;
  sent_at: Date | null;
  to_emails: string[] | null;
  uid: string;
  updated_at: Date | null;
}
export interface CreateFailedOutboundMessagesRow {
  created_at?: Date | null;
  deleted_at?: Date | null;
  error?: any | null;
  message?: any | null;
  retried_at?: Date | null;
  retry_count?: number | null;
  sent_at?: Date | null;
  to_emails?: string[] | null;
  uid?: string;
  updated_at?: Date | null;
}
export interface FeedbackRow {
  activity_rating: number | null;
  activity_star_rating: number | null;
  attachment_uids: string[] | null;
  attribution: any | null;
  can_promote: boolean;
  created_at: Date | null;
  deleted_at: Date | null;
  details: any | null;
  outschool_rating: number | null;
  section_uid: string | null;
  teacher_responded_at: Date | null;
  teacher_response: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreateFeedbackRow {
  activity_rating?: number | null;
  activity_star_rating?: number | null;
  attachment_uids?: string[] | null;
  attribution?: any | null;
  can_promote?: boolean;
  created_at?: Date | null;
  deleted_at?: Date | null;
  details?: any | null;
  outschool_rating?: number | null;
  section_uid?: string | null;
  teacher_responded_at?: Date | null;
  teacher_response?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface FeedbackVotesRow {
  attribution: any | null;
  created_at: Date | null;
  deleted_at: Date | null;
  feedback_uid: string | null;
  referer: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreateFeedbackVotesRow {
  attribution?: any | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  feedback_uid?: string | null;
  referer?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface FilestackMetadataRow {
  created_at: Date;
  deleted_at: Date | null;
  handle: string | null;
  os_s3_path: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateFilestackMetadataRow {
  created_at?: Date;
  deleted_at?: Date | null;
  handle?: string | null;
  os_s3_path?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface FilestackMigrationAttachmentsRow {
  attachment_uid: string;
  batch_id: string | null;
  batch_size: number | null;
  created_at: Date;
  deleted_at: Date | null;
  new_file: any | null;
  old_file: any | null;
  status: string;
  status_updated_at: Date | null;
  uid: string;
  updated_at: Date;
}
export interface CreateFilestackMigrationAttachmentsRow {
  attachment_uid: string;
  batch_id?: string | null;
  batch_size?: number | null;
  created_at?: Date;
  deleted_at?: Date | null;
  new_file?: any | null;
  old_file?: any | null;
  status?: string;
  status_updated_at?: Date | null;
  uid?: string;
  updated_at?: Date;
}
export interface FilestackMigrationUsersRow {
  batch_id: string | null;
  batch_size: number | null;
  created_at: Date;
  deleted_at: Date | null;
  new_photo: string | null;
  old_photo: string | null;
  status: string;
  status_updated_at: Date | null;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateFilestackMigrationUsersRow {
  batch_id?: string | null;
  batch_size?: number | null;
  created_at?: Date;
  deleted_at?: Date | null;
  new_photo?: string | null;
  old_photo?: string | null;
  status?: string;
  status_updated_at?: Date | null;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface FollowedUsersRow {
  attribution: any | null;
  created_at: Date | null;
  deleted_at: Date | null;
  followed_uid: string | null;
  follower_uid: string | null;
  referer: string | null;
  uid: string;
  updated_at: Date | null;
}
export interface CreateFollowedUsersRow {
  attribution?: any | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  followed_uid?: string | null;
  follower_uid?: string | null;
  referer?: string | null;
  uid?: string;
  updated_at?: Date | null;
}
export interface FriendRequestsRow {
  approved_at: Date | null;
  created_at: Date | null;
  from_user_uid: string | null;
  referer: string | null;
  to_email: string | null;
  to_user_uid: string | null;
  uid: string;
  updated_at: Date | null;
}
export interface CreateFriendRequestsRow {
  approved_at?: Date | null;
  created_at?: Date | null;
  from_user_uid?: string | null;
  referer?: string | null;
  to_email?: string | null;
  to_user_uid?: string | null;
  uid?: string;
  updated_at?: Date | null;
}
export interface FriendshipsRow {
  created_at: Date | null;
  uid: string;
  updated_at: Date | null;
  user1_uid: string | null;
  user2_uid: string | null;
}
export interface CreateFriendshipsRow {
  created_at?: Date | null;
  uid?: string;
  updated_at?: Date | null;
  user1_uid?: string | null;
  user2_uid?: string | null;
}
export interface FundingProgramInvoicesRow {
  award_id: string;
  child_name: string;
  created_at: Date;
  deleted_at: Date | null;
  funding_program: string | null;
  order_slug_id: string;
  parent_name: string;
  rejected_at: Date | null;
  uid: string;
  updated_at: Date;
}
export interface CreateFundingProgramInvoicesRow {
  award_id: string;
  child_name: string;
  created_at?: Date;
  deleted_at?: Date | null;
  funding_program?: string | null;
  order_slug_id: string;
  parent_name: string;
  rejected_at?: Date | null;
  uid?: string;
  updated_at?: Date;
}
export interface FundingProgramVersionsRow {
  /** Institution identifier from ClassWallet */
  class_wallet_institution: string | null;
  created_at: Date;
  /** Error message if the CSV catalog generation job failed */
  csv_catalog_job_error: string | null;
  /** Number of activities evaluated so far in the catalog job */
  csv_catalog_job_processed_activities: number | null;
  /** Status of the CSV catalog generation job: pending, processing, completed, failed */
  csv_catalog_job_status: string | null;
  /** Last time the CSV catalog job status changed */
  csv_catalog_job_status_updated_at: Date | null;
  /** Total number of activities to evaluate in the catalog job */
  csv_catalog_job_total_activities: number | null;
  /** S3 object key for the most recently generated catalog CSV */
  csv_catalog_s3_key: string | null;
  deleted_at: Date | null;
  /** Reference to the parent funding program */
  funding_program_uid: string;
  /** US state code if applicable */
  funding_state: string | null;
  /** Path for the program landing page (e.g., &#x27;/online-classes/utah-esa&#x27;) */
  landing_page_path: string | null;
  /** ClassWallet, EMA, Odyssey, etc. */
  marketplace: string;
  /** Free text for admin notes about this version */
  notes: string | null;
  /** Optional end date for the program */
  program_end_date: Date | null;
  /** URL for the funding source application page */
  program_funding_source_url: string | null;
  /** Short program name (e.g., &#x27;Arizona ESA&#x27;) */
  program_name: string;
  /** Program abbreviation (e.g., &#x27;ESA&#x27;) */
  program_name_abbr: string;
  /** Full program name (e.g., &#x27;Empowerment Scholarship Account&#x27;) */
  program_name_long: string;
  /** External URL for program information */
  program_url: string | null;
  /** Error message if the entity attribute publish job failed */
  publish_job_error: string | null;
  /** Number of activities evaluated so far in the publish job */
  publish_job_processed_activities: number | null;
  /** Status of the entity attribute publish job: pending, processing, completed, failed */
  publish_job_status: string | null;
  /** Last time the publish job status changed */
  publish_job_status_updated_at: Date | null;
  /** Total number of activities to evaluate in the publish job */
  publish_job_total_activities: number | null;
  /** JSONB catalog rules configuration */
  rule: any;
  /** Schema version for the rule JSON structure */
  rule_schema_version: number;
  /** Version status: draft, published, or archived */
  status: string;
  uid: string;
  updated_at: Date;
  /** Booking window in days before class starts */
  wait_period_days: number | null;
}
export interface CreateFundingProgramVersionsRow {
  /** Institution identifier from ClassWallet */
  class_wallet_institution?: string | null;
  created_at?: Date;
  /** Error message if the CSV catalog generation job failed */
  csv_catalog_job_error?: string | null;
  /** Number of activities evaluated so far in the catalog job */
  csv_catalog_job_processed_activities?: number | null;
  /** Status of the CSV catalog generation job: pending, processing, completed, failed */
  csv_catalog_job_status?: string | null;
  /** Last time the CSV catalog job status changed */
  csv_catalog_job_status_updated_at?: Date | null;
  /** Total number of activities to evaluate in the catalog job */
  csv_catalog_job_total_activities?: number | null;
  /** S3 object key for the most recently generated catalog CSV */
  csv_catalog_s3_key?: string | null;
  deleted_at?: Date | null;
  /** Reference to the parent funding program */
  funding_program_uid: string;
  /** US state code if applicable */
  funding_state?: string | null;
  /** Path for the program landing page (e.g., &#x27;/online-classes/utah-esa&#x27;) */
  landing_page_path?: string | null;
  /** ClassWallet, EMA, Odyssey, etc. */
  marketplace: string;
  /** Free text for admin notes about this version */
  notes?: string | null;
  /** Optional end date for the program */
  program_end_date?: Date | null;
  /** URL for the funding source application page */
  program_funding_source_url?: string | null;
  /** Short program name (e.g., &#x27;Arizona ESA&#x27;) */
  program_name: string;
  /** Program abbreviation (e.g., &#x27;ESA&#x27;) */
  program_name_abbr: string;
  /** Full program name (e.g., &#x27;Empowerment Scholarship Account&#x27;) */
  program_name_long: string;
  /** External URL for program information */
  program_url?: string | null;
  /** Error message if the entity attribute publish job failed */
  publish_job_error?: string | null;
  /** Number of activities evaluated so far in the publish job */
  publish_job_processed_activities?: number | null;
  /** Status of the entity attribute publish job: pending, processing, completed, failed */
  publish_job_status?: string | null;
  /** Last time the publish job status changed */
  publish_job_status_updated_at?: Date | null;
  /** Total number of activities to evaluate in the publish job */
  publish_job_total_activities?: number | null;
  /** JSONB catalog rules configuration */
  rule: any;
  /** Schema version for the rule JSON structure */
  rule_schema_version?: number;
  /** Version status: draft, published, or archived */
  status?: string;
  uid?: string;
  updated_at?: Date;
  /** Booking window in days before class starts */
  wait_period_days?: number | null;
}
export interface FundingProgramsRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Unique program identifier (e.g., &#x27;TX&#x27;, &#x27;NC&#x27;, &#x27;AZ&#x27;), used in search filtering */
  slug: string;
  uid: string;
  updated_at: Date;
  /** Feature flag: when true, use DB rules; when false, use code-based rules */
  use_db_rules: boolean;
}
export interface CreateFundingProgramsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Unique program identifier (e.g., &#x27;TX&#x27;, &#x27;NC&#x27;, &#x27;AZ&#x27;), used in search filtering */
  slug: string;
  uid?: string;
  updated_at?: Date;
  /** Feature flag: when true, use DB rules; when false, use code-based rules */
  use_db_rules?: boolean;
}
export interface GiftCardsRow {
  amount_cents: number;
  audit_log: any | null;
  confirmed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  deliver_after: Date;
  delivered_at: Date | null;
  delivery_timezone: string;
  note: string | null;
  order_slug_id: string;
  purchaser_email: string;
  purchaser_name: string;
  recipient_email: string | null;
  recipient_name: string;
  redeemed_at: Date | null;
  redeemer_uid: string | null;
  redemption_code: string;
  redemption_credit_transaction_uid: string | null;
  uid: string;
  updated_at: Date;
  user_uid: string | null;
}
export interface CreateGiftCardsRow {
  amount_cents: number;
  audit_log?: any | null;
  confirmed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  deliver_after?: Date;
  delivered_at?: Date | null;
  delivery_timezone?: string;
  note?: string | null;
  order_slug_id: string;
  purchaser_email: string;
  purchaser_name: string;
  recipient_email?: string | null;
  recipient_name?: string;
  redeemed_at?: Date | null;
  redeemer_uid?: string | null;
  redemption_code: string;
  redemption_credit_transaction_uid?: string | null;
  uid?: string;
  updated_at?: Date;
  user_uid?: string | null;
}
export interface GoogleUsersRow {
  access_token: string | null;
  created_at: Date;
  deleted_at: Date | null;
  email: string | null;
  google_id: string | null;
  id_token: string | null;
  learner_uid: string | null;
  profile: any | null;
  refresh_token: string | null;
  uid: string;
  updated_at: Date;
  user_uid: string | null;
}
export interface CreateGoogleUsersRow {
  access_token?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  email?: string | null;
  google_id?: string | null;
  id_token?: string | null;
  learner_uid?: string | null;
  profile?: any | null;
  refresh_token?: string | null;
  uid?: string;
  updated_at?: Date;
  user_uid?: string | null;
}
/** Canonical documents that support Guided catalog funding eligibility decisions */
export interface GuidedCatalogEligibilityDocumentsRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Document type: state_policy, vendor_attestation, approved_list, program_handbook, or manual_review */
  document_type: guided_catalog_eligibility_document_type;
  /** Time after which this document should not be treated as current */
  expires_at: Date | null;
  /** Organization that issued the document */
  issuer: string | null;
  /** Most recent time this document was fetched or verified */
  retrieved_at: Date;
  /** Display title for the supporting document */
  title: string;
  uid: string;
  updated_at: Date;
  /** URL for the supporting document */
  url: string;
}
export interface CreateGuidedCatalogEligibilityDocumentsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Document type: state_policy, vendor_attestation, approved_list, program_handbook, or manual_review */
  document_type: guided_catalog_eligibility_document_type;
  /** Time after which this document should not be treated as current */
  expires_at?: Date | null;
  /** Organization that issued the document */
  issuer?: string | null;
  /** Most recent time this document was fetched or verified */
  retrieved_at: Date;
  /** Display title for the supporting document */
  title: string;
  uid?: string;
  updated_at?: Date;
  /** URL for the supporting document */
  url: string;
}
/** Links a Guided catalog eligibility decision to a supporting document */
export interface GuidedCatalogEligibilityEvidenceRow {
  /** Optional excerpt or section reference for this document */
  citation_note: string | null;
  created_at: Date;
  deleted_at: Date | null;
  /** Supporting document linked to the eligibility decision */
  document_uid: string;
  /** Listing eligibility decision that cites this document */
  guided_catalog_listing_funding_eligibility_uid: string | null;
  /** Vendor eligibility decision that cites this document */
  guided_catalog_vendor_funding_eligibility_uid: string | null;
  /** Display order of this document on the eligibility decision */
  sort_order: number;
  uid: string;
  updated_at: Date;
}
export interface CreateGuidedCatalogEligibilityEvidenceRow {
  /** Optional excerpt or section reference for this document */
  citation_note?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Supporting document linked to the eligibility decision */
  document_uid: string;
  /** Listing eligibility decision that cites this document */
  guided_catalog_listing_funding_eligibility_uid?: string | null;
  /** Vendor eligibility decision that cites this document */
  guided_catalog_vendor_funding_eligibility_uid?: string | null;
  /** Display order of this document on the eligibility decision */
  sort_order?: number;
  uid?: string;
  updated_at?: Date;
}
/** Links a Guided catalog funding rule set to a supporting document */
export interface GuidedCatalogFundingRuleSetEvidenceRow {
  /** Optional excerpt or section reference for this document */
  citation_note: string | null;
  created_at: Date;
  deleted_at: Date | null;
  /** Supporting document linked to the funding rule set */
  document_uid: string;
  /** Funding rule set that cites this document */
  rule_set_uid: string;
  /** Display order of this document on the funding rule set */
  sort_order: number;
  uid: string;
  updated_at: Date;
}
export interface CreateGuidedCatalogFundingRuleSetEvidenceRow {
  /** Optional excerpt or section reference for this document */
  citation_note?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Supporting document linked to the funding rule set */
  document_uid: string;
  /** Funding rule set that cites this document */
  rule_set_uid: string;
  /** Display order of this document on the funding rule set */
  sort_order?: number;
  uid?: string;
  updated_at?: Date;
}
/** Versioned Guided catalog eligibility rules for a funding program */
export interface GuidedCatalogFundingRuleSetsRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Funding program these eligibility rules apply to */
  funding_program_uid: string;
  /** Optional funding program version these eligibility rules were authored against */
  funding_program_version_uid: string | null;
  /** Internal notes about this rule set */
  notes: string | null;
  /** Eligibility status written when rules pass; v1 allows only likely */
  outcome_status: guided_catalog_eligibility_status;
  /** JSON rule configuration evaluated by the eligibility engine */
  rule: any;
  /** Schema version of the rule JSON document */
  rule_schema_version: number;
  /** Publication status: draft, published, or archived */
  status: guided_catalog_funding_rule_set_status;
  uid: string;
  updated_at: Date;
}
export interface CreateGuidedCatalogFundingRuleSetsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Funding program these eligibility rules apply to */
  funding_program_uid: string;
  /** Optional funding program version these eligibility rules were authored against */
  funding_program_version_uid?: string | null;
  /** Internal notes about this rule set */
  notes?: string | null;
  /** Eligibility status written when rules pass; v1 allows only likely */
  outcome_status?: guided_catalog_eligibility_status;
  /** JSON rule configuration evaluated by the eligibility engine */
  rule: any;
  /** Schema version of the rule JSON document */
  rule_schema_version?: number;
  /** Publication status: draft, published, or archived */
  status?: guided_catalog_funding_rule_set_status;
  uid?: string;
  updated_at?: Date;
}
/** One row per Guided catalog ingestion run, recording its outcome and provenance */
export interface GuidedCatalogIngestionRunsRow {
  created_at: Date;
  /** Listings deactivated as unseen by this completed run */
  deactivated_listing_count: number | null;
  /** Why the disappearance sweep was skipped */
  deactivation_skipped_reason: string | null;
  deleted_at: Date | null;
  /** Items this run failed to process */
  error_count: number;
  /** Error message counts plus a bounded sample of error details for this run */
  error_summary: any;
  /** Item count the run expected to see, used to decide whether its coverage is plausible enough to act on */
  expected_item_count: number | null;
  /** Why the run failed; null unless status is failed */
  failure_reason: string | null;
  /** Per-field completeness for the items this run persisted, keyed by column name, as a fraction in [0, 1] where 0.94 means 94% */
  field_completeness: any;
  /** Time the run stopped, whether it completed or failed */
  finished_at: Date | null;
  /** Method this run used: scrape_web, remote_csv_file, vendor_api, or manual */
  ingestion_method: guided_catalog_ingestion_method;
  /** Whether the run discarded its results instead of writing listings */
  is_dry_run: boolean;
  /** Items this run transformed and persisted successfully */
  ok_count: number;
  /** S3 key for this run&#x27;s full per-item skip and error report; null when no report was written */
  report_s3_key: string | null;
  /** Operator who requested the run; null for scheduled runs. Retained so a scrape of a partner site is attributable after the fact */
  requested_by_user_uid: string | null;
  /** Items this run deliberately skipped with a reason */
  skip_count: number;
  /** How many items this run skipped, keyed by skip reason. A reason climbing between runs is the signal that a vendor changed their page structure */
  skip_reason_counts: any;
  /** Time the run began processing; null while queued */
  started_at: Date | null;
  /** Run status: queued, running, completed, or failed */
  status: guided_catalog_ingestion_run_status;
  /** Whether the run was started on a schedule or by an operator */
  trigger_source: guided_catalog_ingestion_trigger_source;
  uid: string;
  updated_at: Date;
  /** Code registry slug for the vendor this run ingested */
  vendor_slug: string;
}
export interface CreateGuidedCatalogIngestionRunsRow {
  created_at?: Date;
  /** Listings deactivated as unseen by this completed run */
  deactivated_listing_count?: number | null;
  /** Why the disappearance sweep was skipped */
  deactivation_skipped_reason?: string | null;
  deleted_at?: Date | null;
  /** Items this run failed to process */
  error_count?: number;
  /** Error message counts plus a bounded sample of error details for this run */
  error_summary?: any;
  /** Item count the run expected to see, used to decide whether its coverage is plausible enough to act on */
  expected_item_count?: number | null;
  /** Why the run failed; null unless status is failed */
  failure_reason?: string | null;
  /** Per-field completeness for the items this run persisted, keyed by column name, as a fraction in [0, 1] where 0.94 means 94% */
  field_completeness?: any;
  /** Time the run stopped, whether it completed or failed */
  finished_at?: Date | null;
  /** Method this run used: scrape_web, remote_csv_file, vendor_api, or manual */
  ingestion_method: guided_catalog_ingestion_method;
  /** Whether the run discarded its results instead of writing listings */
  is_dry_run?: boolean;
  /** Items this run transformed and persisted successfully */
  ok_count?: number;
  /** S3 key for this run&#x27;s full per-item skip and error report; null when no report was written */
  report_s3_key?: string | null;
  /** Operator who requested the run; null for scheduled runs. Retained so a scrape of a partner site is attributable after the fact */
  requested_by_user_uid?: string | null;
  /** Items this run deliberately skipped with a reason */
  skip_count?: number;
  /** How many items this run skipped, keyed by skip reason. A reason climbing between runs is the signal that a vendor changed their page structure */
  skip_reason_counts?: any;
  /** Time the run began processing; null while queued */
  started_at?: Date | null;
  /** Run status: queued, running, completed, or failed */
  status?: guided_catalog_ingestion_run_status;
  /** Whether the run was started on a schedule or by an operator */
  trigger_source: guided_catalog_ingestion_trigger_source;
  uid?: string;
  updated_at?: Date;
  /** Code registry slug for the vendor this run ingested */
  vendor_slug: string;
}
/** Funding eligibility evidence for a Guided catalog listing and funding program */
export interface GuidedCatalogListingFundingEligibilitiesRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Supporting document objects with URL, title, and retrieval time */
  documents: any;
  /** Evidence source: rules_engine, vendor_attestation, manual_review, or document_supported */
  eligibility_source: guided_catalog_eligibility_source | null;
  /** Eligibility status: guaranteed, likely, partial, unknown, or ineligible */
  eligibility_status: guided_catalog_eligibility_status;
  /** Most recent time an automated writer evaluated this row */
  evaluated_at: Date | null;
  /** When true, the rules engine materializer must not overwrite this eligibility row */
  evaluation_locked: boolean;
  /** Funding program used for the eligibility evaluation */
  funding_program_uid: string;
  /** Funding program version used when a rules engine wrote this eligibility row */
  funding_program_version_uid: string | null;
  /** Guided catalog listing evaluated for funding eligibility */
  guided_catalog_listing_uid: string;
  /** Explanation of the eligibility status */
  justification: string | null;
  /** Funding rule set that produced this rules_engine decision and supplies its evidence */
  rule_set_uid: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateGuidedCatalogListingFundingEligibilitiesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Supporting document objects with URL, title, and retrieval time */
  documents?: any;
  /** Evidence source: rules_engine, vendor_attestation, manual_review, or document_supported */
  eligibility_source?: guided_catalog_eligibility_source | null;
  /** Eligibility status: guaranteed, likely, partial, unknown, or ineligible */
  eligibility_status: guided_catalog_eligibility_status;
  /** Most recent time an automated writer evaluated this row */
  evaluated_at?: Date | null;
  /** When true, the rules engine materializer must not overwrite this eligibility row */
  evaluation_locked?: boolean;
  /** Funding program used for the eligibility evaluation */
  funding_program_uid: string;
  /** Funding program version used when a rules engine wrote this eligibility row */
  funding_program_version_uid?: string | null;
  /** Guided catalog listing evaluated for funding eligibility */
  guided_catalog_listing_uid: string;
  /** Explanation of the eligibility status */
  justification?: string | null;
  /** Funding rule set that produced this rules_engine decision and supplies its evidence */
  rule_set_uid?: string | null;
  uid?: string;
  updated_at?: Date;
}
/** Normalized third-party listings available in Guided */
export interface GuidedCatalogListingsRow {
  /** Maximum recommended learner age */
  age_max: number | null;
  /** Minimum recommended learner age */
  age_min: number | null;
  /** Average vendor rating on a zero-to-five scale */
  average_rating: string | null;
  /** Maximum participant capacity for a class listing */
  capacity_max: number | null;
  /** Minimum participant capacity for a class listing */
  capacity_min: number | null;
  /** Hash of normalized source data used to skip unchanged listings */
  content_hash: string;
  created_at: Date;
  deleted_at: Date | null;
  /** Delivery formats: live_online, live_in_person, self_paced_online, or physical_shipment */
  delivery_formats: guided_catalog_delivery_format[];
  /** Listing description supplied by the vendor */
  description: string;
  /** Maximum grade ordinal: preschool -2, pre-kindergarten -1, kindergarten 0, and numbered grades 1 through 12 */
  grade_max: number | null;
  /** Minimum grade ordinal: preschool -2, pre-kindergarten -1, kindergarten 0, and numbered grades 1 through 12 */
  grade_min: number | null;
  /** Normalized Guided subject slugs assigned during ingestion */
  guided_subjects: string[];
  /** Method used to ingest this listing: scrape_web, remote_csv_file, vendor_api, or manual */
  ingestion_method: guided_catalog_ingestion_method;
  /** Ingestion run that most recently wrote this listing; null for listings entered through the admin UI */
  ingestion_run_uid: string | null;
  /** Whether Guided can show this listing */
  is_active: boolean;
  /** Whether the vendor currently offers this listing as available */
  is_available: boolean;
  /** BCP 47 language tag for the listing */
  language: string | null;
  /** Most recent time that ingestion processed this listing */
  last_ingested_at: Date;
  /** Most recent time that ingestion observed this listing */
  last_seen_at: Date;
  /** Normalized learning-need slugs from the registry managed in code */
  learning_needs: string[];
  /** Source image URLs supplied by the vendor */
  media_urls: string[];
  /** Exact price or range minimum in the smallest currency unit; zero when free and null when unpriced or unknown */
  price_cents: number | null;
  /** Vendor price text shown when preferred or not fully normalized */
  price_display_text: string | null;
  /** Range maximum in the smallest currency unit; null for exact prices and unpriced listings */
  price_max_cents: number | null;
  /** Price model: fixed, per_unit, or subscription */
  price_model: guided_catalog_price_model | null;
  /** Unit for a per-unit price: session, hour, item, or learner */
  price_unit: guided_catalog_price_unit | null;
  /** Vendor-supplied product subtypes that add detail beyond product_type */
  product_subtypes: string[];
  /** Product type: class, community, curriculum_resource, or classroom_supply */
  product_type: guided_catalog_product_type;
  /** Number of ratings included in the average */
  rating_count: number | null;
  /** Vendor or other source that supplied the rating */
  rating_source: string | null;
  /** Raw vendor payload retained for ingestion debugging */
  raw_payload: any;
  /** Original listing title supplied by the vendor */
  raw_title: string;
  /** Billing interval for a subscription: day, week, month, or year */
  subscription_interval: guided_catalog_subscription_interval | null;
  /** Listing title cleaned for display by Guided */
  title: string;
  uid: string;
  updated_at: Date;
  /** Stable listing identifier assigned by the vendor */
  vendor_side_uid: string;
  /** Code registry slug for the vendor that owns this listing */
  vendor_slug: string;
  /** Original topic labels supplied by the vendor */
  vendor_topics: string[];
  /** URL for the listing on the vendor site */
  vendor_url: string;
}
export interface CreateGuidedCatalogListingsRow {
  /** Maximum recommended learner age */
  age_max?: number | null;
  /** Minimum recommended learner age */
  age_min?: number | null;
  /** Average vendor rating on a zero-to-five scale */
  average_rating?: string | null;
  /** Maximum participant capacity for a class listing */
  capacity_max?: number | null;
  /** Minimum participant capacity for a class listing */
  capacity_min?: number | null;
  /** Hash of normalized source data used to skip unchanged listings */
  content_hash: string;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Delivery formats: live_online, live_in_person, self_paced_online, or physical_shipment */
  delivery_formats?: guided_catalog_delivery_format[];
  /** Listing description supplied by the vendor */
  description: string;
  /** Maximum grade ordinal: preschool -2, pre-kindergarten -1, kindergarten 0, and numbered grades 1 through 12 */
  grade_max?: number | null;
  /** Minimum grade ordinal: preschool -2, pre-kindergarten -1, kindergarten 0, and numbered grades 1 through 12 */
  grade_min?: number | null;
  /** Normalized Guided subject slugs assigned during ingestion */
  guided_subjects?: string[];
  /** Method used to ingest this listing: scrape_web, remote_csv_file, vendor_api, or manual */
  ingestion_method: guided_catalog_ingestion_method;
  /** Ingestion run that most recently wrote this listing; null for listings entered through the admin UI */
  ingestion_run_uid?: string | null;
  /** Whether Guided can show this listing */
  is_active?: boolean;
  /** Whether the vendor currently offers this listing as available */
  is_available?: boolean;
  /** BCP 47 language tag for the listing */
  language?: string | null;
  /** Most recent time that ingestion processed this listing */
  last_ingested_at: Date;
  /** Most recent time that ingestion observed this listing */
  last_seen_at: Date;
  /** Normalized learning-need slugs from the registry managed in code */
  learning_needs?: string[];
  /** Source image URLs supplied by the vendor */
  media_urls?: string[];
  /** Exact price or range minimum in the smallest currency unit; zero when free and null when unpriced or unknown */
  price_cents?: number | null;
  /** Vendor price text shown when preferred or not fully normalized */
  price_display_text?: string | null;
  /** Range maximum in the smallest currency unit; null for exact prices and unpriced listings */
  price_max_cents?: number | null;
  /** Price model: fixed, per_unit, or subscription */
  price_model?: guided_catalog_price_model | null;
  /** Unit for a per-unit price: session, hour, item, or learner */
  price_unit?: guided_catalog_price_unit | null;
  /** Vendor-supplied product subtypes that add detail beyond product_type */
  product_subtypes?: string[];
  /** Product type: class, community, curriculum_resource, or classroom_supply */
  product_type: guided_catalog_product_type;
  /** Number of ratings included in the average */
  rating_count?: number | null;
  /** Vendor or other source that supplied the rating */
  rating_source?: string | null;
  /** Raw vendor payload retained for ingestion debugging */
  raw_payload: any;
  /** Original listing title supplied by the vendor */
  raw_title: string;
  /** Billing interval for a subscription: day, week, month, or year */
  subscription_interval?: guided_catalog_subscription_interval | null;
  /** Listing title cleaned for display by Guided */
  title: string;
  uid?: string;
  updated_at?: Date;
  /** Stable listing identifier assigned by the vendor */
  vendor_side_uid: string;
  /** Code registry slug for the vendor that owns this listing */
  vendor_slug: string;
  /** Original topic labels supplied by the vendor */
  vendor_topics?: string[];
  /** URL for the listing on the vendor site */
  vendor_url: string;
}
/** Default funding eligibility for all Guided catalog listings from a vendor and funding program */
export interface GuidedCatalogVendorFundingEligibilitiesRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Evidence source: rules_engine, vendor_attestation, manual_review, or document_supported */
  eligibility_source: guided_catalog_eligibility_source | null;
  /** Eligibility status: guaranteed, likely, partial, unknown, or ineligible */
  eligibility_status: guided_catalog_eligibility_status;
  /** Most recent time an automated writer evaluated this row */
  evaluated_at: Date | null;
  /** Funding program used for the vendor default eligibility */
  funding_program_uid: string;
  /** Funding program version used when a rules engine wrote this eligibility row */
  funding_program_version_uid: string | null;
  /** Explanation of the eligibility status */
  justification: string | null;
  uid: string;
  updated_at: Date;
  /** Vendor slug whose listings inherit this default eligibility */
  vendor_slug: string;
}
export interface CreateGuidedCatalogVendorFundingEligibilitiesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Evidence source: rules_engine, vendor_attestation, manual_review, or document_supported */
  eligibility_source?: guided_catalog_eligibility_source | null;
  /** Eligibility status: guaranteed, likely, partial, unknown, or ineligible */
  eligibility_status: guided_catalog_eligibility_status;
  /** Most recent time an automated writer evaluated this row */
  evaluated_at?: Date | null;
  /** Funding program used for the vendor default eligibility */
  funding_program_uid: string;
  /** Funding program version used when a rules engine wrote this eligibility row */
  funding_program_version_uid?: string | null;
  /** Explanation of the eligibility status */
  justification?: string | null;
  uid?: string;
  updated_at?: Date;
  /** Vendor slug whose listings inherit this default eligibility */
  vendor_slug: string;
}
/** Whether a Guided catalog vendor is permitted to sell into a funding program */
export interface GuidedCatalogVendorProgramPermitsRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Funding program the vendor may or may not sell into */
  funding_program_uid: string;
  /** Explanation of why the vendor is or is not permitted */
  justification: string | null;
  /** True when the vendor is allowed to sell into the funding program */
  permitted: boolean;
  uid: string;
  updated_at: Date;
  /** Vendor slug gated for the funding program */
  vendor_slug: string;
}
export interface CreateGuidedCatalogVendorProgramPermitsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Funding program the vendor may or may not sell into */
  funding_program_uid: string;
  /** Explanation of why the vendor is or is not permitted */
  justification?: string | null;
  /** True when the vendor is allowed to sell into the funding program */
  permitted: boolean;
  uid?: string;
  updated_at?: Date;
  /** Vendor slug gated for the funding program */
  vendor_slug: string;
}
/** Registry of Guided catalog listing vendors (slug identity + display metadata) */
export interface GuidedCatalogVendorsRow {
  /** Maximum recommended learner age in years */
  age_max: number | null;
  /** Minimum recommended learner age in years */
  age_min: number | null;
  /** Catalog categories for directory filtering, e.g. {curriculum}. Empty means not in the public catalog categories filter. */
  catalog_categories: string[];
  created_at: Date;
  deleted_at: Date | null;
  /** Delivery formats: live_online, live_in_person, self_paced_online, or physical_shipment. Empty means unset. */
  delivery_formats: guided_catalog_delivery_format[];
  /** Optional vendor description for Guided vendor display cards */
  description: string | null;
  /** Free-form public profile description of vendor format */
  format: string | null;
  /** When true, a free tier is available. Null means unknown. */
  free_tier: boolean | null;
  /** Maximum grade ordinal: preschool -2, pre-kindergarten -1, kindergarten 0, and numbered grades 1 through 12 */
  grade_max: number | null;
  /** Minimum grade ordinal: preschool -2, pre-kindergarten -1, kindergarten 0, and numbered grades 1 through 12 */
  grade_min: number | null;
  /** When true, vendor may appear in the public vendor catalog (independent of listings/search). */
  is_catalog_published: boolean;
  /** S3 object key in outschool-filestack-general for the vendor logo (no bucket prefix) */
  logo_s3_path: string | null;
  /** Human-readable vendor name for display */
  name: string;
  /** Pedagogical approaches. See guided_catalog_pedagogy for valid cases. Empty means unset. */
  pedagogy: guided_catalog_pedagogy[];
  /** Display-only pricing string for the public vendor profile */
  pricing: string | null;
  /** Product types offered by the vendor: class, community, curriculum_resource, or classroom_supply. Empty means unset. */
  product_types: guided_catalog_product_type[];
  /** Optional vendor-specific catalog profile fields (logo URL, service areas, grades, specialties, provenance, etc.). Sparse per vendor. */
  profile_metadata: any;
  /** Kebab-case vendor identity; matches listing vendor_slug / GuidedListingVendorCode */
  slug: string;
  /** When true, vendor focuses on special needs. Null means unknown. */
  special_needs_focus: boolean | null;
  /** Free-form target audience description */
  target_audience: string | null;
  uid: string;
  updated_at: Date;
  /** Optional vendor homepage or catalog URL for Guided vendor display cards */
  url: string | null;
  /** Free-form audience or use-case positioning, e.g. dyslexia intervention */
  use_case: string | null;
}
export interface CreateGuidedCatalogVendorsRow {
  /** Maximum recommended learner age in years */
  age_max?: number | null;
  /** Minimum recommended learner age in years */
  age_min?: number | null;
  /** Catalog categories for directory filtering, e.g. {curriculum}. Empty means not in the public catalog categories filter. */
  catalog_categories?: string[];
  created_at?: Date;
  deleted_at?: Date | null;
  /** Delivery formats: live_online, live_in_person, self_paced_online, or physical_shipment. Empty means unset. */
  delivery_formats?: guided_catalog_delivery_format[];
  /** Optional vendor description for Guided vendor display cards */
  description?: string | null;
  /** Free-form public profile description of vendor format */
  format?: string | null;
  /** When true, a free tier is available. Null means unknown. */
  free_tier?: boolean | null;
  /** Maximum grade ordinal: preschool -2, pre-kindergarten -1, kindergarten 0, and numbered grades 1 through 12 */
  grade_max?: number | null;
  /** Minimum grade ordinal: preschool -2, pre-kindergarten -1, kindergarten 0, and numbered grades 1 through 12 */
  grade_min?: number | null;
  /** When true, vendor may appear in the public vendor catalog (independent of listings/search). */
  is_catalog_published?: boolean;
  /** S3 object key in outschool-filestack-general for the vendor logo (no bucket prefix) */
  logo_s3_path?: string | null;
  /** Human-readable vendor name for display */
  name: string;
  /** Pedagogical approaches. See guided_catalog_pedagogy for valid cases. Empty means unset. */
  pedagogy?: guided_catalog_pedagogy[];
  /** Display-only pricing string for the public vendor profile */
  pricing?: string | null;
  /** Product types offered by the vendor: class, community, curriculum_resource, or classroom_supply. Empty means unset. */
  product_types?: guided_catalog_product_type[];
  /** Optional vendor-specific catalog profile fields (logo URL, service areas, grades, specialties, provenance, etc.). Sparse per vendor. */
  profile_metadata?: any;
  /** Kebab-case vendor identity; matches listing vendor_slug / GuidedListingVendorCode */
  slug: string;
  /** When true, vendor focuses on special needs. Null means unknown. */
  special_needs_focus?: boolean | null;
  /** Free-form target audience description */
  target_audience?: string | null;
  uid?: string;
  updated_at?: Date;
  /** Optional vendor homepage or catalog URL for Guided vendor display cards */
  url?: string | null;
  /** Free-form audience or use-case positioning, e.g. dyslexia intervention */
  use_case?: string | null;
}
/** Email addresses that should receive emails about a guided plan */
export interface GuidedPlanEmailsRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Email address to contact about the guided plan */
  email: string;
  /** Guided plan that this email address is attached to */
  guided_plan_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateGuidedPlanEmailsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Email address to contact about the guided plan */
  email: string;
  /** Guided plan that this email address is attached to */
  guided_plan_uid: string;
  uid?: string;
  updated_at?: Date;
}
/** Saved provider results within a guided plan slot */
export interface GuidedPlanSearchResultsRow {
  /** Guided aggregator insertion id that produced this saved search result */
  aggregator_insertion_id: string | null;
  created_at: Date;
  deleted_at: Date | null;
  /** Guided plan slot that this saved search result belongs to */
  guided_plan_slot_uid: string;
  /** Guided search provider that returned this result */
  provider_key: string;
  /** Provider-owned class identifier for this result */
  provider_side_class_uuid: string;
  /** Display order for the saved result within its guided plan slot */
  result_rank: number;
  /** Title of the class */
  title: string;
  uid: string;
  updated_at: Date;
}
export interface CreateGuidedPlanSearchResultsRow {
  /** Guided aggregator insertion id that produced this saved search result */
  aggregator_insertion_id?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Guided plan slot that this saved search result belongs to */
  guided_plan_slot_uid: string;
  /** Guided search provider that returned this result */
  provider_key: string;
  /** Provider-owned class identifier for this result */
  provider_side_class_uuid: string;
  /** Display order for the saved result within its guided plan slot */
  result_rank?: number;
  /** Title of the class */
  title: string;
  uid?: string;
  updated_at?: Date;
}
/** Search output slots within a guided plan */
export interface GuidedPlanSlotsRow {
  /** Guided aggregator request id that produced the saved results for this slot */
  aggregator_request_id: string | null;
  created_at: Date;
  deleted_at: Date | null;
  /** Per-slot search grade band (GraphQL GuidedLearnerGradeBand value) */
  grade: string;
  /** Guided plan that this output slot belongs to */
  guided_plan_uid: string;
  /** Top-level provider search query for this output slot */
  search_query: string;
  /** Display subject label for this output slot */
  subject: string;
  /** Resolved search interest terms for this slot, used to build search criteria */
  subject_interests: any;
  uid: string;
  updated_at: Date;
}
export interface CreateGuidedPlanSlotsRow {
  /** Guided aggregator request id that produced the saved results for this slot */
  aggregator_request_id?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Per-slot search grade band (GraphQL GuidedLearnerGradeBand value) */
  grade: string;
  /** Guided plan that this output slot belongs to */
  guided_plan_uid: string;
  /** Top-level provider search query for this output slot */
  search_query: string;
  /** Display subject label for this output slot */
  subject?: string;
  /** Resolved search interest terms for this slot, used to build search criteria */
  subject_interests?: any;
  uid?: string;
  updated_at?: Date;
}
/** Saved and shared guided plans generated from learner intake */
export interface GuidedPlansRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Learner grade band from GuidedLearnerGradeBand */
  grade: string;
  /** Learner support, challenge, and preference information used to generate the plan */
  learner_characteristics: any;
  /** Learner name supplied during guided plan intake */
  learner_name: string;
  /** Subject and topic interests used to generate the plan */
  subject_interests: any;
  uid: string;
  updated_at: Date;
  /** Shareable guided plan URL slug */
  url: string;
}
export interface CreateGuidedPlansRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Learner grade band from GuidedLearnerGradeBand */
  grade: string;
  /** Learner support, challenge, and preference information used to generate the plan */
  learner_characteristics?: any;
  /** Learner name supplied during guided plan intake */
  learner_name: string;
  /** Subject and topic interests used to generate the plan */
  subject_interests?: any;
  uid?: string;
  updated_at?: Date;
  /** Shareable guided plan URL slug */
  url: string;
}
/** Free-form user feedback submitted from Guided browse and related pages */
export interface GuidedUserFeedbacksRow {
  created_at: Date;
  /** Optional contact email supplied with the feedback */
  email: string | null;
  /** Free-form feedback body submitted by the user */
  feedback_text: string;
  /** Page path or URL where the user submitted the feedback */
  page_location: string;
  uid: string;
  /** User who submitted the feedback, if they were logged in; null otherwise */
  user_uid: string | null;
}
export interface CreateGuidedUserFeedbacksRow {
  created_at?: Date;
  /** Optional contact email supplied with the feedback */
  email?: string | null;
  /** Free-form feedback body submitted by the user */
  feedback_text: string;
  /** Page path or URL where the user submitted the feedback */
  page_location: string;
  uid?: string;
  /** User who submitted the feedback, if they were logged in; null otherwise */
  user_uid?: string | null;
}
export interface HolidaysRow {
  created_at: Date | null;
  day: Date;
  deleted_at: Date | null;
  name: string;
  uid: string;
}
export interface CreateHolidaysRow {
  created_at?: Date | null;
  day: Date;
  deleted_at?: Date | null;
  name: string;
  uid?: string;
}
export interface InvoicesRow {
  charter_school_uid: string | null;
  created_at: Date | null;
  deleted_at: Date | null;
  invoice_email: string | null;
  invoice_id: string | null;
  organization_uid: string | null;
  paypal_response: any | null;
  uid: string;
  updated_at: Date | null;
}
export interface CreateInvoicesRow {
  charter_school_uid?: string | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  invoice_email?: string | null;
  invoice_id?: string | null;
  organization_uid?: string | null;
  paypal_response?: any | null;
  uid?: string;
  updated_at?: Date | null;
}
export interface KnownSpamUsersRow {
  created_at: Date;
  deleted_at: Date | null;
  learner_emails: string[] | null;
  learner_names: string[] | null;
  name: string | null;
  uid: string;
  updated_at: Date;
  user_emails: string[] | null;
  user_uid: string;
}
export interface CreateKnownSpamUsersRow {
  created_at?: Date;
  deleted_at?: Date | null;
  learner_emails?: string[] | null;
  learner_names?: string[] | null;
  name?: string | null;
  uid?: string;
  updated_at?: Date;
  user_emails?: string[] | null;
  user_uid: string;
}
export interface LearnerAllowancePaymentsRow {
  amount_cents: number;
  canceled_at: Date | null;
  confirmed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  deposit_credit_transaction_uid: string | null;
  learner_allowance_uid: string;
  order_slug_id: string;
  payment_schedule_payment_uid: string | null;
  payment_type: string;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerAllowancePaymentsRow {
  amount_cents: number;
  canceled_at?: Date | null;
  confirmed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  deposit_credit_transaction_uid?: string | null;
  learner_allowance_uid: string;
  order_slug_id: string;
  payment_schedule_payment_uid?: string | null;
  payment_type: string;
  uid?: string;
  updated_at?: Date;
}
export interface LearnerAllowancesRow {
  audit_log: any;
  confirmed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string;
  payment_schedule_uid: string | null;
  stopped_at: Date | null;
  stopped_reason: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerAllowancesRow {
  audit_log: any;
  confirmed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid: string;
  payment_schedule_uid?: string | null;
  stopped_at?: Date | null;
  stopped_reason?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface LearnerAttributesRow {
  created_at: Date;
  deleted_at: Date | null;
  key: string;
  learner_uid: string;
  uid: string;
  updated_at: Date;
  value: string;
}
export interface CreateLearnerAttributesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  key: string;
  learner_uid: string;
  uid?: string;
  updated_at?: Date;
  value: string;
}
export interface LearnerAvatarsRow {
  /** The animals that were combined to create this avatar */
  animals: string[] | null;
  /** The attachment containing the avatar image */
  attachment_uid: string | null;
  created_at: Date;
  deleted_at: Date | null;
  /** Description of the avatar creature */
  description: string | null;
  /** The learner who owns this avatar */
  learner_uid: string;
  /** The name of the avatar */
  name: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerAvatarsRow {
  /** The animals that were combined to create this avatar */
  animals?: string[] | null;
  /** The attachment containing the avatar image */
  attachment_uid?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Description of the avatar creature */
  description?: string | null;
  /** The learner who owns this avatar */
  learner_uid: string;
  /** The name of the avatar */
  name?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface LearnerBehaviorReportsRow {
  blocked_learner_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  note: string | null;
  reason: string;
  reporting_user_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerBehaviorReportsRow {
  blocked_learner_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  note?: string | null;
  reason: string;
  reporting_user_uid: string;
  uid?: string;
  updated_at?: Date;
}
/** Mobile device info for sending push notifications */
export interface LearnerDevicesRow {
  app_version: string;
  created_at: Date;
  deleted_at: Date | null;
  device_id: string;
  device_token: string;
  last_seen_at: Date;
  learner_uid: string | null;
  os_version: string;
  platform: string;
  supported_notifications: string[];
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateLearnerDevicesRow {
  app_version: string;
  created_at?: Date;
  deleted_at?: Date | null;
  device_id: string;
  device_token: string;
  last_seen_at: Date;
  learner_uid?: string | null;
  os_version: string;
  platform: string;
  supported_notifications: string[];
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface LearnerEnrollmentRequestsRow {
  activity_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  enrollment_uid: string | null;
  learner_cancelled_at: Date | null;
  learner_uid: string;
  order_slug_id: string;
  parent_confirmed_at: Date | null;
  parent_denied_at: Date | null;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerEnrollmentRequestsRow {
  activity_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  enrollment_uid?: string | null;
  learner_cancelled_at?: Date | null;
  learner_uid: string;
  order_slug_id: string;
  parent_confirmed_at?: Date | null;
  parent_denied_at?: Date | null;
  uid?: string;
  updated_at?: Date;
}
/** Generalized learner-to-funding-program relationship used for personalization and wallet resolution */
export interface LearnerFundingProgramsRow {
  created_at: Date;
  /** When this learner funding program relationship became inactive */
  deactivated_at: Date | null;
  deleted_at: Date | null;
  /** Funding program referenced by this learner relationship */
  funding_program_uid: string;
  /** Learner associated with this funding program relationship */
  learner_uid: string;
  /** Arbitrary source and attribution details used to reconcile learner funding program state */
  metadata: any;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerFundingProgramsRow {
  created_at?: Date;
  /** When this learner funding program relationship became inactive */
  deactivated_at?: Date | null;
  deleted_at?: Date | null;
  /** Funding program referenced by this learner relationship */
  funding_program_uid: string;
  /** Learner associated with this funding program relationship */
  learner_uid: string;
  /** Arbitrary source and attribution details used to reconcile learner funding program state */
  metadata?: any;
  uid?: string;
  updated_at?: Date;
}
export interface LearnerInterestTopicsRow {
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string;
  topic_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerInterestTopicsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid: string;
  topic_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface LearnerInterfacePreferencesRow {
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string;
  name: string;
  uid: string;
  updated_at: Date;
  value: any;
}
export interface CreateLearnerInterfacePreferencesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid: string;
  name: string;
  uid?: string;
  updated_at?: Date;
  value: any;
}
export interface LearnerMeetingSummaryRow {
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string;
  meeting_uid: string;
  /** Number of times the learner talked in the meeting */
  talk_count: number;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerMeetingSummaryRow {
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid: string;
  meeting_uid: string;
  /** Number of times the learner talked in the meeting */
  talk_count?: number;
  uid?: string;
  updated_at?: Date;
}
export interface LearnerMixTopicsRow {
  /** Reference uid of attachments table, stores image URL */
  attachment_uid: string | null;
  created_at: Date;
  deleted_at: Date | null;
  /** The description of the mixed topic */
  description: string;
  /** Reference uid of learners table */
  learner_uid: string | null;
  /** Array of source topics, e.g. {art, music} */
  source_topics: string[];
  /** The title of the mixed topic */
  title: string;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerMixTopicsRow {
  /** Reference uid of attachments table, stores image URL */
  attachment_uid?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** The description of the mixed topic */
  description: string;
  /** Reference uid of learners table */
  learner_uid?: string | null;
  /** Array of source topics, e.g. {art, music} */
  source_topics: string[];
  /** The title of the mixed topic */
  title: string;
  uid?: string;
  updated_at?: Date;
}
/** Deprecated */
export interface LearnerPlanActivitiesRow {
  activity_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  is_pending: boolean;
  is_suggested: boolean | null;
  learner_plan_uid: string;
  meeting_duration_weeks: number | null;
  meeting_end_time: Date | null;
  meeting_start_time: Date | null;
  section_uid: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerPlanActivitiesRow {
  activity_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  is_pending?: boolean;
  is_suggested?: boolean | null;
  learner_plan_uid: string;
  meeting_duration_weeks?: number | null;
  meeting_end_time?: Date | null;
  meeting_start_time?: Date | null;
  section_uid?: string | null;
  uid?: string;
  updated_at?: Date;
}
/** Deprecated */
export interface LearnerPlanGoalFiltersRow {
  created_at: Date;
  deleted_at: Date | null;
  learner_plan_goal_uid: string;
  type: string;
  uid: string;
  updated_at: Date;
  value: string;
}
export interface CreateLearnerPlanGoalFiltersRow {
  created_at?: Date;
  deleted_at?: Date | null;
  learner_plan_goal_uid: string;
  type: string;
  uid?: string;
  updated_at?: Date;
  value: string;
}
/** Deprecated */
export interface LearnerPlanGoalsRow {
  created_at: Date;
  deleted_at: Date | null;
  learner_plan_activity_uid: string | null;
  learner_plan_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerPlanGoalsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  learner_plan_activity_uid?: string | null;
  learner_plan_uid: string;
  uid?: string;
  updated_at?: Date;
}
/** Deprecated */
export interface LearnerPlanRejectedSuggestionsRow {
  activity_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  learner_plan_goal_uid: string;
  learner_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerPlanRejectedSuggestionsRow {
  activity_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  learner_plan_goal_uid: string;
  learner_uid: string;
  uid?: string;
  updated_at?: Date;
}
/** Deprecated */
export interface LearnerPlansRow {
  created_at: Date;
  deleted_at: Date | null;
  end_date: Date | null;
  entity_availability_schedule_uid: string | null;
  learner_uid: string | null;
  name: string | null;
  start_date: Date | null;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateLearnerPlansRow {
  created_at?: Date;
  deleted_at?: Date | null;
  end_date?: Date | null;
  entity_availability_schedule_uid?: string | null;
  learner_uid?: string | null;
  name?: string | null;
  start_date?: Date | null;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface LearnerSearchGuardrailsRow {
  audit_log: any | null;
  created_at: Date;
  deleted_at: Date | null;
  delivery_type: string | null;
  learner_uid: string;
  max_duration_minutes: number | null;
  max_price_cents: number | null;
  outschool_hours: any | null;
  time_zone: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerSearchGuardrailsRow {
  audit_log?: any | null;
  created_at?: Date;
  deleted_at?: Date | null;
  delivery_type?: string | null;
  learner_uid: string;
  max_duration_minutes?: number | null;
  max_price_cents?: number | null;
  outschool_hours?: any | null;
  time_zone?: string | null;
  uid?: string;
  updated_at?: Date;
}
/** Documents a teacher sent about a learner for a section, such as progress reports, end-of-class grades, and certificates */
export interface LearnerSectionDocumentsRow {
  /** Files of the document. These are separate attachment rows from the message&#x27;s copies, so they are kept when expired messages are purged */
  attachment_uids: string[];
  /** Text of the document. Null when the document is files only */
  content: string | null;
  created_at: Date;
  /** Teacher who sent the document */
  created_by_user_uid: string;
  deleted_at: Date | null;
  /** One of &#x27;progress_report&#x27;, &#x27;final_grade&#x27;, or &#x27;certificate&#x27; */
  document_type: string;
  /** Learner the document is about */
  learner_uid: string;
  /** Message that sent the document to the parent */
  message_uid: string;
  /** Section the document belongs to */
  section_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerSectionDocumentsRow {
  /** Files of the document. These are separate attachment rows from the message&#x27;s copies, so they are kept when expired messages are purged */
  attachment_uids?: string[];
  /** Text of the document. Null when the document is files only */
  content?: string | null;
  created_at?: Date;
  /** Teacher who sent the document */
  created_by_user_uid: string;
  deleted_at?: Date | null;
  /** One of &#x27;progress_report&#x27;, &#x27;final_grade&#x27;, or &#x27;certificate&#x27; */
  document_type: string;
  /** Learner the document is about */
  learner_uid: string;
  /** Message that sent the document to the parent */
  message_uid: string;
  /** Section the document belongs to */
  section_uid: string;
  uid?: string;
  updated_at?: Date;
}
/** End-of-class grade a teacher gave a learner for a section. A learner gets one per section */
export interface LearnerSectionGradesRow {
  created_at: Date;
  deleted_at: Date | null;
  /** One of &#x27;letter&#x27;, &#x27;standards_based&#x27;, &#x27;percentage&#x27;, &#x27;pass_fail&#x27;, or &#x27;completion&#x27; */
  grade_type: string;
  /** Grade in the format of grade_type, such as &#x27;B&#x27;, &#x27;3&#x27;, &#x27;85&#x27;, &#x27;pass&#x27;, or &#x27;complete&#x27; */
  grade_value: string;
  /** Teacher who gave the grade */
  graded_by_user_uid: string;
  /** Learner who got the grade */
  learner_uid: string;
  /** Section the grade is for */
  section_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerSectionGradesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** One of &#x27;letter&#x27;, &#x27;standards_based&#x27;, &#x27;percentage&#x27;, &#x27;pass_fail&#x27;, or &#x27;completion&#x27; */
  grade_type: string;
  /** Grade in the format of grade_type, such as &#x27;B&#x27;, &#x27;3&#x27;, &#x27;85&#x27;, &#x27;pass&#x27;, or &#x27;complete&#x27; */
  grade_value: string;
  /** Teacher who gave the grade */
  graded_by_user_uid: string;
  /** Learner who got the grade */
  learner_uid: string;
  /** Section the grade is for */
  section_uid: string;
  uid?: string;
  updated_at?: Date;
}
/** Private notes a teacher writes about a learner for a section. Only the author can see them */
export interface LearnerSectionNotesRow {
  /** Text of the note */
  content: string;
  created_at: Date;
  /** Teacher who wrote the note */
  created_by_user_uid: string;
  deleted_at: Date | null;
  /** Learner the note is about */
  learner_uid: string;
  /** Section the note belongs to */
  section_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerSectionNotesRow {
  /** Text of the note */
  content: string;
  created_at?: Date;
  /** Teacher who wrote the note */
  created_by_user_uid: string;
  deleted_at?: Date | null;
  /** Learner the note is about */
  learner_uid: string;
  /** Section the note belongs to */
  section_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface LearnerSectionReviewsRow {
  attribution: any | null;
  created_at: Date;
  deleted_at: Date | null;
  enrollment_uid: string;
  name: string | null;
  response: any | null;
  uid: string;
  updated_at: Date;
}
export interface CreateLearnerSectionReviewsRow {
  attribution?: any | null;
  created_at?: Date;
  deleted_at?: Date | null;
  enrollment_uid: string;
  name?: string | null;
  response?: any | null;
  uid?: string;
  updated_at?: Date;
}
export interface LearnerUnlockablesRow {
  created_at: Date;
  deleted_at: Date | null;
  key: string;
  learner_uid: string;
  uid: string;
  updated_at: Date;
  value: any;
}
export interface CreateLearnerUnlockablesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  key: string;
  learner_uid: string;
  uid?: string;
  updated_at?: Date;
  value: any;
}
/** A student who attends classes on Outschool */
export interface LearnersRow {
  about_me: string | null;
  age: number | null;
  age_updated_at: Date | null;
  approved_for_clubs_at: Date | null;
  avatar: string | null;
  birth_year: number | null;
  content_safety_check_completed_at: Date | null;
  content_safety_check_failed_at: Date | null;
  created_at: Date | null;
  date_of_birth: Date | null;
  deleted_at: Date | null;
  derived_key: any | null;
  email: string | null;
  email_confirmation_token: string | null;
  email_confirmation_token_issued_at: Date | null;
  email_confirmed_at: Date | null;
  /** Consent to Outschool collecting and processing learner&#x27;s health data to provide personalized recommendations. */
  has_health_consent: boolean | null;
  /** Consent to seeing additional classes based on what the learner has favorited by sharing with third parties. */
  has_marketing_consent: boolean | null;
  intro: string | null;
  last_name: string | null;
  /** Whether the learner has been offered marketing consent options after logging in for the first time as a 13+ year old. This includes when a learner turns 13. */
  learner_has_been_offered_consent: boolean;
  login_enabled_at: Date | null;
  name: string | null;
  opted_out_of_personalized_recommendations_at: Date | null;
  /** The parent of the learner */
  parent_uid: string;
  password_reset_token: string | null;
  password_reset_token_issued_at: Date | null;
  profile_age_hidden_at: Date | null;
  profile_location_hidden_at: Date | null;
  pronoun: string | null;
  provisioned_for_organization_uid: string | null;
  race_ethnicity: string | null;
  salt: any | null;
  suspended_at: Date | null;
  suspended_reason: string | null;
  uid: string;
  updated_at: Date | null;
  username: string | null;
}
export interface CreateLearnersRow {
  about_me?: string | null;
  age?: number | null;
  age_updated_at?: Date | null;
  approved_for_clubs_at?: Date | null;
  avatar?: string | null;
  birth_year?: number | null;
  content_safety_check_completed_at?: Date | null;
  content_safety_check_failed_at?: Date | null;
  created_at?: Date | null;
  date_of_birth?: Date | null;
  deleted_at?: Date | null;
  derived_key?: any | null;
  email?: string | null;
  email_confirmation_token?: string | null;
  email_confirmation_token_issued_at?: Date | null;
  email_confirmed_at?: Date | null;
  /** Consent to Outschool collecting and processing learner&#x27;s health data to provide personalized recommendations. */
  has_health_consent?: boolean | null;
  /** Consent to seeing additional classes based on what the learner has favorited by sharing with third parties. */
  has_marketing_consent?: boolean | null;
  intro?: string | null;
  last_name?: string | null;
  /** Whether the learner has been offered marketing consent options after logging in for the first time as a 13+ year old. This includes when a learner turns 13. */
  learner_has_been_offered_consent?: boolean;
  login_enabled_at?: Date | null;
  name?: string | null;
  opted_out_of_personalized_recommendations_at?: Date | null;
  /** The parent of the learner */
  parent_uid: string;
  password_reset_token?: string | null;
  password_reset_token_issued_at?: Date | null;
  profile_age_hidden_at?: Date | null;
  profile_location_hidden_at?: Date | null;
  pronoun?: string | null;
  provisioned_for_organization_uid?: string | null;
  race_ethnicity?: string | null;
  salt?: any | null;
  suspended_at?: Date | null;
  suspended_reason?: string | null;
  uid?: string;
  updated_at?: Date | null;
  username?: string | null;
}
export interface LearningActorsRow {
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateLearningActorsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface LearningAssignmentClassPostCommentsRow {
  content_safety_check_completed_at: Date | null;
  content_safety_check_failed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  /** The learner who wrote the comment */
  learner_uid: string | null;
  learning_assignment_class_post_uid: string;
  message_content_uid: string;
  /** The learner whose assignment submission this comment is concerning, making it private between the teacher and the learner. Or left blank can indicate all learners can see the teacher&#x27;s reply. */
  reply_for_learner_uid: string | null;
  uid: string;
  updated_at: Date;
  /** The teacher who wrote the comment or the parent of the learner who wrote the comment */
  user_uid: string;
}
export interface CreateLearningAssignmentClassPostCommentsRow {
  content_safety_check_completed_at?: Date | null;
  content_safety_check_failed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** The learner who wrote the comment */
  learner_uid?: string | null;
  learning_assignment_class_post_uid: string;
  message_content_uid: string;
  /** The learner whose assignment submission this comment is concerning, making it private between the teacher and the learner. Or left blank can indicate all learners can see the teacher&#x27;s reply. */
  reply_for_learner_uid?: string | null;
  uid?: string;
  updated_at?: Date;
  /** The teacher who wrote the comment or the parent of the learner who wrote the comment */
  user_uid: string;
}
/** Grade a teacher gave a learner for an assignment. A new grade replaces the old one */
export interface LearningAssignmentClassPostGradesRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Free text grade, such as &#x27;A&#x27; or &#x27;9/10&#x27; */
  grade: string;
  /** Teacher who gave the grade */
  graded_by_user_uid: string;
  /** Learner who got the grade */
  learner_uid: string;
  /** Assignment the grade is for */
  learning_assignment_class_post_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateLearningAssignmentClassPostGradesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Free text grade, such as &#x27;A&#x27; or &#x27;9/10&#x27; */
  grade: string;
  /** Teacher who gave the grade */
  graded_by_user_uid: string;
  /** Learner who got the grade */
  learner_uid: string;
  /** Assignment the grade is for */
  learning_assignment_class_post_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface LearningAssignmentClassPostsRow {
  content_safety_check_completed_at: Date | null;
  content_safety_check_failed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  due_date: Date | null;
  learning_assignment_lesson_post_uid: string | null;
  lesson_uid: string | null;
  message_content_uid: string;
  /** Position of this block within its section lesson on the live V2 classroom. Shares one sequence with class_posts.order_in_lesson. Null outside live V2 lessons. */
  order_in_lesson: number | null;
  publish_at: Date;
  section_uid: string;
  /** Whether or not the assignment is required */
  submission_requirement_type: string;
  title: string;
  uid: string;
  updated_at: Date;
  /** The teacher who created the assignment */
  user_uid: string;
}
export interface CreateLearningAssignmentClassPostsRow {
  content_safety_check_completed_at?: Date | null;
  content_safety_check_failed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  due_date?: Date | null;
  learning_assignment_lesson_post_uid?: string | null;
  lesson_uid?: string | null;
  message_content_uid: string;
  /** Position of this block within its section lesson on the live V2 classroom. Shares one sequence with class_posts.order_in_lesson. Null outside live V2 lessons. */
  order_in_lesson?: number | null;
  publish_at: Date;
  section_uid: string;
  /** Whether or not the assignment is required */
  submission_requirement_type: string;
  title: string;
  uid?: string;
  updated_at?: Date;
  /** The teacher who created the assignment */
  user_uid: string;
}
export interface LearningAssignmentLessonPostsRow {
  content_safety_check_completed_at: Date | null;
  content_safety_check_failed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  lesson_uid: string;
  message_content_uid: string;
  /** Order of the assignment lesson post within a given lesson.  Must be greater than or equal to zero.  Lower number &#x3D; earlier post */
  order_in_lesson: number;
  /** Whether or not the assignment is required */
  submission_requirement_type: string;
  title: string;
  uid: string;
  updated_at: Date;
  /** The teacher who created the assignment */
  user_uid: string;
}
export interface CreateLearningAssignmentLessonPostsRow {
  content_safety_check_completed_at?: Date | null;
  content_safety_check_failed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  lesson_uid: string;
  message_content_uid: string;
  /** Order of the assignment lesson post within a given lesson.  Must be greater than or equal to zero.  Lower number &#x3D; earlier post */
  order_in_lesson: number;
  /** Whether or not the assignment is required */
  submission_requirement_type: string;
  title: string;
  uid?: string;
  updated_at?: Date;
  /** The teacher who created the assignment */
  user_uid: string;
}
export interface LearningLessonsRow {
  created_at: Date;
  deleted_at: Date | null;
  description: string | null;
  learning_syllabus_uid: string;
  learning_unit_uid: string | null;
  order_within_week: number;
  title: string | null;
  uid: string;
  updated_at: Date;
  week_number: number;
}
export interface CreateLearningLessonsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  description?: string | null;
  learning_syllabus_uid: string;
  learning_unit_uid?: string | null;
  order_within_week: number;
  title?: string | null;
  uid?: string;
  updated_at?: Date;
  week_number: number;
}
export interface LearningStatementsRow {
  created_at: Date;
  deleted_at: Date | null;
  learning_actor_uid: string;
  object_type: string;
  object_uid: string;
  uid: string;
  updated_at: Date;
  verb: string;
}
export interface CreateLearningStatementsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  learning_actor_uid: string;
  object_type: string;
  object_uid: string;
  uid?: string;
  updated_at?: Date;
  verb: string;
}
export interface LearningSyllabusesRow {
  activity_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  /** Classroom layout version for this syllabus template. */
  layout_version: number;
  published_at: Date | null;
  uid: string;
  updated_at: Date;
}
export interface CreateLearningSyllabusesRow {
  activity_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Classroom layout version for this syllabus template. */
  layout_version?: number;
  published_at?: Date | null;
  uid?: string;
  updated_at?: Date;
}
export interface LearningUnitsRow {
  created_at: Date;
  deleted_at: Date | null;
  learning_syllabus_uid: string;
  title: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateLearningUnitsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  learning_syllabus_uid: string;
  title?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface LessonPostsRow {
  /** Type of content block (e.g., text, video) for the async layout. */
  block_type: string | null;
  created_at: Date;
  deleted_at: Date | null;
  /** Estimated time to complete this post in minutes. */
  estimated_duration: number | null;
  is_posted_for_enrollments: boolean;
  is_posted_for_subscriptions: boolean;
  lesson_uid: string;
  message_content_uid: string;
  /** Order of the lesson post within a given lesson.  Must be greater than or equal to zero.  Lower number &#x3D; earlier post */
  order_in_lesson: number;
  title: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateLessonPostsRow {
  /** Type of content block (e.g., text, video) for the async layout. */
  block_type?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Estimated time to complete this post in minutes. */
  estimated_duration?: number | null;
  is_posted_for_enrollments?: boolean;
  is_posted_for_subscriptions?: boolean;
  lesson_uid: string;
  message_content_uid: string;
  /** Order of the lesson post within a given lesson.  Must be greater than or equal to zero.  Lower number &#x3D; earlier post */
  order_in_lesson: number;
  title?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface MathChallengeAttemptsRow {
  /** per-problem answers, correctness, timings, streaks, summary, and completed flag; mutated in place via shallow merge as the learner plays */
  attempt: any | null;
  /** game-specific configuration used for this session (e.g. PemdasConfig: enabled rules, number ranges, term count) */
  config: any;
  created_at: Date;
  deleted_at: Date | null;
  /** e.g. &#x27;pemdas&#x27; */
  game_type: string;
  /** learner who played this session */
  learner_uid: string;
  /** RNG seed; combined with game_type + config it deterministically reproduces every problem in the session */
  seed: string;
  uid: string;
  updated_at: Date;
}
export interface CreateMathChallengeAttemptsRow {
  /** per-problem answers, correctness, timings, streaks, summary, and completed flag; mutated in place via shallow merge as the learner plays */
  attempt?: any | null;
  /** game-specific configuration used for this session (e.g. PemdasConfig: enabled rules, number ranges, term count) */
  config: any;
  created_at?: Date;
  deleted_at?: Date | null;
  /** e.g. &#x27;pemdas&#x27; */
  game_type: string;
  /** learner who played this session */
  learner_uid: string;
  /** RNG seed; combined with game_type + config it deterministically reproduces every problem in the session */
  seed: string;
  uid?: string;
  updated_at?: Date;
}
export interface MeetingAiSummariesRow {
  ai_summary_text: string;
  created_at: Date;
  deleted_at: Date | null;
  edited_summary_text: string | null;
  is_skipped: boolean;
  meeting_uid: string;
  sent_at: Date | null;
  updated_at: Date;
}
export interface CreateMeetingAiSummariesRow {
  ai_summary_text: string;
  created_at?: Date;
  deleted_at?: Date | null;
  edited_summary_text?: string | null;
  is_skipped?: boolean;
  meeting_uid: string;
  sent_at?: Date | null;
  updated_at?: Date;
}
export interface MeetingRequestsRow {
  /** Set when the parent accepts a request. */
  accepted_at: Date | null;
  /** activity_uid is set and section_uid is null when the meeting request represents a private meeting request rather than a new meeting request for an existing section. */
  activity_uid: string;
  created_at: Date;
  /** Set when the parent declines the request. */
  declined_at: Date | null;
  deleted_at: Date | null;
  /** The proposed end time.  This is to be consistent with sections/meetings existing API.  Always equal to start_time + interval duration_minutes minutes. */
  end_time: Date;
  /** When the request can no longer be accepted or declined. Set when request is created or a new time is suggested. */
  expires_at: Date;
  is_recurring: boolean;
  /** The meeting that this requests affects.  For pending requests, this indicates that it is a reschedule request.  For accepted requests, it is the rescheduled/created meeting. */
  meeting_uid: string | null;
  /** The message displayed to the parent. */
  message: string | null;
  org_teacher_uid: string | null;
  /** The section associated with this meeting request. */
  section_uid: string | null;
  /** The proposed start time. */
  start_time: Date;
  uid: string;
  updated_at: Date;
}
export interface CreateMeetingRequestsRow {
  /** Set when the parent accepts a request. */
  accepted_at?: Date | null;
  /** activity_uid is set and section_uid is null when the meeting request represents a private meeting request rather than a new meeting request for an existing section. */
  activity_uid: string;
  created_at?: Date;
  /** Set when the parent declines the request. */
  declined_at?: Date | null;
  deleted_at?: Date | null;
  /** The proposed end time.  This is to be consistent with sections/meetings existing API.  Always equal to start_time + interval duration_minutes minutes. */
  end_time: Date;
  /** When the request can no longer be accepted or declined. Set when request is created or a new time is suggested. */
  expires_at: Date;
  is_recurring?: boolean;
  /** The meeting that this requests affects.  For pending requests, this indicates that it is a reschedule request.  For accepted requests, it is the rescheduled/created meeting. */
  meeting_uid?: string | null;
  /** The message displayed to the parent. */
  message?: string | null;
  org_teacher_uid?: string | null;
  /** The section associated with this meeting request. */
  section_uid?: string | null;
  /** The proposed start time. */
  start_time: Date;
  uid?: string;
  updated_at?: Date;
}
export interface MeetingReviewsRow {
  activity_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string;
  meeting_uid: string;
  rating: number;
  section_uid: string;
  type: string;
  uid: string;
  updated_at: Date;
}
export interface CreateMeetingReviewsRow {
  activity_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid: string;
  meeting_uid: string;
  rating: number;
  section_uid: string;
  type?: string;
  uid?: string;
  updated_at?: Date;
}
/** A single scheduled meeting of a section (e.g. a specific Zoom meeting) */
export interface MeetingsRow {
  /** The message expanding on why a meeting is canceled. */
  cancel_note: string | null;
  /** The reason why a meeting is canceled. */
  cancel_reason: string | null;
  canceled_by_user_role: string | null;
  canceled_by_user_uid: string | null;
  created_at: Date;
  deleted_at: Date | null;
  details: any | null;
  end_time: Date;
  lesson_uid: string | null;
  migration: any | null;
  recordings_details: any | null;
  recordings_visibility: boolean;
  section_uid: string;
  start_time: Date;
  uid: string;
  updated_at: Date;
}
export interface CreateMeetingsRow {
  /** The message expanding on why a meeting is canceled. */
  cancel_note?: string | null;
  /** The reason why a meeting is canceled. */
  cancel_reason?: string | null;
  canceled_by_user_role?: string | null;
  canceled_by_user_uid?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  details?: any | null;
  end_time: Date;
  lesson_uid?: string | null;
  migration?: any | null;
  recordings_details?: any | null;
  recordings_visibility: boolean;
  section_uid: string;
  start_time: Date;
  uid?: string;
  updated_at?: Date;
}
export interface MessageContentsRow {
  attachment_uids: string[] | null;
  created_at: Date | null;
  deleted_at: Date | null;
  edited_at: Date | null;
  email_message: any | null;
  /** External video URL (YouTube, Vimeo, or direct link) */
  external_video_url: string | null;
  /** Separate set of image attachment UIDs (e.g., content images) rendered independently from regular attachments. */
  image_attachment_uids: string[] | null;
  text: string | null;
  text_mime_type: string | null;
  uid: string;
  updated_at: Date | null;
  video_uid: string | null;
}
export interface CreateMessageContentsRow {
  attachment_uids?: string[] | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  edited_at?: Date | null;
  email_message?: any | null;
  /** External video URL (YouTube, Vimeo, or direct link) */
  external_video_url?: string | null;
  /** Separate set of image attachment UIDs (e.g., content images) rendered independently from regular attachments. */
  image_attachment_uids?: string[] | null;
  text?: string | null;
  text_mime_type?: string | null;
  uid?: string;
  updated_at?: Date | null;
  video_uid?: string | null;
}
export interface MessageReadEventsRow {
  class_post_comment_uid: string | null;
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string | null;
  learning_assignment_class_post_comment_uid: string | null;
  message_uid: string | null;
  private_class_message_uid: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreateMessageReadEventsRow {
  class_post_comment_uid?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid?: string | null;
  learning_assignment_class_post_comment_uid?: string | null;
  message_uid?: string | null;
  private_class_message_uid?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface MessageSpamMarkersRow {
  created_at: Date;
  deleted_at: Date | null;
  message_uid: string;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateMessageSpamMarkersRow {
  created_at?: Date;
  deleted_at?: Date | null;
  message_uid: string;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface MessagesRow {
  activity_uid: string | null;
  archived_at: Date | null;
  bulk_group_uid: string | null;
  content: string | null;
  content_safety_check_completed_at: Date | null;
  content_safety_check_failed_at: Date | null;
  created_at: Date | null;
  deleted_at: Date | null;
  delivered_at: Date | null;
  details: any | null;
  hold_new_threads: boolean;
  message_content_uid: string | null;
  participants: string[] | null;
  release_at: Date | null;
  section_uid: string | null;
  sender: string | null;
  thread_uid: string | null;
  uid: string;
  updated_at: Date | null;
}
export interface CreateMessagesRow {
  activity_uid?: string | null;
  archived_at?: Date | null;
  bulk_group_uid?: string | null;
  content?: string | null;
  content_safety_check_completed_at?: Date | null;
  content_safety_check_failed_at?: Date | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  delivered_at?: Date | null;
  details?: any | null;
  hold_new_threads?: boolean;
  message_content_uid?: string | null;
  participants?: string[] | null;
  release_at?: Date | null;
  section_uid?: string | null;
  sender?: string | null;
  thread_uid?: string | null;
  uid?: string;
  updated_at?: Date | null;
}
export interface MonitoringPromptsRow {
  created_at: Date;
  deleted_at: Date | null;
  prompt_uid: string;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateMonitoringPromptsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  prompt_uid: string;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface NonceChallengesRow {
  challenge: string;
  created_at: Date;
}
export interface CreateNonceChallengesRow {
  challenge: string;
  created_at?: Date;
}
export interface NotificationsRow {
  action: string;
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string | null;
  object_id: string;
  object_type: string;
  platform: string;
  read_at: Date | null;
  seen_at: Date | null;
  sent_at: Date | null;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateNotificationsRow {
  action: string;
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid?: string | null;
  object_id: string;
  object_type: string;
  platform: string;
  read_at?: Date | null;
  seen_at?: Date | null;
  sent_at?: Date | null;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface OidcUsersRow {
  created_at: Date;
  deleted_at: Date | null;
  email: string | null;
  learner_uid: string | null;
  profile: any | null;
  provider: string;
  subject: string;
  uid: string;
  updated_at: Date;
  user_uid: string | null;
}
export interface CreateOidcUsersRow {
  created_at?: Date;
  deleted_at?: Date | null;
  email?: string | null;
  learner_uid?: string | null;
  profile?: any | null;
  provider: string;
  subject: string;
  uid?: string;
  updated_at?: Date;
  user_uid?: string | null;
}
/** Requested checkout tender intent for an order; not the resolved payment allocation */
export interface OrderCheckoutTenderSelectionsRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Logical order identifier for this checkout */
  order_slug_id: string;
  /** Explicitly selected tender type; null when selection_mode is automatic */
  selected_tender_type: string | null;
  /** Whether checkout used automatic tender selection or an explicit user choice */
  selection_mode: string;
  uid: string;
  updated_at: Date;
  /** User who submitted the checkout */
  user_uid: string;
}
export interface CreateOrderCheckoutTenderSelectionsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Logical order identifier for this checkout */
  order_slug_id: string;
  /** Explicitly selected tender type; null when selection_mode is automatic */
  selected_tender_type?: string | null;
  /** Whether checkout used automatic tender selection or an explicit user choice */
  selection_mode: string;
  uid?: string;
  updated_at?: Date;
  /** User who submitted the checkout */
  user_uid: string;
}
/** Payment by some method to fund a credit account. Note that there may be multiple payments for a single enrollment (e.g. combining a coupon + Stripe subscription) */
export interface OrderPaymentsRow {
  amount_cents: number;
  amount_in_local_currency: number | null;
  apple_transaction_id: string | null;
  canceled_at: Date | null;
  captured_at: Date | null;
  charter_school_uid: string | null;
  confirmed_at: Date | null;
  coupon_code_uid: string | null;
  created_at: Date;
  /** Transaction in the account that the credits were debited into */
  credit_transaction_uid: string | null;
  currency_code: string | null;
  deleted_at: Date | null;
  esa_order_id: string | null;
  exchange_rate: number | null;
  funding_program_invoice_uid: string | null;
  intercom_url: string | null;
  invoice_uid: string | null;
  last4: string | null;
  order_slug_id: string;
  organization_uid: string | null;
  pricing_offer_uid: string | null;
  purchase_order_id: string | null;
  purchaser_email: string | null;
  purchaser_name: string | null;
  receipt_data: string | null;
  stripe_charge_id: string | null;
  stripe_coupon_id: string | null;
  stripe_coupon_promotion_code_id: string | null;
  stripe_payment_intent_id: string | null;
  /** The tax amount in cents associated with this payment. */
  tax_amount_cents: number | null;
  tender_type: string;
  uid: string;
  updated_at: Date;
  user_uid: string | null;
}
export interface CreateOrderPaymentsRow {
  amount_cents: number;
  amount_in_local_currency?: number | null;
  apple_transaction_id?: string | null;
  canceled_at?: Date | null;
  captured_at?: Date | null;
  charter_school_uid?: string | null;
  confirmed_at?: Date | null;
  coupon_code_uid?: string | null;
  created_at?: Date;
  /** Transaction in the account that the credits were debited into */
  credit_transaction_uid?: string | null;
  currency_code?: string | null;
  deleted_at?: Date | null;
  esa_order_id?: string | null;
  exchange_rate?: number | null;
  funding_program_invoice_uid?: string | null;
  intercom_url?: string | null;
  invoice_uid?: string | null;
  last4?: string | null;
  order_slug_id: string;
  organization_uid?: string | null;
  pricing_offer_uid?: string | null;
  purchase_order_id?: string | null;
  purchaser_email?: string | null;
  purchaser_name?: string | null;
  receipt_data?: string | null;
  stripe_charge_id?: string | null;
  stripe_coupon_id?: string | null;
  stripe_coupon_promotion_code_id?: string | null;
  stripe_payment_intent_id?: string | null;
  /** The tax amount in cents associated with this payment. */
  tax_amount_cents?: number | null;
  tender_type: string;
  uid?: string;
  updated_at?: Date;
  user_uid?: string | null;
}
export interface OrderTaxesRow {
  /** Total amount of tax due based on tax calc/transaction */
  amount_cents: number;
  created_at: Date;
  deleted_at: Date | null;
  /** Reference to the order slug */
  order_slug_id: string;
  /** Reference to the stripe invoice where tax was collected. Is not null if the tax was calculated from a stripe invoice.  Stripe invoices do not have a tax calculation id, so we use the invoice id to uniquely identify the tax calculation. */
  stripe_invoice_id: string | null;
  /** Reference to the stripe tax calculation id */
  stripe_tax_calculation_id: string | null;
  /** Reference to the stripe tax transaction id. Null if only tax calculation has occurred */
  stripe_tax_transaction_id: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateOrderTaxesRow {
  /** Total amount of tax due based on tax calc/transaction */
  amount_cents: number;
  created_at?: Date;
  deleted_at?: Date | null;
  /** Reference to the order slug */
  order_slug_id: string;
  /** Reference to the stripe invoice where tax was collected. Is not null if the tax was calculated from a stripe invoice.  Stripe invoices do not have a tax calculation id, so we use the invoice id to uniquely identify the tax calculation. */
  stripe_invoice_id?: string | null;
  /** Reference to the stripe tax calculation id */
  stripe_tax_calculation_id?: string | null;
  /** Reference to the stripe tax transaction id. Null if only tax calculation has occurred */
  stripe_tax_transaction_id?: string | null;
  uid?: string;
  updated_at?: Date;
}
/** An organization (chart school, non-profit, etc.) that pays for learners in their network */
export interface OrganizationsRow {
  address: string | null;
  audit_log: any | null;
  created_at: Date;
  deleted_at: Date | null;
  details: any;
  invoice_email: string | null;
  is_esa_or_microgrant: boolean;
  is_org_community_partner: boolean;
  logo_url: string | null;
  name: string | null;
  notes: string | null;
  state: string | null;
  tech_support_email: string | null;
  trust_safety_email: string | null;
  type: string;
  uid: string;
  updated_at: Date;
  url_name: string | null;
}
export interface CreateOrganizationsRow {
  address?: string | null;
  audit_log?: any | null;
  created_at?: Date;
  deleted_at?: Date | null;
  details?: any;
  invoice_email?: string | null;
  is_esa_or_microgrant?: boolean;
  is_org_community_partner?: boolean;
  logo_url?: string | null;
  name?: string | null;
  notes?: string | null;
  state?: string | null;
  tech_support_email?: string | null;
  trust_safety_email?: string | null;
  type?: string;
  uid?: string;
  updated_at?: Date;
  url_name?: string | null;
}
export interface OtherUserEmailsRow {
  confirmed_at: Date | null;
  created_at: Date | null;
  deleted_at: Date | null;
  email: string | null;
  token_uid: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string;
}
export interface CreateOtherUserEmailsRow {
  confirmed_at?: Date | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  email?: string | null;
  token_uid?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid: string;
}
export interface ParsedClassRecordingsRow {
  class_recording_uid: string;
  created_at: Date;
  deleted_at: Date | null;
  parsed_at: Date | null;
  uid: string;
}
export interface CreateParsedClassRecordingsRow {
  class_recording_uid: string;
  created_at?: Date;
  deleted_at?: Date | null;
  parsed_at?: Date | null;
  uid?: string;
}
/** Record of how an enrollment_payment posts to downstream accounts (teachers for now).
      The daily payout job reads from this table (by processing_date) to determine what to pay
      and updates rows with processing markers.
      
      IMPORTANT:
      Several columns capture a snapshot-in-time of the enrollment_payment state to ensure
      auditing accuracy even when sections, leaders, or user associations later change. */
export interface PayableTransactionsRow {
  /** Used for admin_payout contextual notes. */
  admin_notes: any | null;
  /** In minor units (USD) */
  amount_cents: number;
  created_at: Date;
  deleted_at: Date | null;
  /** FK to enrollment_payment_refunds. Set when this payable transaction is a refund. */
  enrollment_payment_refund_uid: string | null;
  /** 1:1 with EPs */
  enrollment_payment_uid: string | null;
  /** Per-member net amount computed at prepare time so recordPayouts can stamp each enrollment payment with its own disbursed_cents */
  net_amount_cents: number | null;
  /** FK to users.uid for the teacher who is being paid */
  payee_user_uid: string;
  /** FK if PayPal payout exists. */
  paypal_payout_uid: string | null;
  /** Indicates payout has been processed by our system at this time */
  processed_at: Date | null;
  /** indicates the date of the payout is scheduled to be sent */
  processing_time: Date;
  section_uid: string | null;
  /** Percentage of revenue share for the payee (0–100). */
  shared_percentage: number;
  /** FK to stripe_transfers if Stripe transfer exists. */
  stripe_transfer_uid: string | null;
  type: string;
  uid: string;
  updated_at: Date;
}
export interface CreatePayableTransactionsRow {
  /** Used for admin_payout contextual notes. */
  admin_notes?: any | null;
  /** In minor units (USD) */
  amount_cents: number;
  created_at?: Date;
  deleted_at?: Date | null;
  /** FK to enrollment_payment_refunds. Set when this payable transaction is a refund. */
  enrollment_payment_refund_uid?: string | null;
  /** 1:1 with EPs */
  enrollment_payment_uid?: string | null;
  /** Per-member net amount computed at prepare time so recordPayouts can stamp each enrollment payment with its own disbursed_cents */
  net_amount_cents?: number | null;
  /** FK to users.uid for the teacher who is being paid */
  payee_user_uid: string;
  /** FK if PayPal payout exists. */
  paypal_payout_uid?: string | null;
  /** Indicates payout has been processed by our system at this time */
  processed_at?: Date | null;
  /** indicates the date of the payout is scheduled to be sent */
  processing_time: Date;
  section_uid?: string | null;
  /** Percentage of revenue share for the payee (0–100). */
  shared_percentage: number;
  /** FK to stripe_transfers if Stripe transfer exists. */
  stripe_transfer_uid?: string | null;
  type: string;
  uid?: string;
  updated_at?: Date;
}
export interface PaymentSchedulePaymentsRow {
  amount_cents: number;
  audit_log: any | null;
  canceled_at: Date | null;
  confirmed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  order_slug_id: string;
  payment_schedule_uid: string;
  period_end_time: Date;
  period_start_time: Date;
  uid: string;
  updated_at: Date;
}
export interface CreatePaymentSchedulePaymentsRow {
  amount_cents: number;
  audit_log?: any | null;
  canceled_at?: Date | null;
  confirmed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  order_slug_id: string;
  payment_schedule_uid: string;
  period_end_time: Date;
  period_start_time: Date;
  uid?: string;
  updated_at?: Date;
}
export interface PaymentSchedulePaymentsFailuresRow {
  amount_cents: number;
  created_at: Date;
  deleted_at: Date | null;
  enrollment_uid: string;
  payment_schedule_uid: string;
  period_end_time: Date;
  period_start_time: Date;
  reason: string;
  stripe_payment_intent_id: string;
  uid: string;
  updated_at: Date;
}
export interface CreatePaymentSchedulePaymentsFailuresRow {
  amount_cents: number;
  created_at?: Date;
  deleted_at?: Date | null;
  enrollment_uid: string;
  payment_schedule_uid: string;
  period_end_time: Date;
  period_start_time: Date;
  reason: string;
  stripe_payment_intent_id: string;
  uid?: string;
  updated_at?: Date;
}
export interface PaymentSchedulesRow {
  amount_cents: number | null;
  audit_log: any | null;
  created_at: Date;
  deleted_at: Date | null;
  end_time: Date | null;
  schedule_type: string;
  start_time: Date;
  stopped_at: Date | null;
  stopped_reason: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreatePaymentSchedulesRow {
  amount_cents?: number | null;
  audit_log?: any | null;
  created_at?: Date;
  deleted_at?: Date | null;
  end_time?: Date | null;
  schedule_type: string;
  start_time: Date;
  stopped_at?: Date | null;
  stopped_reason?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface PayoutBatchAttemptsRow {
  batch_details_at: Date | null;
  completed_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  paypal_batch_id: string | null;
  retry_count: number;
  script_started_at: Date;
  status: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreatePayoutBatchAttemptsRow {
  batch_details_at?: Date | null;
  completed_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  paypal_batch_id?: string | null;
  retry_count?: number;
  script_started_at: Date;
  status?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface PayoutSourcesRow {
  created_at: Date;
  disbursed_cents: number | null;
  enrollment_payment_uid: string;
  payout_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreatePayoutSourcesRow {
  created_at?: Date;
  disbursed_cents?: number | null;
  enrollment_payment_uid: string;
  payout_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface PayoutsRow {
  amount_cents: number | null;
  created_at: Date | null;
  deleted_at: Date | null;
  email: string | null;
  is_manual: boolean | null;
  payout_batch_attempt_uid: string | null;
  response: any | null;
  section_uid: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreatePayoutsRow {
  amount_cents?: number | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  email?: string | null;
  is_manual?: boolean | null;
  payout_batch_attempt_uid?: string | null;
  response?: any | null;
  section_uid?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface PricingAdjustmentsRow {
  created_at: Date;
  deleted_at: Date | null;
  /** References the name of the database table */
  entity_type: string;
  entity_uid: string;
  /** The title of the pricing adjustment rule */
  rule: string;
  uid: string;
  updated_at: Date;
  value: number;
}
export interface CreatePricingAdjustmentsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** References the name of the database table */
  entity_type: string;
  entity_uid: string;
  /** The title of the pricing adjustment rule */
  rule: string;
  uid?: string;
  updated_at?: Date;
  value: number;
}
export interface PricingOfferEmailAddressesRow {
  audit_log: any | null;
  created_at: Date;
  deleted_at: Date | null;
  eligibility: string | null;
  email_address: string;
  pricing_offer_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreatePricingOfferEmailAddressesRow {
  audit_log?: any | null;
  created_at?: Date;
  deleted_at?: Date | null;
  eligibility?: string | null;
  email_address: string;
  pricing_offer_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface PricingOfferEmailDomainsRow {
  audit_log: any | null;
  created_at: Date;
  deleted_at: Date | null;
  email_domain: string;
  pricing_offer_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreatePricingOfferEmailDomainsRow {
  audit_log?: any | null;
  created_at?: Date;
  deleted_at?: Date | null;
  email_domain: string;
  pricing_offer_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface PricingOffersRow {
  audit_log: any | null;
  buyer_org_name: string | null;
  created_at: Date;
  deleted_at: Date | null;
  discount: number | null;
  end_by: Date;
  name: string;
  organization_uid: string | null;
  require_financial_assistance: boolean;
  require_payment_method: boolean;
  start_after: Date;
  total_cap_cents: number;
  uid: string;
  updated_at: Date;
  user_limit_cents: number;
  users_synced_at: Date | null;
}
export interface CreatePricingOffersRow {
  audit_log?: any | null;
  buyer_org_name?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  discount?: number | null;
  end_by: Date;
  name: string;
  organization_uid?: string | null;
  require_financial_assistance?: boolean;
  require_payment_method?: boolean;
  start_after: Date;
  total_cap_cents: number;
  uid?: string;
  updated_at?: Date;
  user_limit_cents: number;
  users_synced_at?: Date | null;
}
export interface PrivateClassMessagesRow {
  activity_uid: string | null;
  archived_at: Date | null;
  audit_log: any | null;
  /** FK to class_posts for post-scoped threads in self-paced classes */
  class_post_uid: string | null;
  content_safety_check_completed_at: Date | null;
  content_safety_check_failed_at: Date | null;
  created_at: Date | null;
  deleted_at: Date | null;
  /** FK to learning_assignment_class_posts for post-scoped threads in self-paced classes */
  learning_assignment_class_post_uid: string | null;
  message_content_uid: string | null;
  participant_learner_uids: string[];
  participant_user_uids: string[];
  section_uid: string;
  sender_learner_uid: string | null;
  sender_user_uid: string;
  thread_uid: string | null;
  uid: string;
  updated_at: Date | null;
}
export interface CreatePrivateClassMessagesRow {
  activity_uid?: string | null;
  archived_at?: Date | null;
  audit_log?: any | null;
  /** FK to class_posts for post-scoped threads in self-paced classes */
  class_post_uid?: string | null;
  content_safety_check_completed_at?: Date | null;
  content_safety_check_failed_at?: Date | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  /** FK to learning_assignment_class_posts for post-scoped threads in self-paced classes */
  learning_assignment_class_post_uid?: string | null;
  message_content_uid?: string | null;
  participant_learner_uids: string[];
  participant_user_uids: string[];
  section_uid: string;
  sender_learner_uid?: string | null;
  sender_user_uid: string;
  thread_uid?: string | null;
  uid?: string;
  updated_at?: Date | null;
}
export interface PrivateLearnerNotesRow {
  content: string | null;
  created_at: Date;
  deleted_at: Date | null;
  learner_uid: string;
  owner_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreatePrivateLearnerNotesRow {
  content?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  learner_uid: string;
  owner_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface PromptsRow {
  content: string;
  created_at: Date;
  deleted_at: Date | null;
  name: string;
  uid: string;
  updated_at: Date;
}
export interface CreatePromptsRow {
  content: string;
  created_at?: Date;
  deleted_at?: Date | null;
  name: string;
  uid?: string;
  updated_at?: Date;
}
export interface QuizAttemptsRow {
  /** attempt definition / content */
  attempt: any | null;
  created_at: Date;
  deleted_at: Date | null;
  /** quiz topics that were generated as a result of completing this quiz attempt */
  generated_quiz_topic_uids: string[] | null;
  learner_uid: string;
  quiz_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateQuizAttemptsRow {
  /** attempt definition / content */
  attempt?: any | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** quiz topics that were generated as a result of completing this quiz attempt */
  generated_quiz_topic_uids?: string[] | null;
  learner_uid: string;
  quiz_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface QuizTopicsRow {
  /** date and time when this quiz topic was blocked */
  blocked_at: Date | null;
  created_at: Date;
  deleted_at: Date | null;
  /** whether this quiz topic can be used by any learner */
  is_universal: boolean;
  /** learner who created this quiz topic row by completing another quiz */
  learner_uid: string | null;
  /** log of model / LLM calls related to this quiz */
  model_interaction_log: any | null;
  name: string;
  uid: string;
  updated_at: Date;
}
export interface CreateQuizTopicsRow {
  /** date and time when this quiz topic was blocked */
  blocked_at?: Date | null;
  created_at?: Date;
  deleted_at?: Date | null;
  /** whether this quiz topic can be used by any learner */
  is_universal?: boolean;
  /** learner who created this quiz topic row by completing another quiz */
  learner_uid?: string | null;
  /** log of model / LLM calls related to this quiz */
  model_interaction_log?: any | null;
  name: string;
  uid?: string;
  updated_at?: Date;
}
export interface QuizzesRow {
  created_at: Date;
  /** learner who created this quiz row */
  created_by_learner_uid: string;
  deleted_at: Date | null;
  /** inputs used to generate the quiz */
  input: any | null;
  /** log of model / LLM calls related to this quiz */
  model_interaction_log: any | null;
  /** quiz definition / content */
  quiz: any | null;
  /** quiz topic that this quiz was generated from */
  quiz_topic_uid: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateQuizzesRow {
  created_at?: Date;
  /** learner who created this quiz row */
  created_by_learner_uid: string;
  deleted_at?: Date | null;
  /** inputs used to generate the quiz */
  input?: any | null;
  /** log of model / LLM calls related to this quiz */
  model_interaction_log?: any | null;
  /** quiz definition / content */
  quiz?: any | null;
  /** quiz topic that this quiz was generated from */
  quiz_topic_uid?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface RecordingAiTeacherObservationsRow {
  ai_response: any | null;
  created_at: Date;
  deleted_at: Date | null;
  prompt_version: string;
  recording_uid: string | null;
  status: string;
  uid: string;
  updated_at: Date;
}
export interface CreateRecordingAiTeacherObservationsRow {
  ai_response?: any | null;
  created_at?: Date;
  deleted_at?: Date | null;
  prompt_version: string;
  recording_uid?: string | null;
  status: string;
  uid?: string;
  updated_at?: Date;
}
export interface SavedActivitiesRow {
  activity_uid: string | null;
  attribution: any | null;
  created_at: Date | null;
  deleted_at: Date | null;
  referer: string | null;
  saved_by_learner_uid: string | null;
  saved_class_list_uid: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreateSavedActivitiesRow {
  activity_uid?: string | null;
  attribution?: any | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  referer?: string | null;
  saved_by_learner_uid?: string | null;
  saved_class_list_uid?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface SavedClassListsRow {
  created_at: Date;
  deleted_at: Date | null;
  for_learner_uid: string | null;
  name: string | null;
  privacy_status: string;
  uid: string;
  updated_at: Date;
  user_uid: string | null;
}
export interface CreateSavedClassListsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  for_learner_uid?: string | null;
  name?: string | null;
  privacy_status?: string;
  uid?: string;
  updated_at?: Date;
  user_uid?: string | null;
}
export interface SavedSearchesRow {
  created_at: Date | null;
  deleted_at: Date | null;
  filters: any | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreateSavedSearchesRow {
  created_at?: Date | null;
  deleted_at?: Date | null;
  filters?: any | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface SectionAvailabilityReadModelRow {
  /** Generated column that stores the number of available seats (computed as GREATEST(total_spaces - filled_spaces, 0)) */
  available_seats: number | null;
  created_at: Date;
  deleted_at: Date | null;
  filled_spaces: number;
  /** Generated column that indicates whether the section has any available spaces (computed as total_spaces - filled_spaces &gt; 0) */
  is_available: boolean | null;
  next_meeting_end_time: Date | null;
  next_meeting_time: Date | null;
  section_uid: string;
  total_spaces: number;
  updated_at: Date;
}
export interface CreateSectionAvailabilityReadModelRow {
  /** Generated column that stores the number of available seats (computed as GREATEST(total_spaces - filled_spaces, 0)) */
  available_seats?: number | null;
  created_at?: Date;
  deleted_at?: Date | null;
  filled_spaces: number;
  /** Generated column that indicates whether the section has any available spaces (computed as total_spaces - filled_spaces &gt; 0) */
  is_available?: boolean | null;
  next_meeting_end_time?: Date | null;
  next_meeting_time?: Date | null;
  section_uid: string;
  total_spaces: number;
  updated_at?: Date;
}
export interface SectionModeratorsRow {
  created_at: Date;
  deleted_at: Date | null;
  section_uid: string;
  uid: string;
  user_uid: string;
}
export interface CreateSectionModeratorsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  section_uid: string;
  uid?: string;
  user_uid: string;
}
export interface SectionRecurringMeetingsRow {
  created_at: Date;
  deleted_at: Date | null;
  /** The meeting associated with the section_recurring_schedule. */
  meeting_uid: string;
  /** The associated section_recurring_schedule. */
  section_recurring_schedule_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateSectionRecurringMeetingsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** The meeting associated with the section_recurring_schedule. */
  meeting_uid: string;
  /** The associated section_recurring_schedule. */
  section_recurring_schedule_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface SectionRecurringSchedulesRow {
  created_at: Date;
  deleted_at: Date | null;
  /** When the recurring event should end. If NULL, meetings will continue to be added for this schedule.. */
  end_at: Date | null;
  /** End time of the first meeting, used to determine day_of_week and time local to the user for repeatability. */
  end_time: Date;
  /** The section associated with this recurring schedule. */
  section_uid: string;
  /** Start time of the first meeting, used to determine day_of_week and time local to the user for repeatability. */
  start_time: Date;
  uid: string;
  updated_at: Date;
}
export interface CreateSectionRecurringSchedulesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** When the recurring event should end. If NULL, meetings will continue to be added for this schedule.. */
  end_at?: Date | null;
  /** End time of the first meeting, used to determine day_of_week and time local to the user for repeatability. */
  end_time: Date;
  /** The section associated with this recurring schedule. */
  section_uid: string;
  /** Start time of the first meeting, used to determine day_of_week and time local to the user for repeatability. */
  start_time: Date;
  uid?: string;
  updated_at?: Date;
}
/** A cohort of learners enrolled in a class for one or more meetings */
export interface SectionsRow {
  activity_uid: string;
  /** Minutes relative to the lesson meeting used as the default assignment due offset; negative is before and positive is after. Null uses the system default. */
  assignment_due_offset_minutes: number | null;
  attribution: any | null;
  canceled_at: Date | null;
  checklist: any | null;
  classroom_layout_published_at: Date | null;
  /** Optional classroom layout override for this section; null uses the syllabus layout version. */
  classroom_layout_version: number | null;
  created_at: Date | null;
  deleted_at: Date | null;
  details: any | null;
  duration_minutes: number | null;
  end_time: Date | null;
  is_cross_listed: boolean | null;
  /** If true, is a self-paced flex class otherwise it is a “traditional” cohorted flex class (not self-paced).  Only true for flex classes (weekly_meetings &#x3D; 0) */
  is_self_paced: boolean;
  learning_syllabus_uid: string | null;
  /** Minutes relative to the lesson meeting used as the default content release offset; negative is before and positive is after. Null uses the system default. */
  lesson_content_release_offset_minutes: number | null;
  location: any | null;
  ongoing_stopped_at: Date | null;
  /** Allow null for section price to indicate it is the same with activity */
  price_cents: number | null;
  published_at: Date | null;
  size_max: number | null;
  size_min: number | null;
  start_time: Date | null;
  /** When teacher support period begins for self-paced classes. */
  teacher_support_start_time: Date | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreateSectionsRow {
  activity_uid: string;
  /** Minutes relative to the lesson meeting used as the default assignment due offset; negative is before and positive is after. Null uses the system default. */
  assignment_due_offset_minutes?: number | null;
  attribution?: any | null;
  canceled_at?: Date | null;
  checklist?: any | null;
  classroom_layout_published_at?: Date | null;
  /** Optional classroom layout override for this section; null uses the syllabus layout version. */
  classroom_layout_version?: number | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  details?: any | null;
  duration_minutes?: number | null;
  end_time?: Date | null;
  is_cross_listed?: boolean | null;
  /** If true, is a self-paced flex class otherwise it is a “traditional” cohorted flex class (not self-paced).  Only true for flex classes (weekly_meetings &#x3D; 0) */
  is_self_paced?: boolean;
  learning_syllabus_uid?: string | null;
  /** Minutes relative to the lesson meeting used as the default content release offset; negative is before and positive is after. Null uses the system default. */
  lesson_content_release_offset_minutes?: number | null;
  location?: any | null;
  ongoing_stopped_at?: Date | null;
  /** Allow null for section price to indicate it is the same with activity */
  price_cents?: number | null;
  published_at?: Date | null;
  size_max?: number | null;
  size_min?: number | null;
  start_time?: Date | null;
  /** When teacher support period begins for self-paced classes. */
  teacher_support_start_time?: Date | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface SectionsAvailabilityRow {
  filled_spaces: number | null;
  is_available: boolean | null;
  next_meeting_end_time: Date | null;
  next_meeting_time: Date | null;
  section_uid: string | null;
  total_spaces: number | null;
}
export interface CreateSectionsAvailabilityRow {
  filled_spaces?: number | null;
  is_available?: boolean | null;
  next_meeting_end_time?: Date | null;
  next_meeting_time?: Date | null;
  section_uid?: string | null;
  total_spaces?: number | null;
}
export interface SellerOrgAgreementsRow {
  agreement: string;
  agreement_template_uid: string | null;
  created_at: Date;
  fields: any | null;
  signed_at: Date | null;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateSellerOrgAgreementsRow {
  agreement: string;
  agreement_template_uid?: string | null;
  created_at?: Date;
  fields?: any | null;
  signed_at?: Date | null;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface SellerOrgApplicationsRow {
  admin_response: string | null;
  applied_at: Date | null;
  approved_at: Date | null;
  contract_signed_at: Date | null;
  created_at: Date | null;
  /** Application form version: 1 (original) or 2 (onboarding v2) */
  form_version: number;
  other_answers: any | null;
  rejected_at: Date | null;
  /** Signed agreement this application was submitted with */
  seller_org_agreement_uid: string | null;
  status: string;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
  /** Private business verification document in the secured bucket: s3_key, filename, mimetype, size */
  verification_document: any | null;
  /** Business verification document uploaded by the applicant */
  verification_document_uid: string | null;
  /** Profile video uploaded by the applicant */
  video_uid: string | null;
}
export interface CreateSellerOrgApplicationsRow {
  admin_response?: string | null;
  applied_at?: Date | null;
  approved_at?: Date | null;
  contract_signed_at?: Date | null;
  created_at?: Date | null;
  /** Application form version: 1 (original) or 2 (onboarding v2) */
  form_version?: number;
  other_answers?: any | null;
  rejected_at?: Date | null;
  /** Signed agreement this application was submitted with */
  seller_org_agreement_uid?: string | null;
  status?: string;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
  /** Private business verification document in the secured bucket: s3_key, filename, mimetype, size */
  verification_document?: any | null;
  /** Business verification document uploaded by the applicant */
  verification_document_uid?: string | null;
  /** Profile video uploaded by the applicant */
  video_uid?: string | null;
}
/** An organization offering classes on Outschool */
export interface SellerOrgsRow {
  background_check_owner: string;
  created_at: Date | null;
  pin_derived_key: any | null;
  pin_salt: any | null;
  status: string;
  uid: string;
  updated_at: Date | null;
}
export interface CreateSellerOrgsRow {
  background_check_owner?: string;
  created_at?: Date | null;
  pin_derived_key?: any | null;
  pin_salt?: any | null;
  status?: string;
  uid?: string;
  updated_at?: Date | null;
}
export interface SentNotificationsRow {
  created_at: Date | null;
  deleted_at: Date | null;
  key: string;
  namespace: string;
  uid: string;
}
export interface CreateSentNotificationsRow {
  created_at?: Date | null;
  deleted_at?: Date | null;
  key: string;
  namespace: string;
  uid?: string;
}
export interface StripeCollectionInvoicesRow {
  admin_notes: any | null;
  /** Invoice Amount */
  amount_cents: number;
  created_at: Date;
  deleted_at: Date | null;
  /** notes for teacher to see in the invoice Learner Name, Parent Name, Class Name and Section Details... etc */
  description: string | null;
  enrollment_payment_refund_uid: string;
  /** Stripe invoice status (DRAFT, OPEN, PAID, VOID, UNCOLLECTIBLE) */
  status: string;
  /** Stripe invoice id */
  stripe_invoice_id: string | null;
  stripe_response: any | null;
  uid: string;
  updated_at: Date;
  /** Educator Uid */
  user_uid: string | null;
}
export interface CreateStripeCollectionInvoicesRow {
  admin_notes?: any | null;
  /** Invoice Amount */
  amount_cents: number;
  created_at?: Date;
  deleted_at?: Date | null;
  /** notes for teacher to see in the invoice Learner Name, Parent Name, Class Name and Section Details... etc */
  description?: string | null;
  enrollment_payment_refund_uid: string;
  /** Stripe invoice status (DRAFT, OPEN, PAID, VOID, UNCOLLECTIBLE) */
  status: string;
  /** Stripe invoice id */
  stripe_invoice_id?: string | null;
  stripe_response?: any | null;
  uid?: string;
  updated_at?: Date;
  /** Educator Uid */
  user_uid?: string | null;
}
export interface StripeCouponPromoCodesRow {
  coupon_id: string | null;
  coupon_name: string | null;
  created_at: Date;
  deleted_at: Date | null;
  promo_code: string | null;
  promo_code_id: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateStripeCouponPromoCodesRow {
  coupon_id?: string | null;
  coupon_name?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  promo_code?: string | null;
  promo_code_id?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface StripeFingerprintsRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Whether this Stripe fingerprint is designated as a backup payment method for off-session charges */
  is_backup_for_off_session_charges: boolean;
  stripe_fingerprint: string;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateStripeFingerprintsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Whether this Stripe fingerprint is designated as a backup payment method for off-session charges */
  is_backup_for_off_session_charges?: boolean;
  stripe_fingerprint: string;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface StripeTransfersRow {
  amount_cents: number;
  created_at: Date;
  deleted_at: Date | null;
  paid_to_connected_account_id: string;
  /** Stripe destination payment ID for this transfer (py_...). Null when not applicable. */
  stripe_destination_payment_id: string | null;
  stripe_response: any | null;
  stripe_status: string;
  stripe_transfer_id: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateStripeTransfersRow {
  amount_cents: number;
  created_at?: Date;
  deleted_at?: Date | null;
  paid_to_connected_account_id: string;
  /** Stripe destination payment ID for this transfer (py_...). Null when not applicable. */
  stripe_destination_payment_id?: string | null;
  stripe_response?: any | null;
  stripe_status: string;
  stripe_transfer_id?: string | null;
  uid?: string;
  updated_at?: Date;
}
/** Definition of a subscription package (aka tier) */
export interface SubscriptionPackagesRow {
  /** The time a subscription package was archived. This Outschool specific column is decoupled from a Stripe product/price being archived, which sometimes need to be active to migrate to/from legacy pricing. */
  archived_at: Date | null;
  created_at: Date;
  /** The approximate price of each credit in cents */
  credit_value: number;
  deleted_at: Date | null;
  /** Number of credits included in this subscription package per billing period */
  num_credits: number;
  /** The monthly cost of this subscription package in USD cents */
  package_cost_cents: number;
  /** Human-readable display name for this subscription package */
  package_name: string;
  /** Stripe Price ID, use this as the unique identifier for a subscription product in Stripe */
  stripe_price_id: string;
  /** Stripe Product ID, should NOT be used as a unique identifier for a subscription package */
  stripe_product_id: string;
  uid: string;
  updated_at: Date;
}
export interface CreateSubscriptionPackagesRow {
  /** The time a subscription package was archived. This Outschool specific column is decoupled from a Stripe product/price being archived, which sometimes need to be active to migrate to/from legacy pricing. */
  archived_at?: Date | null;
  created_at?: Date;
  /** The approximate price of each credit in cents */
  credit_value?: number;
  deleted_at?: Date | null;
  /** Number of credits included in this subscription package per billing period */
  num_credits?: number;
  /** The monthly cost of this subscription package in USD cents */
  package_cost_cents?: number;
  /** Human-readable display name for this subscription package */
  package_name: string;
  /** Stripe Price ID, use this as the unique identifier for a subscription product in Stripe */
  stripe_price_id: string;
  /** Stripe Product ID, should NOT be used as a unique identifier for a subscription package */
  stripe_product_id: string;
  uid?: string;
  updated_at?: Date;
}
/** A Stripe-managed subscription (source of truth is in Stripe, this is just a synced copy) */
export interface SubscriptionsRow {
  attribution: any | null;
  billing_end_at: Date;
  billing_start_at: Date;
  canceled_at: Date | null;
  cancellation_details: any | null;
  created_at: Date;
  current_package_uid: string;
  deleted_at: Date | null;
  /** Time the subscription was paused */
  paused_at: Date | null;
  stripe_subscription_id: string;
  trial_end: Date | null;
  uid: string;
  /** The package that the user is set to upgrade to next (if any) */
  upcoming_package_uid: string | null;
  updated_at: Date;
  user_uid: string;
  /** Time when the subscription will resume after pause */
  will_resume_at: Date | null;
}
export interface CreateSubscriptionsRow {
  attribution?: any | null;
  billing_end_at: Date;
  billing_start_at: Date;
  canceled_at?: Date | null;
  cancellation_details?: any | null;
  created_at?: Date;
  current_package_uid: string;
  deleted_at?: Date | null;
  /** Time the subscription was paused */
  paused_at?: Date | null;
  stripe_subscription_id: string;
  trial_end?: Date | null;
  uid?: string;
  /** The package that the user is set to upgrade to next (if any) */
  upcoming_package_uid?: string | null;
  updated_at?: Date;
  user_uid: string;
  /** Time when the subscription will resume after pause */
  will_resume_at?: Date | null;
}
export interface TeacherActivityStatsRow {
  average_star_rating: string | null;
  fraction_poor_reviews: string | null;
  learners_taught_count: number | null;
  review_rate: string | null;
  reviews_count: string | null;
  reviews_count_90d: string | null;
  reviews_with_text_count: string | null;
  successful_class_count: number | null;
  successful_private_class_count: number | null;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreateTeacherActivityStatsRow {
  average_star_rating?: string | null;
  fraction_poor_reviews?: string | null;
  learners_taught_count?: number | null;
  review_rate?: string | null;
  reviews_count?: string | null;
  reviews_count_90d?: string | null;
  reviews_with_text_count?: string | null;
  successful_class_count?: number | null;
  successful_private_class_count?: number | null;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface TeacherApplicationsRow {
  age_ranges_taught: string[] | null;
  class_subjects: string[] | null;
  class_types: string | null;
  created_at: Date | null;
  deleted_at: Date | null;
  experience_types: string[] | null;
  how_did_you_hear_about_us: string | null;
  legal_name: string | null;
  online_profiles: string | null;
  reviewed_at: Date | null;
  sample_classes: string | null;
  status: string;
  submitted_at: Date | null;
  teaching_credentials: string | null;
  teaching_experience: string | null;
  teaching_motivation: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string;
  video_uid: string | null;
  years_of_experience: string | null;
}
export interface CreateTeacherApplicationsRow {
  age_ranges_taught?: string[] | null;
  class_subjects?: string[] | null;
  class_types?: string | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  experience_types?: string[] | null;
  how_did_you_hear_about_us?: string | null;
  legal_name?: string | null;
  online_profiles?: string | null;
  reviewed_at?: Date | null;
  sample_classes?: string | null;
  status?: string;
  submitted_at?: Date | null;
  teaching_credentials?: string | null;
  teaching_experience?: string | null;
  teaching_motivation?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid: string;
  video_uid?: string | null;
  years_of_experience?: string | null;
}
export interface TeacherAttendancesRow {
  attended_at: Date | null;
  created_at: Date | null;
  deleted_at: Date | null;
  meeting_uid: string;
  teacher_uid: string;
  uid: string;
  updated_at: Date | null;
}
export interface CreateTeacherAttendancesRow {
  attended_at?: Date | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  meeting_uid: string;
  teacher_uid: string;
  uid?: string;
  updated_at?: Date | null;
}
export interface TeacherAttributesRow {
  auto_scheduling_buffer: any;
  created_at: Date;
  deleted_at: Date | null;
  is_active: boolean | null;
  is_auto_scheduling_enabled: boolean;
  main_toolbar_pinned_tabs: string[] | null;
  /** Payout processor for this teacher: stripe, paypal. Defaults to paypal (legacy PayPal payouts) until switched to stripe. */
  payout_processor: string;
  show_calendar: boolean;
  stripe_connected_account_id: string | null;
  /** Stripe event.created of the last processed connected-account event; used for idempotency */
  stripe_connected_account_last_event_created: Date | null;
  stripe_connected_account_status: string;
  teacher_availability: any | null;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateTeacherAttributesRow {
  auto_scheduling_buffer?: any;
  created_at?: Date;
  deleted_at?: Date | null;
  is_active?: boolean | null;
  is_auto_scheduling_enabled?: boolean;
  main_toolbar_pinned_tabs?: string[] | null;
  /** Payout processor for this teacher: stripe, paypal. Defaults to paypal (legacy PayPal payouts) until switched to stripe. */
  payout_processor?: string;
  show_calendar?: boolean;
  stripe_connected_account_id?: string | null;
  /** Stripe event.created of the last processed connected-account event; used for idempotency */
  stripe_connected_account_last_event_created?: Date | null;
  stripe_connected_account_status?: string;
  teacher_availability?: any | null;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface TeacherCredentialsRow {
  certificate_discipline: string | null;
  certificate_does_not_expire: boolean;
  certificate_expire_date: Date | null;
  certificate_issue_date: Date | null;
  certificate_number: string | null;
  certificate_secondary_discipline: string | null;
  certificate_state: string | null;
  created_at: Date;
  credential_type: string;
  degree_additional_info: string | null;
  degree_institution: string | null;
  degree_issue_date: Date | null;
  degree_subject: string | null;
  degree_type: string | null;
  deleted_at: Date | null;
  file: any;
  other_details: string | null;
  other_type: string | null;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateTeacherCredentialsRow {
  certificate_discipline?: string | null;
  certificate_does_not_expire?: boolean;
  certificate_expire_date?: Date | null;
  certificate_issue_date?: Date | null;
  certificate_number?: string | null;
  certificate_secondary_discipline?: string | null;
  certificate_state?: string | null;
  created_at?: Date;
  credential_type: string;
  degree_additional_info?: string | null;
  degree_institution?: string | null;
  degree_issue_date?: Date | null;
  degree_subject?: string | null;
  degree_type?: string | null;
  deleted_at?: Date | null;
  file: any;
  other_details?: string | null;
  other_type?: string | null;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface TeacherFeedbackQuotesRow {
  activity_uid: string | null;
  created_at: Date;
  feedback_uid: string | null;
  feedback_user_name: string | null;
  quote: string | null;
  teacher_uid: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateTeacherFeedbackQuotesRow {
  activity_uid?: string | null;
  created_at?: Date;
  feedback_uid?: string | null;
  feedback_user_name?: string | null;
  quote?: string | null;
  teacher_uid?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface TeacherFeedbackSummaryRow {
  activity_uid: string | null;
  cons: string | null;
  created_at: Date;
  pros: string | null;
  summary_variant: string | null;
  teacher_attributes: string[] | null;
  teacher_uid: string | null;
  uid: string;
  updated_at: Date;
}
export interface CreateTeacherFeedbackSummaryRow {
  activity_uid?: string | null;
  cons?: string | null;
  created_at?: Date;
  pros?: string | null;
  summary_variant?: string | null;
  teacher_attributes?: string[] | null;
  teacher_uid?: string | null;
  uid?: string;
  updated_at?: Date;
}
export interface TeacherMarketingSettingsRow {
  abandoned_cart_auto_message_is_on: boolean;
  abandoned_cart_auto_message_template: string | null;
  ai_action_items_is_on: boolean;
  ai_meeting_summary_is_on: boolean;
  ai_review_summary_is_on: boolean;
  away_mode_enabled: boolean;
  coupon_prefix: string | null;
  created_at: Date;
  deleted_at: Date | null;
  teacher_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateTeacherMarketingSettingsRow {
  abandoned_cart_auto_message_is_on?: boolean;
  abandoned_cart_auto_message_template?: string | null;
  ai_action_items_is_on?: boolean;
  ai_meeting_summary_is_on?: boolean;
  ai_review_summary_is_on?: boolean;
  away_mode_enabled?: boolean;
  coupon_prefix?: string | null;
  created_at?: Date;
  deleted_at?: Date | null;
  teacher_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface TeacherScheduleAvailabilityRow {
  created_at: Date;
  deleted_at: Date | null;
  end_time: Date;
  is_recurring: boolean;
  is_unavailable: boolean | null;
  recurring_end_time: Date | null;
  start_time: Date;
  teacher_schedule_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateTeacherScheduleAvailabilityRow {
  created_at?: Date;
  deleted_at?: Date | null;
  end_time: Date;
  is_recurring: boolean;
  is_unavailable?: boolean | null;
  recurring_end_time?: Date | null;
  start_time: Date;
  teacher_schedule_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface TeacherScheduleEnrollableTimesRow {
  created_at: Date;
  deleted_at: Date | null;
  end_time: Date;
  start_time: Date;
  teacher_schedule_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateTeacherScheduleEnrollableTimesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  end_time: Date;
  start_time: Date;
  teacher_schedule_uid: string;
  uid?: string;
  updated_at?: Date;
}
/** Tracks pending teacher schedule enrollable-time recalculations. */
export interface TeacherScheduleUpdateRequestsRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Time when recalculation for this request completed. */
  processing_completed_at: Date | null;
  /** Time when a worker claimed this recalculation request. */
  processing_started_at: Date | null;
  /** Most recent time a recalculation was requested. */
  requested_at: Date;
  /** Teacher schedule that needs enrollable times recalculated. */
  teacher_schedule_uid: string;
  uid: string;
  updated_at: Date;
}
export interface CreateTeacherScheduleUpdateRequestsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Time when recalculation for this request completed. */
  processing_completed_at?: Date | null;
  /** Time when a worker claimed this recalculation request. */
  processing_started_at?: Date | null;
  /** Most recent time a recalculation was requested. */
  requested_at?: Date;
  /** Teacher schedule that needs enrollable times recalculated. */
  teacher_schedule_uid: string;
  uid?: string;
  updated_at?: Date;
}
export interface TeacherSchedulesRow {
  buffer_time_between_meetings: any;
  created_at: Date;
  deleted_at: Date | null;
  meetings_start_time_increments: any;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateTeacherSchedulesRow {
  buffer_time_between_meetings?: any;
  created_at?: Date;
  deleted_at?: Date | null;
  meetings_start_time_increments?: any;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface TeacherSimilarityRow {
  rank: number;
  score: string;
  similar_teacher_uid: string;
  teacher_uid: string;
}
export interface CreateTeacherSimilarityRow {
  rank: number;
  score: string;
  similar_teacher_uid: string;
  teacher_uid: string;
}
export interface TeacherStatsRow {
  created_at: Date | null;
  deleted_at: Date | null;
  key: string;
  uid: string;
  updated_at: Date | null;
  user_uid: string;
  value: number | null;
}
export interface CreateTeacherStatsRow {
  created_at?: Date | null;
  deleted_at?: Date | null;
  key: string;
  uid?: string;
  updated_at?: Date | null;
  user_uid: string;
  value?: number | null;
}
export interface TeacherTagsRow {
  created_at: Date;
  deleted_at: Date | null;
  key: string;
  uid: string;
  updated_at: Date;
  value: string;
}
export interface CreateTeacherTagsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  key: string;
  uid?: string;
  updated_at?: Date;
  value: string;
}
export interface TeacherTagsAssignedRow {
  created_at: Date;
  deleted_at: Date | null;
  teacher_tag_uid: string;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateTeacherTagsAssignedRow {
  created_at?: Date;
  deleted_at?: Date | null;
  teacher_tag_uid: string;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface TeacherUnavailableBlocksRow {
  created_at: Date | null;
  deleted_at: Date | null;
  end_time: Date | null;
  start_time: Date;
  uid: string;
  updated_at: Date | null;
  user_uid: string;
}
export interface CreateTeacherUnavailableBlocksRow {
  created_at?: Date | null;
  deleted_at?: Date | null;
  end_time?: Date | null;
  start_time: Date;
  uid?: string;
  updated_at?: Date | null;
  user_uid: string;
}
export interface TemporaryTokensRow {
  created_at: Date;
  deleted_at: Date | null;
  expiration_time: Date;
  token: string;
  type: string;
  uid: string;
  updated_at: Date;
}
export interface CreateTemporaryTokensRow {
  created_at?: Date;
  deleted_at?: Date | null;
  expiration_time: Date;
  token: string;
  type: string;
  uid?: string;
  updated_at?: Date;
}
export interface TopicsRow {
  created_at: Date;
  deleted_at: Date | null;
  image_url: string;
  label: string;
  uid: string;
  updated_at: Date;
}
export interface CreateTopicsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  image_url: string;
  label: string;
  uid?: string;
  updated_at?: Date;
}
export interface TrendingSearchTopicsRow {
  num_searches: number;
  search_query: string;
  subject: string;
}
export interface CreateTrendingSearchTopicsRow {
  num_searches: number;
  search_query: string;
  subject: string;
}
export interface TrustPrivilegesRow {
  admin_action_note: string | null;
  admin_action_user: string;
  audit_log: any | null;
  created_at: Date;
  deleted_at: Date | null;
  name: string;
  override_value: string;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateTrustPrivilegesRow {
  admin_action_note?: string | null;
  admin_action_user: string;
  audit_log?: any | null;
  created_at?: Date;
  deleted_at?: Date | null;
  name: string;
  override_value: string;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface UpcomingSectionsRow {
  activity_uid: string | null;
  next_meeting_end_time: Date | null;
  next_meeting_time: Date | null;
  section_uid: string | null;
  updated_at: Date | null;
}
export interface CreateUpcomingSectionsRow {
  activity_uid?: string | null;
  next_meeting_end_time?: Date | null;
  next_meeting_time?: Date | null;
  section_uid?: string | null;
  updated_at?: Date | null;
}
export interface UserChurnIndicatorsRow {
  last_page_view_at: Date | null;
  last_weekly_email_open_at: Date | null;
  updated_at: Date | null;
  user_uid: string;
}
export interface CreateUserChurnIndicatorsRow {
  last_page_view_at?: Date | null;
  last_weekly_email_open_at?: Date | null;
  updated_at?: Date | null;
  user_uid: string;
}
export interface UserEmailPreferencesRow {
  attribution: any | null;
  created_at: Date | null;
  deleted_at: Date | null;
  deletion_attribution: any | null;
  is_enabled: boolean | null;
  name: string | null;
  uid: string;
  updated_at: Date | null;
  user_uid: string | null;
}
export interface CreateUserEmailPreferencesRow {
  attribution?: any | null;
  created_at?: Date | null;
  deleted_at?: Date | null;
  deletion_attribution?: any | null;
  is_enabled?: boolean | null;
  name?: string | null;
  uid?: string;
  updated_at?: Date | null;
  user_uid?: string | null;
}
export interface UserFinancialAssistanceRow {
  application_status: string | null;
  city: string | null;
  covid: boolean | null;
  created_at: Date;
  deleted_at: Date | null;
  hispanic_latino: boolean | null;
  household_size: number | null;
  household_size_3_to_18: number | null;
  how_did_you_hear: string | null;
  income: string | null;
  interested_in_research: boolean | null;
  interested_in_sharing: boolean | null;
  learning_environments: string[] | null;
  lunch: boolean | null;
  name: string | null;
  needs_assistance: boolean | null;
  noschool: boolean | null;
  primary_language: string | null;
  race_ethnicity: string[] | null;
  reliable_internet: boolean | null;
  school_closed: boolean | null;
  state: string | null;
  uid: string;
  updated_at: Date;
  user_uid: string;
  zip_code: string | null;
}
export interface CreateUserFinancialAssistanceRow {
  application_status?: string | null;
  city?: string | null;
  covid?: boolean | null;
  created_at?: Date;
  deleted_at?: Date | null;
  hispanic_latino?: boolean | null;
  household_size?: number | null;
  household_size_3_to_18?: number | null;
  how_did_you_hear?: string | null;
  income?: string | null;
  interested_in_research?: boolean | null;
  interested_in_sharing?: boolean | null;
  learning_environments?: string[] | null;
  lunch?: boolean | null;
  name?: string | null;
  needs_assistance?: boolean | null;
  noschool?: boolean | null;
  primary_language?: string | null;
  race_ethnicity?: string[] | null;
  reliable_internet?: boolean | null;
  school_closed?: boolean | null;
  state?: string | null;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
  zip_code?: string | null;
}
export interface UserIncidentsRow {
  action: string | null;
  category: string | null;
  created_at: Date;
  created_by_user_uid: string | null;
  deleted_at: Date | null;
  expired: boolean;
  expires_at: Date | null;
  link: string | null;
  notes: string | null;
  points: number | null;
  side_effects_failed_at: Date | null;
  uid: string;
  updated_at: Date;
  user_incidents_summary_uid: string | null;
  user_uid: string | null;
}
export interface CreateUserIncidentsRow {
  action?: string | null;
  category?: string | null;
  created_at?: Date;
  created_by_user_uid?: string | null;
  deleted_at?: Date | null;
  expired?: boolean;
  expires_at?: Date | null;
  link?: string | null;
  notes?: string | null;
  points?: number | null;
  side_effects_failed_at?: Date | null;
  uid?: string;
  updated_at?: Date;
  user_incidents_summary_uid?: string | null;
  user_uid?: string | null;
}
export interface UserIncidentsSummariesRow {
  created_at: Date;
  deleted_at: Date | null;
  total_points: number;
  type: string;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateUserIncidentsSummariesRow {
  created_at?: Date;
  deleted_at?: Date | null;
  total_points?: number;
  type: string;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
export interface UserLoginAttemptsLogRow {
  auth_type: string;
  created_at: Date;
  deleted_at: Date | null;
  ip_address: string;
  learner_uid: string | null;
  uid: string;
  updated_at: Date;
  user_agent: string;
  user_uid: string;
  was_successful: boolean;
}
export interface CreateUserLoginAttemptsLogRow {
  auth_type?: string;
  created_at?: Date;
  deleted_at?: Date | null;
  ip_address: string;
  learner_uid?: string | null;
  uid?: string;
  updated_at?: Date;
  user_agent?: string;
  user_uid: string;
  was_successful?: boolean;
}
export interface UserPricingOffersRow {
  created_at: Date;
  deleted_at: Date | null;
  pricing_offer_uid: string;
  uid: string;
  updated_at: Date;
  user_uid: string;
}
export interface CreateUserPricingOffersRow {
  created_at?: Date;
  deleted_at?: Date | null;
  pricing_offer_uid: string;
  uid?: string;
  updated_at?: Date;
  user_uid: string;
}
/** A non-learner user identity. Could be a parent and/or teacher (leader_subscribed_at is non-null) and/or admin (is_admin is true) */
export interface UsersRow {
  activity_format_description_flex_hidden_at: Date | null;
  activity_format_description_multi_day_hidden_at: Date | null;
  activity_format_description_one_time_hidden_at: Date | null;
  activity_format_description_ongoing_hidden_at: Date | null;
  admin_for_charter_school_uid: string | null;
  admin_for_organization_uid: string | null;
  approved_learner_signup_at: Date | null;
  attribution: any | null;
  /** Date the most recent background check was started */
  background_check_started_at: Date | null;
  /** Date the most recent background check was completed (this needs to be combined with an expiration period to see if the check is still valid) */
  background_checked_at: Date | null;
  /** Two-letter country code (ISO 3166-1 alpha-2).  Currently only US and CA are taxed. */
  billing_country: string | null;
  /** ZIP or postal code.  Required for US addresses to calculate sales tax. */
  billing_postal_code: string | null;
  /** Surfaces if automatic tax computation is possible given the current customer location information.  Corresponds to the field &#x60;tax.automatic_tax&#x60; in the Stripe customer object. */
  billing_tax_status: string | null;
  calendar_uid: string | null;
  chaperone_required: boolean | null;
  classroom_trained_at: Date | null;
  classroom_training_scheduled_at: Date | null;
  confirmed_at: Date | null;
  consent_to_share_class_history: boolean | null;
  consent_to_share_favourites: boolean | null;
  consented_to_coppa_notice_at: Date | null;
  /** Date the user was created */
  created_at: Date | null;
  default_currency: string | null;
  default_schedule_filters: any;
  deleted_at: Date | null;
  derived_key: any | null;
  /** JSON object with miscellaneous user-related data. Avoid adding new properties to this - use a new column instead */
  details: any | null;
  do_not_sell_my_personal_info: boolean;
  educator_name: string | null;
  educator_name_source: string | null;
  educator_name_updated_at: Date | null;
  email: string;
  email_bounced_at: Date | null;
  email_settings_uid: string;
  email_updated_at: Date | null;
  interview_scheduled_at: Date | null;
  interviewed_at: Date | null;
  is_admin: boolean;
  is_crosslister: boolean | null;
  leader_link: string | null;
  /** Date the user signed up to be a teacher */
  leader_subscribed_at: Date | null;
  learner_mode_switch_auth_requirement: string | null;
  learner_uses_parent_mode: boolean;
  learners_verified_at: Date | null;
  locale: string | null;
  location: any | null;
  name: string | null;
  number_of_merges: number | null;
  /** If set, this user is treated as the abstraction of a group of teachers (mutually exclusive with teacher_for_seller_org_user_uid) */
  owner_of_seller_org_uid: string | null;
  payout_email: string | null;
  payout_email_updated_at: Date | null;
  phone: string | null;
  photo: string | null;
  /** Attachment with the profile photo for this user */
  photo_uid: string | null;
  privacy_state: string | null;
  profile_link_uid: string | null;
  pw_updated_at: Date | null;
  race_ethnicity: string | null;
  recording_autopost_enabled_at: Date | null;
  recording_autopost_updated_at: Date | null;
  roles: string[] | null;
  salt: any | null;
  scheduled_removal_at: Date | null;
  seller_org_admin_teacher_account_uid: string | null;
  signup_initiator: string | null;
  skilljar_user_id: string | null;
  slug_id: string;
  stripe_customer_id: string | null;
  subscribed_at: Date | null;
  suspended_at: Date | null;
  suspended_reason: string | null;
  /** Date the user was last approved as a teacher */
  teacher_approved_at: Date | null;
  /** The teacher&#x27;s availability for scheduling as a JSON object like {hourlyTimetable: {mon: [7, 8, 9], ...}} */
  teacher_availability: any | null;
  teacher_featured_at: Date | null;
  /** If set, this user is treated as a teacher for the given seller org (mutually exclusive with owner_of_seller_org_uid) */
  teacher_for_seller_org_user_uid: string | null;
  uid: string;
  unsubscribed_at: Date | null;
  updated_at: Date | null;
  /** Teacher profile video attachment */
  video_uid: string | null;
}
export interface CreateUsersRow {
  activity_format_description_flex_hidden_at?: Date | null;
  activity_format_description_multi_day_hidden_at?: Date | null;
  activity_format_description_one_time_hidden_at?: Date | null;
  activity_format_description_ongoing_hidden_at?: Date | null;
  admin_for_charter_school_uid?: string | null;
  admin_for_organization_uid?: string | null;
  approved_learner_signup_at?: Date | null;
  attribution?: any | null;
  /** Date the most recent background check was started */
  background_check_started_at?: Date | null;
  /** Date the most recent background check was completed (this needs to be combined with an expiration period to see if the check is still valid) */
  background_checked_at?: Date | null;
  /** Two-letter country code (ISO 3166-1 alpha-2).  Currently only US and CA are taxed. */
  billing_country?: string | null;
  /** ZIP or postal code.  Required for US addresses to calculate sales tax. */
  billing_postal_code?: string | null;
  /** Surfaces if automatic tax computation is possible given the current customer location information.  Corresponds to the field &#x60;tax.automatic_tax&#x60; in the Stripe customer object. */
  billing_tax_status?: string | null;
  calendar_uid?: string | null;
  chaperone_required?: boolean | null;
  classroom_trained_at?: Date | null;
  classroom_training_scheduled_at?: Date | null;
  confirmed_at?: Date | null;
  consent_to_share_class_history?: boolean | null;
  consent_to_share_favourites?: boolean | null;
  consented_to_coppa_notice_at?: Date | null;
  /** Date the user was created */
  created_at?: Date | null;
  default_currency?: string | null;
  default_schedule_filters?: any;
  deleted_at?: Date | null;
  derived_key?: any | null;
  /** JSON object with miscellaneous user-related data. Avoid adding new properties to this - use a new column instead */
  details?: any | null;
  do_not_sell_my_personal_info?: boolean;
  educator_name?: string | null;
  educator_name_source?: string | null;
  educator_name_updated_at?: Date | null;
  email: string;
  email_bounced_at?: Date | null;
  email_settings_uid?: string;
  email_updated_at?: Date | null;
  interview_scheduled_at?: Date | null;
  interviewed_at?: Date | null;
  is_admin?: boolean;
  is_crosslister?: boolean | null;
  leader_link?: string | null;
  /** Date the user signed up to be a teacher */
  leader_subscribed_at?: Date | null;
  learner_mode_switch_auth_requirement?: string | null;
  learner_uses_parent_mode?: boolean;
  learners_verified_at?: Date | null;
  locale?: string | null;
  location?: any | null;
  name?: string | null;
  number_of_merges?: number | null;
  /** If set, this user is treated as the abstraction of a group of teachers (mutually exclusive with teacher_for_seller_org_user_uid) */
  owner_of_seller_org_uid?: string | null;
  payout_email?: string | null;
  payout_email_updated_at?: Date | null;
  phone?: string | null;
  photo?: string | null;
  /** Attachment with the profile photo for this user */
  photo_uid?: string | null;
  privacy_state?: string | null;
  profile_link_uid?: string | null;
  pw_updated_at?: Date | null;
  race_ethnicity?: string | null;
  recording_autopost_enabled_at?: Date | null;
  recording_autopost_updated_at?: Date | null;
  roles?: string[] | null;
  salt?: any | null;
  scheduled_removal_at?: Date | null;
  seller_org_admin_teacher_account_uid?: string | null;
  signup_initiator?: string | null;
  skilljar_user_id?: string | null;
  slug_id?: string;
  stripe_customer_id?: string | null;
  subscribed_at?: Date | null;
  suspended_at?: Date | null;
  suspended_reason?: string | null;
  /** Date the user was last approved as a teacher */
  teacher_approved_at?: Date | null;
  /** The teacher&#x27;s availability for scheduling as a JSON object like {hourlyTimetable: {mon: [7, 8, 9], ...}} */
  teacher_availability?: any | null;
  teacher_featured_at?: Date | null;
  /** If set, this user is treated as a teacher for the given seller org (mutually exclusive with owner_of_seller_org_uid) */
  teacher_for_seller_org_user_uid?: string | null;
  uid?: string;
  unsubscribed_at?: Date | null;
  updated_at?: Date | null;
  /** Teacher profile video attachment */
  video_uid?: string | null;
}
export interface WaitlistSeatsRow {
  created_at: Date;
  deleted_at: Date | null;
  enrollment_uid: string | null;
  learner_uid: string;
  parent_uid: string;
  section_uid: string;
  uid: string;
  updated_at: Date;
  waitlist_source: string | null;
}
export interface CreateWaitlistSeatsRow {
  created_at?: Date;
  deleted_at?: Date | null;
  enrollment_uid?: string | null;
  learner_uid: string;
  parent_uid: string;
  section_uid: string;
  uid?: string;
  updated_at?: Date;
  waitlist_source?: string | null;
}
export interface ZoomMeetingsRow {
  created_at: Date | null;
  deleted_at: Date | null;
  details: any | null;
  join_url: string | null;
  section_uid: string | null;
  uid: string;
  updated_at: Date | null;
  zoom_id: string | null;
  zoom_recordings_synced_at: Date | null;
  zoom_user_id: string | null;
}
export interface CreateZoomMeetingsRow {
  created_at?: Date | null;
  deleted_at?: Date | null;
  details?: any | null;
  join_url?: string | null;
  section_uid?: string | null;
  uid?: string;
  updated_at?: Date | null;
  zoom_id?: string | null;
  zoom_recordings_synced_at?: Date | null;
  zoom_user_id?: string | null;
}
export interface ZoomRecordingsRow {
  created_at: Date | null;
  deleted_at: Date | null;
  play_url: string;
  recording_ended_at: Date;
  recording_started_at: Date;
  recording_type: string | null;
  section_uid: string;
  status: string | null;
  uid: string;
  updated_at: Date | null;
  zoom_recording_id: string;
  zoom_response: any | null;
}
export interface CreateZoomRecordingsRow {
  created_at?: Date | null;
  deleted_at?: Date | null;
  play_url: string;
  recording_ended_at: Date;
  recording_started_at: Date;
  recording_type?: string | null;
  section_uid: string;
  status?: string | null;
  uid?: string;
  updated_at?: Date | null;
  zoom_recording_id: string;
  zoom_response?: any | null;
}
export interface ZoomUsersRow {
  created_at: Date;
  deleted_at: Date | null;
  /** Reference uid of learners table */
  learner_uid: string | null;
  uid: string;
  updated_at: Date;
  /** Zoom user ID from Zoom API */
  zoom_user_id: string | null;
}
export interface CreateZoomUsersRow {
  created_at?: Date;
  deleted_at?: Date | null;
  /** Reference uid of learners table */
  learner_uid?: string | null;
  uid?: string;
  updated_at?: Date;
  /** Zoom user ID from Zoom API */
  zoom_user_id?: string | null;
}
export enum refund_policy {
  variable = "variable",
  limited = "limited",
  moderate = "moderate",
  flexible = "flexible",
}
export enum guided_catalog_subscription_interval {
  day = "day",
  week = "week",
  month = "month",
  year = "year",
}
export enum guided_catalog_product_type {
  class = "class",
  community = "community",
  curriculum_resource = "curriculum_resource",
  classroom_supply = "classroom_supply",
}
export enum guided_catalog_price_unit {
  session = "session",
  hour = "hour",
  item = "item",
  learner = "learner",
}
export enum guided_catalog_price_model {
  fixed = "fixed",
  per_unit = "per_unit",
  subscription = "subscription",
}
export enum guided_catalog_pedagogy {
  montessori = "montessori",
  waldorf = "waldorf",
  charlotte_mason = "charlotte_mason",
  classical = "classical",
  science_of_reading = "science_of_reading",
  orton_gillingham = "orton_gillingham",
  adaptive_learning = "adaptive_learning",
  game_based = "game_based",
  project_based = "project_based",
  mastery_based = "mastery_based",
  multisensory = "multisensory",
  hands_on = "hands_on",
  play_based = "play_based",
  singapore_math = "singapore_math",
  concrete_pictorial_abstract = "concrete_pictorial_abstract",
  interest_led = "interest_led",
  place_based = "place_based",
  knowledge_space = "knowledge_space",
  backward_design = "backward_design",
  spiral_curriculum = "spiral_curriculum",
  presume_competence = "presume_competence",
  trauma_informed = "trauma_informed",
  experiential = "experiential",
  outcome_based = "outcome_based",
}
export enum guided_catalog_ingestion_trigger_source {
  scheduled = "scheduled",
  operator = "operator",
}
export enum guided_catalog_ingestion_run_status {
  queued = "queued",
  running = "running",
  completed = "completed",
  failed = "failed",
}
export enum guided_catalog_ingestion_method {
  scrape_web = "scrape_web",
  remote_csv_file = "remote_csv_file",
  vendor_api = "vendor_api",
  manual = "manual",
}
export enum guided_catalog_funding_rule_set_status {
  draft = "draft",
  published = "published",
  archived = "archived",
}
export enum guided_catalog_eligibility_status {
  guaranteed = "guaranteed",
  likely = "likely",
  partial = "partial",
  unknown = "unknown",
  ineligible = "ineligible",
}
export enum guided_catalog_eligibility_source {
  rules_engine = "rules_engine",
  vendor_attestation = "vendor_attestation",
  manual_review = "manual_review",
  document_supported = "document_supported",
}
export enum guided_catalog_eligibility_document_type {
  state_policy = "state_policy",
  vendor_attestation = "vendor_attestation",
  approved_list = "approved_list",
  program_handbook = "program_handbook",
  manual_review = "manual_review",
}
export enum guided_catalog_delivery_format {
  live_online = "live_online",
  live_in_person = "live_in_person",
  self_paced_online = "self_paced_online",
  physical_shipment = "physical_shipment",
}
export enum english_proficiency_level {
  A0 = "A0",
  A05 = "A05",
  PRE_A1 = "PRE_A1",
  A1 = "A1",
  A2 = "A2",
  B1 = "B1",
  B2 = "B2",
}

declare module "knex/types/tables" {
  interface Tables {
    activities: Knex.CompositeTableType<
      ActivitiesRow,
      Knex.MaybeRawRecord<CreateActivitiesRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivitiesRow, "uid">>>
    >;
    activities_as_search_document: Knex.CompositeTableType<
      ActivitiesAsSearchDocumentRow,
      Knex.MaybeRawRecord<CreateActivitiesAsSearchDocumentRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivitiesAsSearchDocumentRow, "uid">>>
    >;
    activity_actions: Knex.CompositeTableType<
      ActivityActionsRow,
      Knex.MaybeRawRecord<CreateActivityActionsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivityActionsRow, "uid">>>
    >;
    activity_external_resources: Knex.CompositeTableType<
      ActivityExternalResourcesRow,
      Knex.MaybeRawRecord<CreateActivityExternalResourcesRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivityExternalResourcesRow, "uid">>>
    >;
    activity_gtins: Knex.CompositeTableType<
      ActivityGtinsRow,
      Knex.MaybeRawRecord<CreateActivityGtinsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivityGtinsRow, "uid">>>
    >;
    activity_leader_funding_eligibilities: Knex.CompositeTableType<
      ActivityLeaderFundingEligibilitiesRow,
      Knex.MaybeRawRecord<CreateActivityLeaderFundingEligibilitiesRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<ActivityLeaderFundingEligibilitiesRow, "uid">>
      >
    >;
    activity_potential_funding_eligibilities: Knex.CompositeTableType<
      ActivityPotentialFundingEligibilitiesRow,
      Knex.MaybeRawRecord<CreateActivityPotentialFundingEligibilitiesRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<ActivityPotentialFundingEligibilitiesRow, "uid">>
      >
    >;
    activity_schedule_settings: Knex.CompositeTableType<
      ActivityScheduleSettingsRow,
      Knex.MaybeRawRecord<CreateActivityScheduleSettingsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivityScheduleSettingsRow, "uid">>>
    >;
    activity_scores: Knex.CompositeTableType<
      ActivityScoresRow,
      Knex.MaybeRawRecord<CreateActivityScoresRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivityScoresRow, "uid">>>
    >;
    activity_similarity: Knex.CompositeTableType<
      ActivitySimilarityRow,
      Knex.MaybeRawRecord<CreateActivitySimilarityRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivitySimilarityRow, "uid">>>
    >;
    activity_stats: Knex.CompositeTableType<
      ActivityStatsRow,
      Knex.MaybeRawRecord<CreateActivityStatsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivityStatsRow, "uid">>>
    >;
    activity_tags: Knex.CompositeTableType<
      ActivityTagsRow,
      Knex.MaybeRawRecord<CreateActivityTagsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivityTagsRow, "uid">>>
    >;
    activity_topics: Knex.CompositeTableType<
      ActivityTopicsRow,
      Knex.MaybeRawRecord<CreateActivityTopicsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivityTopicsRow, "uid">>>
    >;
    activity_translations: Knex.CompositeTableType<
      ActivityTranslationsRow,
      Knex.MaybeRawRecord<CreateActivityTranslationsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ActivityTranslationsRow, "uid">>>
    >;
    admin_enrollment_payment_refund_actions: Knex.CompositeTableType<
      AdminEnrollmentPaymentRefundActionsRow,
      Knex.MaybeRawRecord<CreateAdminEnrollmentPaymentRefundActionsRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<AdminEnrollmentPaymentRefundActionsRow, "uid">>
      >
    >;
    admin_user_actions: Knex.CompositeTableType<
      AdminUserActionsRow,
      Knex.MaybeRawRecord<CreateAdminUserActionsRow>,
      Knex.MaybeRawRecord<Partial<Omit<AdminUserActionsRow, "uid">>>
    >;
    admin_user_roles: Knex.CompositeTableType<
      AdminUserRolesRow,
      Knex.MaybeRawRecord<CreateAdminUserRolesRow>,
      Knex.MaybeRawRecord<Partial<Omit<AdminUserRolesRow, "uid">>>
    >;
    agreement_templates: Knex.CompositeTableType<
      AgreementTemplatesRow,
      Knex.MaybeRawRecord<CreateAgreementTemplatesRow>,
      Knex.MaybeRawRecord<Partial<Omit<AgreementTemplatesRow, "uid">>>
    >;
    ai_activity_listing_summaries: Knex.CompositeTableType<
      AiActivityListingSummariesRow,
      Knex.MaybeRawRecord<CreateAiActivityListingSummariesRow>,
      Knex.MaybeRawRecord<Partial<Omit<AiActivityListingSummariesRow, "uid">>>
    >;
    apple_attestations: Knex.CompositeTableType<
      AppleAttestationsRow,
      Knex.MaybeRawRecord<CreateAppleAttestationsRow>,
      Knex.MaybeRawRecord<Partial<Omit<AppleAttestationsRow, "uid">>>
    >;
    apple_users: Knex.CompositeTableType<
      AppleUsersRow,
      Knex.MaybeRawRecord<CreateAppleUsersRow>,
      Knex.MaybeRawRecord<Partial<Omit<AppleUsersRow, "uid">>>
    >;
    attachment_conversions: Knex.CompositeTableType<
      AttachmentConversionsRow,
      Knex.MaybeRawRecord<CreateAttachmentConversionsRow>,
      Knex.MaybeRawRecord<Partial<Omit<AttachmentConversionsRow, "uid">>>
    >;
    attachments: Knex.CompositeTableType<
      AttachmentsRow,
      Knex.MaybeRawRecord<CreateAttachmentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<AttachmentsRow, "uid">>>
    >;
    attendances: Knex.CompositeTableType<
      AttendancesRow,
      Knex.MaybeRawRecord<CreateAttendancesRow>,
      Knex.MaybeRawRecord<Partial<Omit<AttendancesRow, "uid">>>
    >;
    bundle_elements: Knex.CompositeTableType<
      BundleElementsRow,
      Knex.MaybeRawRecord<CreateBundleElementsRow>,
      Knex.MaybeRawRecord<Partial<Omit<BundleElementsRow, "uid">>>
    >;
    bundles: Knex.CompositeTableType<
      BundlesRow,
      Knex.MaybeRawRecord<CreateBundlesRow>,
      Knex.MaybeRawRecord<Partial<Omit<BundlesRow, "uid">>>
    >;
    categories: Knex.CompositeTableType<
      CategoriesRow,
      Knex.MaybeRawRecord<CreateCategoriesRow>,
      Knex.MaybeRawRecord<Partial<Omit<CategoriesRow, "uid">>>
    >;
    category_actions: Knex.CompositeTableType<
      CategoryActionsRow,
      Knex.MaybeRawRecord<CreateCategoryActionsRow>,
      Knex.MaybeRawRecord<Partial<Omit<CategoryActionsRow, "uid">>>
    >;
    category_relationships: Knex.CompositeTableType<
      CategoryRelationshipsRow,
      Knex.MaybeRawRecord<CreateCategoryRelationshipsRow>,
      Knex.MaybeRawRecord<Partial<Omit<CategoryRelationshipsRow, "uid">>>
    >;
    charter_schools: Knex.CompositeTableType<
      CharterSchoolsRow,
      Knex.MaybeRawRecord<CreateCharterSchoolsRow>,
      Knex.MaybeRawRecord<Partial<Omit<CharterSchoolsRow, "uid">>>
    >;
    class_inquiries: Knex.CompositeTableType<
      ClassInquiriesRow,
      Knex.MaybeRawRecord<CreateClassInquiriesRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClassInquiriesRow, "uid">>>
    >;
    class_inquiry_teachers: Knex.CompositeTableType<
      ClassInquiryTeachersRow,
      Knex.MaybeRawRecord<CreateClassInquiryTeachersRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClassInquiryTeachersRow, "uid">>>
    >;
    class_post_comments: Knex.CompositeTableType<
      ClassPostCommentsRow,
      Knex.MaybeRawRecord<CreateClassPostCommentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClassPostCommentsRow, "uid">>>
    >;
    class_post_learner_state: Knex.CompositeTableType<
      ClassPostLearnerStateRow,
      Knex.MaybeRawRecord<CreateClassPostLearnerStateRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClassPostLearnerStateRow, "uid">>>
    >;
    class_post_scores: Knex.CompositeTableType<
      ClassPostScoresRow,
      Knex.MaybeRawRecord<CreateClassPostScoresRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClassPostScoresRow, "uid">>>
    >;
    class_posts: Knex.CompositeTableType<
      ClassPostsRow,
      Knex.MaybeRawRecord<CreateClassPostsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClassPostsRow, "uid">>>
    >;
    class_recording_insights: Knex.CompositeTableType<
      ClassRecordingInsightsRow,
      Knex.MaybeRawRecord<CreateClassRecordingInsightsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClassRecordingInsightsRow, "uid">>>
    >;
    class_recordings: Knex.CompositeTableType<
      ClassRecordingsRow,
      Knex.MaybeRawRecord<CreateClassRecordingsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClassRecordingsRow, "uid">>>
    >;
    class_requests: Knex.CompositeTableType<
      ClassRequestsRow,
      Knex.MaybeRawRecord<CreateClassRequestsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClassRequestsRow, "uid">>>
    >;
    class_schedule_requests: Knex.CompositeTableType<
      ClassScheduleRequestsRow,
      Knex.MaybeRawRecord<CreateClassScheduleRequestsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClassScheduleRequestsRow, "uid">>>
    >;
    club_attributes: Knex.CompositeTableType<
      ClubAttributesRow,
      Knex.MaybeRawRecord<CreateClubAttributesRow>,
      Knex.MaybeRawRecord<Partial<Omit<ClubAttributesRow, "uid">>>
    >;
    coupon_activity_constraints: Knex.CompositeTableType<
      CouponActivityConstraintsRow,
      Knex.MaybeRawRecord<CreateCouponActivityConstraintsRow>,
      Knex.MaybeRawRecord<Partial<Omit<CouponActivityConstraintsRow, "uid">>>
    >;
    coupon_codes: Knex.CompositeTableType<
      CouponCodesRow,
      Knex.MaybeRawRecord<CreateCouponCodesRow>,
      Knex.MaybeRawRecord<Partial<Omit<CouponCodesRow, "uid">>>
    >;
    coupons: Knex.CompositeTableType<
      CouponsRow,
      Knex.MaybeRawRecord<CreateCouponsRow>,
      Knex.MaybeRawRecord<Partial<Omit<CouponsRow, "uid">>>
    >;
    credit_accounts: Knex.CompositeTableType<
      CreditAccountsRow,
      Knex.MaybeRawRecord<CreateCreditAccountsRow>,
      Knex.MaybeRawRecord<Partial<Omit<CreditAccountsRow, "uid">>>
    >;
    credit_purchase_refunds: Knex.CompositeTableType<
      CreditPurchaseRefundsRow,
      Knex.MaybeRawRecord<CreateCreditPurchaseRefundsRow>,
      Knex.MaybeRawRecord<Partial<Omit<CreditPurchaseRefundsRow, "uid">>>
    >;
    credit_purchases: Knex.CompositeTableType<
      CreditPurchasesRow,
      Knex.MaybeRawRecord<CreateCreditPurchasesRow>,
      Knex.MaybeRawRecord<Partial<Omit<CreditPurchasesRow, "uid">>>
    >;
    credit_transactions: Knex.CompositeTableType<
      CreditTransactionsRow,
      Knex.MaybeRawRecord<CreateCreditTransactionsRow>,
      Knex.MaybeRawRecord<Partial<Omit<CreditTransactionsRow, "uid">>>
    >;
    currency_exchange_rates: Knex.CompositeTableType<
      CurrencyExchangeRatesRow,
      Knex.MaybeRawRecord<CreateCurrencyExchangeRatesRow>,
      Knex.MaybeRawRecord<Partial<Omit<CurrencyExchangeRatesRow, "uid">>>
    >;
    deletion_log: Knex.CompositeTableType<
      DeletionLogRow,
      Knex.MaybeRawRecord<CreateDeletionLogRow>,
      Knex.MaybeRawRecord<Partial<Omit<DeletionLogRow, "uid">>>
    >;
    dim_educator_users: Knex.CompositeTableType<
      DimEducatorUsersRow,
      Knex.MaybeRawRecord<CreateDimEducatorUsersRow>,
      Knex.MaybeRawRecord<Partial<Omit<DimEducatorUsersRow, "uid">>>
    >;
    directory_membership: Knex.CompositeTableType<
      DirectoryMembershipRow,
      Knex.MaybeRawRecord<CreateDirectoryMembershipRow>,
      Knex.MaybeRawRecord<Partial<Omit<DirectoryMembershipRow, "uid">>>
    >;
    donations: Knex.CompositeTableType<
      DonationsRow,
      Knex.MaybeRawRecord<CreateDonationsRow>,
      Knex.MaybeRawRecord<Partial<Omit<DonationsRow, "uid">>>
    >;
    enrollment_class_wallet_funding_leaders: Knex.CompositeTableType<
      EnrollmentClassWalletFundingLeadersRow,
      Knex.MaybeRawRecord<CreateEnrollmentClassWalletFundingLeadersRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<EnrollmentClassWalletFundingLeadersRow, "uid">>
      >
    >;
    enrollment_meeting_purchases: Knex.CompositeTableType<
      EnrollmentMeetingPurchasesRow,
      Knex.MaybeRawRecord<CreateEnrollmentMeetingPurchasesRow>,
      Knex.MaybeRawRecord<Partial<Omit<EnrollmentMeetingPurchasesRow, "uid">>>
    >;
    enrollment_pause_windows: Knex.CompositeTableType<
      EnrollmentPauseWindowsRow,
      Knex.MaybeRawRecord<CreateEnrollmentPauseWindowsRow>,
      Knex.MaybeRawRecord<Partial<Omit<EnrollmentPauseWindowsRow, "uid">>>
    >;
    enrollment_payment_refunds: Knex.CompositeTableType<
      EnrollmentPaymentRefundsRow,
      Knex.MaybeRawRecord<CreateEnrollmentPaymentRefundsRow>,
      Knex.MaybeRawRecord<Partial<Omit<EnrollmentPaymentRefundsRow, "uid">>>
    >;
    enrollment_payments: Knex.CompositeTableType<
      EnrollmentPaymentsRow,
      Knex.MaybeRawRecord<CreateEnrollmentPaymentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<EnrollmentPaymentsRow, "uid">>>
    >;
    enrollments: Knex.CompositeTableType<
      EnrollmentsRow,
      Knex.MaybeRawRecord<CreateEnrollmentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<EnrollmentsRow, "uid">>>
    >;
    entity_attributes: Knex.CompositeTableType<
      EntityAttributesRow,
      Knex.MaybeRawRecord<CreateEntityAttributesRow>,
      Knex.MaybeRawRecord<Partial<Omit<EntityAttributesRow, "uid">>>
    >;
    entity_availabilities: Knex.CompositeTableType<
      EntityAvailabilitiesRow,
      Knex.MaybeRawRecord<CreateEntityAvailabilitiesRow>,
      Knex.MaybeRawRecord<Partial<Omit<EntityAvailabilitiesRow, "uid">>>
    >;
    entity_availability_schedules: Knex.CompositeTableType<
      EntityAvailabilitySchedulesRow,
      Knex.MaybeRawRecord<CreateEntityAvailabilitySchedulesRow>,
      Knex.MaybeRawRecord<Partial<Omit<EntityAvailabilitySchedulesRow, "uid">>>
    >;
    esa_memberships: Knex.CompositeTableType<
      EsaMembershipsRow,
      Knex.MaybeRawRecord<CreateEsaMembershipsRow>,
      Knex.MaybeRawRecord<Partial<Omit<EsaMembershipsRow, "uid">>>
    >;
    experiment_overrides: Knex.CompositeTableType<
      ExperimentOverridesRow,
      Knex.MaybeRawRecord<CreateExperimentOverridesRow>,
      Knex.MaybeRawRecord<Partial<Omit<ExperimentOverridesRow, "uid">>>
    >;
    experiments: Knex.CompositeTableType<
      ExperimentsRow,
      Knex.MaybeRawRecord<CreateExperimentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ExperimentsRow, "uid">>>
    >;
    external_activities: Knex.CompositeTableType<
      ExternalActivitiesRow,
      Knex.MaybeRawRecord<CreateExternalActivitiesRow>,
      Knex.MaybeRawRecord<Partial<Omit<ExternalActivitiesRow, "uid">>>
    >;
    external_resource_policies: Knex.CompositeTableType<
      ExternalResourcePoliciesRow,
      Knex.MaybeRawRecord<CreateExternalResourcePoliciesRow>,
      Knex.MaybeRawRecord<Partial<Omit<ExternalResourcePoliciesRow, "uid">>>
    >;
    facebook_users: Knex.CompositeTableType<
      FacebookUsersRow,
      Knex.MaybeRawRecord<CreateFacebookUsersRow>,
      Knex.MaybeRawRecord<Partial<Omit<FacebookUsersRow, "uid">>>
    >;
    failed_content_security_checks: Knex.CompositeTableType<
      FailedContentSecurityChecksRow,
      Knex.MaybeRawRecord<CreateFailedContentSecurityChecksRow>,
      Knex.MaybeRawRecord<Partial<Omit<FailedContentSecurityChecksRow, "uid">>>
    >;
    failed_inbound_messages: Knex.CompositeTableType<
      FailedInboundMessagesRow,
      Knex.MaybeRawRecord<CreateFailedInboundMessagesRow>,
      Knex.MaybeRawRecord<Partial<Omit<FailedInboundMessagesRow, "uid">>>
    >;
    failed_outbound_messages: Knex.CompositeTableType<
      FailedOutboundMessagesRow,
      Knex.MaybeRawRecord<CreateFailedOutboundMessagesRow>,
      Knex.MaybeRawRecord<Partial<Omit<FailedOutboundMessagesRow, "uid">>>
    >;
    feedback: Knex.CompositeTableType<
      FeedbackRow,
      Knex.MaybeRawRecord<CreateFeedbackRow>,
      Knex.MaybeRawRecord<Partial<Omit<FeedbackRow, "uid">>>
    >;
    feedback_votes: Knex.CompositeTableType<
      FeedbackVotesRow,
      Knex.MaybeRawRecord<CreateFeedbackVotesRow>,
      Knex.MaybeRawRecord<Partial<Omit<FeedbackVotesRow, "uid">>>
    >;
    filestack_metadata: Knex.CompositeTableType<
      FilestackMetadataRow,
      Knex.MaybeRawRecord<CreateFilestackMetadataRow>,
      Knex.MaybeRawRecord<Partial<Omit<FilestackMetadataRow, "uid">>>
    >;
    filestack_migration_attachments: Knex.CompositeTableType<
      FilestackMigrationAttachmentsRow,
      Knex.MaybeRawRecord<CreateFilestackMigrationAttachmentsRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<FilestackMigrationAttachmentsRow, "uid">>
      >
    >;
    filestack_migration_users: Knex.CompositeTableType<
      FilestackMigrationUsersRow,
      Knex.MaybeRawRecord<CreateFilestackMigrationUsersRow>,
      Knex.MaybeRawRecord<Partial<Omit<FilestackMigrationUsersRow, "uid">>>
    >;
    followed_users: Knex.CompositeTableType<
      FollowedUsersRow,
      Knex.MaybeRawRecord<CreateFollowedUsersRow>,
      Knex.MaybeRawRecord<Partial<Omit<FollowedUsersRow, "uid">>>
    >;
    friend_requests: Knex.CompositeTableType<
      FriendRequestsRow,
      Knex.MaybeRawRecord<CreateFriendRequestsRow>,
      Knex.MaybeRawRecord<Partial<Omit<FriendRequestsRow, "uid">>>
    >;
    friendships: Knex.CompositeTableType<
      FriendshipsRow,
      Knex.MaybeRawRecord<CreateFriendshipsRow>,
      Knex.MaybeRawRecord<Partial<Omit<FriendshipsRow, "uid">>>
    >;
    funding_program_invoices: Knex.CompositeTableType<
      FundingProgramInvoicesRow,
      Knex.MaybeRawRecord<CreateFundingProgramInvoicesRow>,
      Knex.MaybeRawRecord<Partial<Omit<FundingProgramInvoicesRow, "uid">>>
    >;
    funding_program_versions: Knex.CompositeTableType<
      FundingProgramVersionsRow,
      Knex.MaybeRawRecord<CreateFundingProgramVersionsRow>,
      Knex.MaybeRawRecord<Partial<Omit<FundingProgramVersionsRow, "uid">>>
    >;
    funding_programs: Knex.CompositeTableType<
      FundingProgramsRow,
      Knex.MaybeRawRecord<CreateFundingProgramsRow>,
      Knex.MaybeRawRecord<Partial<Omit<FundingProgramsRow, "uid">>>
    >;
    gift_cards: Knex.CompositeTableType<
      GiftCardsRow,
      Knex.MaybeRawRecord<CreateGiftCardsRow>,
      Knex.MaybeRawRecord<Partial<Omit<GiftCardsRow, "uid">>>
    >;
    google_users: Knex.CompositeTableType<
      GoogleUsersRow,
      Knex.MaybeRawRecord<CreateGoogleUsersRow>,
      Knex.MaybeRawRecord<Partial<Omit<GoogleUsersRow, "uid">>>
    >;
    guided_catalog_eligibility_documents: Knex.CompositeTableType<
      GuidedCatalogEligibilityDocumentsRow,
      Knex.MaybeRawRecord<CreateGuidedCatalogEligibilityDocumentsRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<GuidedCatalogEligibilityDocumentsRow, "uid">>
      >
    >;
    guided_catalog_eligibility_evidence: Knex.CompositeTableType<
      GuidedCatalogEligibilityEvidenceRow,
      Knex.MaybeRawRecord<CreateGuidedCatalogEligibilityEvidenceRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<GuidedCatalogEligibilityEvidenceRow, "uid">>
      >
    >;
    guided_catalog_funding_rule_set_evidence: Knex.CompositeTableType<
      GuidedCatalogFundingRuleSetEvidenceRow,
      Knex.MaybeRawRecord<CreateGuidedCatalogFundingRuleSetEvidenceRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<GuidedCatalogFundingRuleSetEvidenceRow, "uid">>
      >
    >;
    guided_catalog_funding_rule_sets: Knex.CompositeTableType<
      GuidedCatalogFundingRuleSetsRow,
      Knex.MaybeRawRecord<CreateGuidedCatalogFundingRuleSetsRow>,
      Knex.MaybeRawRecord<Partial<Omit<GuidedCatalogFundingRuleSetsRow, "uid">>>
    >;
    guided_catalog_ingestion_runs: Knex.CompositeTableType<
      GuidedCatalogIngestionRunsRow,
      Knex.MaybeRawRecord<CreateGuidedCatalogIngestionRunsRow>,
      Knex.MaybeRawRecord<Partial<Omit<GuidedCatalogIngestionRunsRow, "uid">>>
    >;
    guided_catalog_listing_funding_eligibilities: Knex.CompositeTableType<
      GuidedCatalogListingFundingEligibilitiesRow,
      Knex.MaybeRawRecord<CreateGuidedCatalogListingFundingEligibilitiesRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<GuidedCatalogListingFundingEligibilitiesRow, "uid">>
      >
    >;
    guided_catalog_listings: Knex.CompositeTableType<
      GuidedCatalogListingsRow,
      Knex.MaybeRawRecord<CreateGuidedCatalogListingsRow>,
      Knex.MaybeRawRecord<Partial<Omit<GuidedCatalogListingsRow, "uid">>>
    >;
    guided_catalog_vendor_funding_eligibilities: Knex.CompositeTableType<
      GuidedCatalogVendorFundingEligibilitiesRow,
      Knex.MaybeRawRecord<CreateGuidedCatalogVendorFundingEligibilitiesRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<GuidedCatalogVendorFundingEligibilitiesRow, "uid">>
      >
    >;
    guided_catalog_vendor_program_permits: Knex.CompositeTableType<
      GuidedCatalogVendorProgramPermitsRow,
      Knex.MaybeRawRecord<CreateGuidedCatalogVendorProgramPermitsRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<GuidedCatalogVendorProgramPermitsRow, "uid">>
      >
    >;
    guided_catalog_vendors: Knex.CompositeTableType<
      GuidedCatalogVendorsRow,
      Knex.MaybeRawRecord<CreateGuidedCatalogVendorsRow>,
      Knex.MaybeRawRecord<Partial<Omit<GuidedCatalogVendorsRow, "uid">>>
    >;
    guided_plan_emails: Knex.CompositeTableType<
      GuidedPlanEmailsRow,
      Knex.MaybeRawRecord<CreateGuidedPlanEmailsRow>,
      Knex.MaybeRawRecord<Partial<Omit<GuidedPlanEmailsRow, "uid">>>
    >;
    guided_plan_search_results: Knex.CompositeTableType<
      GuidedPlanSearchResultsRow,
      Knex.MaybeRawRecord<CreateGuidedPlanSearchResultsRow>,
      Knex.MaybeRawRecord<Partial<Omit<GuidedPlanSearchResultsRow, "uid">>>
    >;
    guided_plan_slots: Knex.CompositeTableType<
      GuidedPlanSlotsRow,
      Knex.MaybeRawRecord<CreateGuidedPlanSlotsRow>,
      Knex.MaybeRawRecord<Partial<Omit<GuidedPlanSlotsRow, "uid">>>
    >;
    guided_plans: Knex.CompositeTableType<
      GuidedPlansRow,
      Knex.MaybeRawRecord<CreateGuidedPlansRow>,
      Knex.MaybeRawRecord<Partial<Omit<GuidedPlansRow, "uid">>>
    >;
    guided_user_feedbacks: Knex.CompositeTableType<
      GuidedUserFeedbacksRow,
      Knex.MaybeRawRecord<CreateGuidedUserFeedbacksRow>,
      Knex.MaybeRawRecord<Partial<Omit<GuidedUserFeedbacksRow, "uid">>>
    >;
    holidays: Knex.CompositeTableType<
      HolidaysRow,
      Knex.MaybeRawRecord<CreateHolidaysRow>,
      Knex.MaybeRawRecord<Partial<Omit<HolidaysRow, "uid">>>
    >;
    invoices: Knex.CompositeTableType<
      InvoicesRow,
      Knex.MaybeRawRecord<CreateInvoicesRow>,
      Knex.MaybeRawRecord<Partial<Omit<InvoicesRow, "uid">>>
    >;
    known_spam_users: Knex.CompositeTableType<
      KnownSpamUsersRow,
      Knex.MaybeRawRecord<CreateKnownSpamUsersRow>,
      Knex.MaybeRawRecord<Partial<Omit<KnownSpamUsersRow, "uid">>>
    >;
    learner_allowance_payments: Knex.CompositeTableType<
      LearnerAllowancePaymentsRow,
      Knex.MaybeRawRecord<CreateLearnerAllowancePaymentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerAllowancePaymentsRow, "uid">>>
    >;
    learner_allowances: Knex.CompositeTableType<
      LearnerAllowancesRow,
      Knex.MaybeRawRecord<CreateLearnerAllowancesRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerAllowancesRow, "uid">>>
    >;
    learner_attributes: Knex.CompositeTableType<
      LearnerAttributesRow,
      Knex.MaybeRawRecord<CreateLearnerAttributesRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerAttributesRow, "uid">>>
    >;
    learner_avatars: Knex.CompositeTableType<
      LearnerAvatarsRow,
      Knex.MaybeRawRecord<CreateLearnerAvatarsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerAvatarsRow, "uid">>>
    >;
    learner_behavior_reports: Knex.CompositeTableType<
      LearnerBehaviorReportsRow,
      Knex.MaybeRawRecord<CreateLearnerBehaviorReportsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerBehaviorReportsRow, "uid">>>
    >;
    learner_devices: Knex.CompositeTableType<
      LearnerDevicesRow,
      Knex.MaybeRawRecord<CreateLearnerDevicesRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerDevicesRow, "uid">>>
    >;
    learner_enrollment_requests: Knex.CompositeTableType<
      LearnerEnrollmentRequestsRow,
      Knex.MaybeRawRecord<CreateLearnerEnrollmentRequestsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerEnrollmentRequestsRow, "uid">>>
    >;
    learner_funding_programs: Knex.CompositeTableType<
      LearnerFundingProgramsRow,
      Knex.MaybeRawRecord<CreateLearnerFundingProgramsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerFundingProgramsRow, "uid">>>
    >;
    learner_interest_topics: Knex.CompositeTableType<
      LearnerInterestTopicsRow,
      Knex.MaybeRawRecord<CreateLearnerInterestTopicsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerInterestTopicsRow, "uid">>>
    >;
    learner_interface_preferences: Knex.CompositeTableType<
      LearnerInterfacePreferencesRow,
      Knex.MaybeRawRecord<CreateLearnerInterfacePreferencesRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerInterfacePreferencesRow, "uid">>>
    >;
    learner_meeting_summary: Knex.CompositeTableType<
      LearnerMeetingSummaryRow,
      Knex.MaybeRawRecord<CreateLearnerMeetingSummaryRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerMeetingSummaryRow, "uid">>>
    >;
    learner_mix_topics: Knex.CompositeTableType<
      LearnerMixTopicsRow,
      Knex.MaybeRawRecord<CreateLearnerMixTopicsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerMixTopicsRow, "uid">>>
    >;
    learner_plan_activities: Knex.CompositeTableType<
      LearnerPlanActivitiesRow,
      Knex.MaybeRawRecord<CreateLearnerPlanActivitiesRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerPlanActivitiesRow, "uid">>>
    >;
    learner_plan_goal_filters: Knex.CompositeTableType<
      LearnerPlanGoalFiltersRow,
      Knex.MaybeRawRecord<CreateLearnerPlanGoalFiltersRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerPlanGoalFiltersRow, "uid">>>
    >;
    learner_plan_goals: Knex.CompositeTableType<
      LearnerPlanGoalsRow,
      Knex.MaybeRawRecord<CreateLearnerPlanGoalsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerPlanGoalsRow, "uid">>>
    >;
    learner_plan_rejected_suggestions: Knex.CompositeTableType<
      LearnerPlanRejectedSuggestionsRow,
      Knex.MaybeRawRecord<CreateLearnerPlanRejectedSuggestionsRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<LearnerPlanRejectedSuggestionsRow, "uid">>
      >
    >;
    learner_plans: Knex.CompositeTableType<
      LearnerPlansRow,
      Knex.MaybeRawRecord<CreateLearnerPlansRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerPlansRow, "uid">>>
    >;
    learner_search_guardrails: Knex.CompositeTableType<
      LearnerSearchGuardrailsRow,
      Knex.MaybeRawRecord<CreateLearnerSearchGuardrailsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerSearchGuardrailsRow, "uid">>>
    >;
    learner_section_documents: Knex.CompositeTableType<
      LearnerSectionDocumentsRow,
      Knex.MaybeRawRecord<CreateLearnerSectionDocumentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerSectionDocumentsRow, "uid">>>
    >;
    learner_section_grades: Knex.CompositeTableType<
      LearnerSectionGradesRow,
      Knex.MaybeRawRecord<CreateLearnerSectionGradesRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerSectionGradesRow, "uid">>>
    >;
    learner_section_notes: Knex.CompositeTableType<
      LearnerSectionNotesRow,
      Knex.MaybeRawRecord<CreateLearnerSectionNotesRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerSectionNotesRow, "uid">>>
    >;
    learner_section_reviews: Knex.CompositeTableType<
      LearnerSectionReviewsRow,
      Knex.MaybeRawRecord<CreateLearnerSectionReviewsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerSectionReviewsRow, "uid">>>
    >;
    learner_unlockables: Knex.CompositeTableType<
      LearnerUnlockablesRow,
      Knex.MaybeRawRecord<CreateLearnerUnlockablesRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnerUnlockablesRow, "uid">>>
    >;
    learners: Knex.CompositeTableType<
      LearnersRow,
      Knex.MaybeRawRecord<CreateLearnersRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearnersRow, "uid">>>
    >;
    learning_actors: Knex.CompositeTableType<
      LearningActorsRow,
      Knex.MaybeRawRecord<CreateLearningActorsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearningActorsRow, "uid">>>
    >;
    learning_assignment_class_post_comments: Knex.CompositeTableType<
      LearningAssignmentClassPostCommentsRow,
      Knex.MaybeRawRecord<CreateLearningAssignmentClassPostCommentsRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<LearningAssignmentClassPostCommentsRow, "uid">>
      >
    >;
    learning_assignment_class_post_grades: Knex.CompositeTableType<
      LearningAssignmentClassPostGradesRow,
      Knex.MaybeRawRecord<CreateLearningAssignmentClassPostGradesRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<LearningAssignmentClassPostGradesRow, "uid">>
      >
    >;
    learning_assignment_class_posts: Knex.CompositeTableType<
      LearningAssignmentClassPostsRow,
      Knex.MaybeRawRecord<CreateLearningAssignmentClassPostsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearningAssignmentClassPostsRow, "uid">>>
    >;
    learning_assignment_lesson_posts: Knex.CompositeTableType<
      LearningAssignmentLessonPostsRow,
      Knex.MaybeRawRecord<CreateLearningAssignmentLessonPostsRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<LearningAssignmentLessonPostsRow, "uid">>
      >
    >;
    learning_lessons: Knex.CompositeTableType<
      LearningLessonsRow,
      Knex.MaybeRawRecord<CreateLearningLessonsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearningLessonsRow, "uid">>>
    >;
    learning_statements: Knex.CompositeTableType<
      LearningStatementsRow,
      Knex.MaybeRawRecord<CreateLearningStatementsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearningStatementsRow, "uid">>>
    >;
    learning_syllabuses: Knex.CompositeTableType<
      LearningSyllabusesRow,
      Knex.MaybeRawRecord<CreateLearningSyllabusesRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearningSyllabusesRow, "uid">>>
    >;
    learning_units: Knex.CompositeTableType<
      LearningUnitsRow,
      Knex.MaybeRawRecord<CreateLearningUnitsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LearningUnitsRow, "uid">>>
    >;
    lesson_posts: Knex.CompositeTableType<
      LessonPostsRow,
      Knex.MaybeRawRecord<CreateLessonPostsRow>,
      Knex.MaybeRawRecord<Partial<Omit<LessonPostsRow, "uid">>>
    >;
    math_challenge_attempts: Knex.CompositeTableType<
      MathChallengeAttemptsRow,
      Knex.MaybeRawRecord<CreateMathChallengeAttemptsRow>,
      Knex.MaybeRawRecord<Partial<Omit<MathChallengeAttemptsRow, "uid">>>
    >;
    meeting_ai_summaries: Knex.CompositeTableType<
      MeetingAiSummariesRow,
      Knex.MaybeRawRecord<CreateMeetingAiSummariesRow>,
      Knex.MaybeRawRecord<Partial<Omit<MeetingAiSummariesRow, "uid">>>
    >;
    meeting_requests: Knex.CompositeTableType<
      MeetingRequestsRow,
      Knex.MaybeRawRecord<CreateMeetingRequestsRow>,
      Knex.MaybeRawRecord<Partial<Omit<MeetingRequestsRow, "uid">>>
    >;
    meeting_reviews: Knex.CompositeTableType<
      MeetingReviewsRow,
      Knex.MaybeRawRecord<CreateMeetingReviewsRow>,
      Knex.MaybeRawRecord<Partial<Omit<MeetingReviewsRow, "uid">>>
    >;
    meetings: Knex.CompositeTableType<
      MeetingsRow,
      Knex.MaybeRawRecord<CreateMeetingsRow>,
      Knex.MaybeRawRecord<Partial<Omit<MeetingsRow, "uid">>>
    >;
    message_contents: Knex.CompositeTableType<
      MessageContentsRow,
      Knex.MaybeRawRecord<CreateMessageContentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<MessageContentsRow, "uid">>>
    >;
    message_read_events: Knex.CompositeTableType<
      MessageReadEventsRow,
      Knex.MaybeRawRecord<CreateMessageReadEventsRow>,
      Knex.MaybeRawRecord<Partial<Omit<MessageReadEventsRow, "uid">>>
    >;
    message_spam_markers: Knex.CompositeTableType<
      MessageSpamMarkersRow,
      Knex.MaybeRawRecord<CreateMessageSpamMarkersRow>,
      Knex.MaybeRawRecord<Partial<Omit<MessageSpamMarkersRow, "uid">>>
    >;
    messages: Knex.CompositeTableType<
      MessagesRow,
      Knex.MaybeRawRecord<CreateMessagesRow>,
      Knex.MaybeRawRecord<Partial<Omit<MessagesRow, "uid">>>
    >;
    monitoring_prompts: Knex.CompositeTableType<
      MonitoringPromptsRow,
      Knex.MaybeRawRecord<CreateMonitoringPromptsRow>,
      Knex.MaybeRawRecord<Partial<Omit<MonitoringPromptsRow, "uid">>>
    >;
    nonce_challenges: Knex.CompositeTableType<
      NonceChallengesRow,
      Knex.MaybeRawRecord<CreateNonceChallengesRow>,
      Knex.MaybeRawRecord<Partial<Omit<NonceChallengesRow, "uid">>>
    >;
    notifications: Knex.CompositeTableType<
      NotificationsRow,
      Knex.MaybeRawRecord<CreateNotificationsRow>,
      Knex.MaybeRawRecord<Partial<Omit<NotificationsRow, "uid">>>
    >;
    oidc_users: Knex.CompositeTableType<
      OidcUsersRow,
      Knex.MaybeRawRecord<CreateOidcUsersRow>,
      Knex.MaybeRawRecord<Partial<Omit<OidcUsersRow, "uid">>>
    >;
    order_checkout_tender_selections: Knex.CompositeTableType<
      OrderCheckoutTenderSelectionsRow,
      Knex.MaybeRawRecord<CreateOrderCheckoutTenderSelectionsRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<OrderCheckoutTenderSelectionsRow, "uid">>
      >
    >;
    order_payments: Knex.CompositeTableType<
      OrderPaymentsRow,
      Knex.MaybeRawRecord<CreateOrderPaymentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<OrderPaymentsRow, "uid">>>
    >;
    order_taxes: Knex.CompositeTableType<
      OrderTaxesRow,
      Knex.MaybeRawRecord<CreateOrderTaxesRow>,
      Knex.MaybeRawRecord<Partial<Omit<OrderTaxesRow, "uid">>>
    >;
    organizations: Knex.CompositeTableType<
      OrganizationsRow,
      Knex.MaybeRawRecord<CreateOrganizationsRow>,
      Knex.MaybeRawRecord<Partial<Omit<OrganizationsRow, "uid">>>
    >;
    other_user_emails: Knex.CompositeTableType<
      OtherUserEmailsRow,
      Knex.MaybeRawRecord<CreateOtherUserEmailsRow>,
      Knex.MaybeRawRecord<Partial<Omit<OtherUserEmailsRow, "uid">>>
    >;
    parsed_class_recordings: Knex.CompositeTableType<
      ParsedClassRecordingsRow,
      Knex.MaybeRawRecord<CreateParsedClassRecordingsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ParsedClassRecordingsRow, "uid">>>
    >;
    payable_transactions: Knex.CompositeTableType<
      PayableTransactionsRow,
      Knex.MaybeRawRecord<CreatePayableTransactionsRow>,
      Knex.MaybeRawRecord<Partial<Omit<PayableTransactionsRow, "uid">>>
    >;
    payment_schedule_payments: Knex.CompositeTableType<
      PaymentSchedulePaymentsRow,
      Knex.MaybeRawRecord<CreatePaymentSchedulePaymentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<PaymentSchedulePaymentsRow, "uid">>>
    >;
    payment_schedule_payments_failures: Knex.CompositeTableType<
      PaymentSchedulePaymentsFailuresRow,
      Knex.MaybeRawRecord<CreatePaymentSchedulePaymentsFailuresRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<PaymentSchedulePaymentsFailuresRow, "uid">>
      >
    >;
    payment_schedules: Knex.CompositeTableType<
      PaymentSchedulesRow,
      Knex.MaybeRawRecord<CreatePaymentSchedulesRow>,
      Knex.MaybeRawRecord<Partial<Omit<PaymentSchedulesRow, "uid">>>
    >;
    payout_batch_attempts: Knex.CompositeTableType<
      PayoutBatchAttemptsRow,
      Knex.MaybeRawRecord<CreatePayoutBatchAttemptsRow>,
      Knex.MaybeRawRecord<Partial<Omit<PayoutBatchAttemptsRow, "uid">>>
    >;
    payout_sources: Knex.CompositeTableType<
      PayoutSourcesRow,
      Knex.MaybeRawRecord<CreatePayoutSourcesRow>,
      Knex.MaybeRawRecord<Partial<Omit<PayoutSourcesRow, "uid">>>
    >;
    payouts: Knex.CompositeTableType<
      PayoutsRow,
      Knex.MaybeRawRecord<CreatePayoutsRow>,
      Knex.MaybeRawRecord<Partial<Omit<PayoutsRow, "uid">>>
    >;
    pricing_adjustments: Knex.CompositeTableType<
      PricingAdjustmentsRow,
      Knex.MaybeRawRecord<CreatePricingAdjustmentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<PricingAdjustmentsRow, "uid">>>
    >;
    pricing_offer_email_addresses: Knex.CompositeTableType<
      PricingOfferEmailAddressesRow,
      Knex.MaybeRawRecord<CreatePricingOfferEmailAddressesRow>,
      Knex.MaybeRawRecord<Partial<Omit<PricingOfferEmailAddressesRow, "uid">>>
    >;
    pricing_offer_email_domains: Knex.CompositeTableType<
      PricingOfferEmailDomainsRow,
      Knex.MaybeRawRecord<CreatePricingOfferEmailDomainsRow>,
      Knex.MaybeRawRecord<Partial<Omit<PricingOfferEmailDomainsRow, "uid">>>
    >;
    pricing_offers: Knex.CompositeTableType<
      PricingOffersRow,
      Knex.MaybeRawRecord<CreatePricingOffersRow>,
      Knex.MaybeRawRecord<Partial<Omit<PricingOffersRow, "uid">>>
    >;
    private_class_messages: Knex.CompositeTableType<
      PrivateClassMessagesRow,
      Knex.MaybeRawRecord<CreatePrivateClassMessagesRow>,
      Knex.MaybeRawRecord<Partial<Omit<PrivateClassMessagesRow, "uid">>>
    >;
    private_learner_notes: Knex.CompositeTableType<
      PrivateLearnerNotesRow,
      Knex.MaybeRawRecord<CreatePrivateLearnerNotesRow>,
      Knex.MaybeRawRecord<Partial<Omit<PrivateLearnerNotesRow, "uid">>>
    >;
    prompts: Knex.CompositeTableType<
      PromptsRow,
      Knex.MaybeRawRecord<CreatePromptsRow>,
      Knex.MaybeRawRecord<Partial<Omit<PromptsRow, "uid">>>
    >;
    quiz_attempts: Knex.CompositeTableType<
      QuizAttemptsRow,
      Knex.MaybeRawRecord<CreateQuizAttemptsRow>,
      Knex.MaybeRawRecord<Partial<Omit<QuizAttemptsRow, "uid">>>
    >;
    quiz_topics: Knex.CompositeTableType<
      QuizTopicsRow,
      Knex.MaybeRawRecord<CreateQuizTopicsRow>,
      Knex.MaybeRawRecord<Partial<Omit<QuizTopicsRow, "uid">>>
    >;
    quizzes: Knex.CompositeTableType<
      QuizzesRow,
      Knex.MaybeRawRecord<CreateQuizzesRow>,
      Knex.MaybeRawRecord<Partial<Omit<QuizzesRow, "uid">>>
    >;
    recording_ai_teacher_observations: Knex.CompositeTableType<
      RecordingAiTeacherObservationsRow,
      Knex.MaybeRawRecord<CreateRecordingAiTeacherObservationsRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<RecordingAiTeacherObservationsRow, "uid">>
      >
    >;
    saved_activities: Knex.CompositeTableType<
      SavedActivitiesRow,
      Knex.MaybeRawRecord<CreateSavedActivitiesRow>,
      Knex.MaybeRawRecord<Partial<Omit<SavedActivitiesRow, "uid">>>
    >;
    saved_class_lists: Knex.CompositeTableType<
      SavedClassListsRow,
      Knex.MaybeRawRecord<CreateSavedClassListsRow>,
      Knex.MaybeRawRecord<Partial<Omit<SavedClassListsRow, "uid">>>
    >;
    saved_searches: Knex.CompositeTableType<
      SavedSearchesRow,
      Knex.MaybeRawRecord<CreateSavedSearchesRow>,
      Knex.MaybeRawRecord<Partial<Omit<SavedSearchesRow, "uid">>>
    >;
    section_availability_read_model: Knex.CompositeTableType<
      SectionAvailabilityReadModelRow,
      Knex.MaybeRawRecord<CreateSectionAvailabilityReadModelRow>,
      Knex.MaybeRawRecord<Partial<Omit<SectionAvailabilityReadModelRow, "uid">>>
    >;
    section_moderators: Knex.CompositeTableType<
      SectionModeratorsRow,
      Knex.MaybeRawRecord<CreateSectionModeratorsRow>,
      Knex.MaybeRawRecord<Partial<Omit<SectionModeratorsRow, "uid">>>
    >;
    section_recurring_meetings: Knex.CompositeTableType<
      SectionRecurringMeetingsRow,
      Knex.MaybeRawRecord<CreateSectionRecurringMeetingsRow>,
      Knex.MaybeRawRecord<Partial<Omit<SectionRecurringMeetingsRow, "uid">>>
    >;
    section_recurring_schedules: Knex.CompositeTableType<
      SectionRecurringSchedulesRow,
      Knex.MaybeRawRecord<CreateSectionRecurringSchedulesRow>,
      Knex.MaybeRawRecord<Partial<Omit<SectionRecurringSchedulesRow, "uid">>>
    >;
    sections: Knex.CompositeTableType<
      SectionsRow,
      Knex.MaybeRawRecord<CreateSectionsRow>,
      Knex.MaybeRawRecord<Partial<Omit<SectionsRow, "uid">>>
    >;
    sections_availability: Knex.CompositeTableType<
      SectionsAvailabilityRow,
      Knex.MaybeRawRecord<CreateSectionsAvailabilityRow>,
      Knex.MaybeRawRecord<Partial<Omit<SectionsAvailabilityRow, "uid">>>
    >;
    seller_org_agreements: Knex.CompositeTableType<
      SellerOrgAgreementsRow,
      Knex.MaybeRawRecord<CreateSellerOrgAgreementsRow>,
      Knex.MaybeRawRecord<Partial<Omit<SellerOrgAgreementsRow, "uid">>>
    >;
    seller_org_applications: Knex.CompositeTableType<
      SellerOrgApplicationsRow,
      Knex.MaybeRawRecord<CreateSellerOrgApplicationsRow>,
      Knex.MaybeRawRecord<Partial<Omit<SellerOrgApplicationsRow, "uid">>>
    >;
    seller_orgs: Knex.CompositeTableType<
      SellerOrgsRow,
      Knex.MaybeRawRecord<CreateSellerOrgsRow>,
      Knex.MaybeRawRecord<Partial<Omit<SellerOrgsRow, "uid">>>
    >;
    sent_notifications: Knex.CompositeTableType<
      SentNotificationsRow,
      Knex.MaybeRawRecord<CreateSentNotificationsRow>,
      Knex.MaybeRawRecord<Partial<Omit<SentNotificationsRow, "uid">>>
    >;
    stripe_collection_invoices: Knex.CompositeTableType<
      StripeCollectionInvoicesRow,
      Knex.MaybeRawRecord<CreateStripeCollectionInvoicesRow>,
      Knex.MaybeRawRecord<Partial<Omit<StripeCollectionInvoicesRow, "uid">>>
    >;
    stripe_coupon_promo_codes: Knex.CompositeTableType<
      StripeCouponPromoCodesRow,
      Knex.MaybeRawRecord<CreateStripeCouponPromoCodesRow>,
      Knex.MaybeRawRecord<Partial<Omit<StripeCouponPromoCodesRow, "uid">>>
    >;
    stripe_fingerprints: Knex.CompositeTableType<
      StripeFingerprintsRow,
      Knex.MaybeRawRecord<CreateStripeFingerprintsRow>,
      Knex.MaybeRawRecord<Partial<Omit<StripeFingerprintsRow, "uid">>>
    >;
    stripe_transfers: Knex.CompositeTableType<
      StripeTransfersRow,
      Knex.MaybeRawRecord<CreateStripeTransfersRow>,
      Knex.MaybeRawRecord<Partial<Omit<StripeTransfersRow, "uid">>>
    >;
    subscription_packages: Knex.CompositeTableType<
      SubscriptionPackagesRow,
      Knex.MaybeRawRecord<CreateSubscriptionPackagesRow>,
      Knex.MaybeRawRecord<Partial<Omit<SubscriptionPackagesRow, "uid">>>
    >;
    subscriptions: Knex.CompositeTableType<
      SubscriptionsRow,
      Knex.MaybeRawRecord<CreateSubscriptionsRow>,
      Knex.MaybeRawRecord<Partial<Omit<SubscriptionsRow, "uid">>>
    >;
    teacher_activity_stats: Knex.CompositeTableType<
      TeacherActivityStatsRow,
      Knex.MaybeRawRecord<CreateTeacherActivityStatsRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherActivityStatsRow, "uid">>>
    >;
    teacher_applications: Knex.CompositeTableType<
      TeacherApplicationsRow,
      Knex.MaybeRawRecord<CreateTeacherApplicationsRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherApplicationsRow, "uid">>>
    >;
    teacher_attendances: Knex.CompositeTableType<
      TeacherAttendancesRow,
      Knex.MaybeRawRecord<CreateTeacherAttendancesRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherAttendancesRow, "uid">>>
    >;
    teacher_attributes: Knex.CompositeTableType<
      TeacherAttributesRow,
      Knex.MaybeRawRecord<CreateTeacherAttributesRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherAttributesRow, "uid">>>
    >;
    teacher_credentials: Knex.CompositeTableType<
      TeacherCredentialsRow,
      Knex.MaybeRawRecord<CreateTeacherCredentialsRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherCredentialsRow, "uid">>>
    >;
    teacher_feedback_quotes: Knex.CompositeTableType<
      TeacherFeedbackQuotesRow,
      Knex.MaybeRawRecord<CreateTeacherFeedbackQuotesRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherFeedbackQuotesRow, "uid">>>
    >;
    teacher_feedback_summary: Knex.CompositeTableType<
      TeacherFeedbackSummaryRow,
      Knex.MaybeRawRecord<CreateTeacherFeedbackSummaryRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherFeedbackSummaryRow, "uid">>>
    >;
    teacher_marketing_settings: Knex.CompositeTableType<
      TeacherMarketingSettingsRow,
      Knex.MaybeRawRecord<CreateTeacherMarketingSettingsRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherMarketingSettingsRow, "uid">>>
    >;
    teacher_schedule_availability: Knex.CompositeTableType<
      TeacherScheduleAvailabilityRow,
      Knex.MaybeRawRecord<CreateTeacherScheduleAvailabilityRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherScheduleAvailabilityRow, "uid">>>
    >;
    teacher_schedule_enrollable_times: Knex.CompositeTableType<
      TeacherScheduleEnrollableTimesRow,
      Knex.MaybeRawRecord<CreateTeacherScheduleEnrollableTimesRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<TeacherScheduleEnrollableTimesRow, "uid">>
      >
    >;
    teacher_schedule_update_requests: Knex.CompositeTableType<
      TeacherScheduleUpdateRequestsRow,
      Knex.MaybeRawRecord<CreateTeacherScheduleUpdateRequestsRow>,
      Knex.MaybeRawRecord<
        Partial<Omit<TeacherScheduleUpdateRequestsRow, "uid">>
      >
    >;
    teacher_schedules: Knex.CompositeTableType<
      TeacherSchedulesRow,
      Knex.MaybeRawRecord<CreateTeacherSchedulesRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherSchedulesRow, "uid">>>
    >;
    teacher_similarity: Knex.CompositeTableType<
      TeacherSimilarityRow,
      Knex.MaybeRawRecord<CreateTeacherSimilarityRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherSimilarityRow, "uid">>>
    >;
    teacher_stats: Knex.CompositeTableType<
      TeacherStatsRow,
      Knex.MaybeRawRecord<CreateTeacherStatsRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherStatsRow, "uid">>>
    >;
    teacher_tags: Knex.CompositeTableType<
      TeacherTagsRow,
      Knex.MaybeRawRecord<CreateTeacherTagsRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherTagsRow, "uid">>>
    >;
    teacher_tags_assigned: Knex.CompositeTableType<
      TeacherTagsAssignedRow,
      Knex.MaybeRawRecord<CreateTeacherTagsAssignedRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherTagsAssignedRow, "uid">>>
    >;
    teacher_unavailable_blocks: Knex.CompositeTableType<
      TeacherUnavailableBlocksRow,
      Knex.MaybeRawRecord<CreateTeacherUnavailableBlocksRow>,
      Knex.MaybeRawRecord<Partial<Omit<TeacherUnavailableBlocksRow, "uid">>>
    >;
    temporary_tokens: Knex.CompositeTableType<
      TemporaryTokensRow,
      Knex.MaybeRawRecord<CreateTemporaryTokensRow>,
      Knex.MaybeRawRecord<Partial<Omit<TemporaryTokensRow, "uid">>>
    >;
    topics: Knex.CompositeTableType<
      TopicsRow,
      Knex.MaybeRawRecord<CreateTopicsRow>,
      Knex.MaybeRawRecord<Partial<Omit<TopicsRow, "uid">>>
    >;
    trending_search_topics: Knex.CompositeTableType<
      TrendingSearchTopicsRow,
      Knex.MaybeRawRecord<CreateTrendingSearchTopicsRow>,
      Knex.MaybeRawRecord<Partial<Omit<TrendingSearchTopicsRow, "uid">>>
    >;
    trust_privileges: Knex.CompositeTableType<
      TrustPrivilegesRow,
      Knex.MaybeRawRecord<CreateTrustPrivilegesRow>,
      Knex.MaybeRawRecord<Partial<Omit<TrustPrivilegesRow, "uid">>>
    >;
    upcoming_sections: Knex.CompositeTableType<
      UpcomingSectionsRow,
      Knex.MaybeRawRecord<CreateUpcomingSectionsRow>,
      Knex.MaybeRawRecord<Partial<Omit<UpcomingSectionsRow, "uid">>>
    >;
    user_churn_indicators: Knex.CompositeTableType<
      UserChurnIndicatorsRow,
      Knex.MaybeRawRecord<CreateUserChurnIndicatorsRow>,
      Knex.MaybeRawRecord<Partial<Omit<UserChurnIndicatorsRow, "uid">>>
    >;
    user_email_preferences: Knex.CompositeTableType<
      UserEmailPreferencesRow,
      Knex.MaybeRawRecord<CreateUserEmailPreferencesRow>,
      Knex.MaybeRawRecord<Partial<Omit<UserEmailPreferencesRow, "uid">>>
    >;
    user_financial_assistance: Knex.CompositeTableType<
      UserFinancialAssistanceRow,
      Knex.MaybeRawRecord<CreateUserFinancialAssistanceRow>,
      Knex.MaybeRawRecord<Partial<Omit<UserFinancialAssistanceRow, "uid">>>
    >;
    user_incidents: Knex.CompositeTableType<
      UserIncidentsRow,
      Knex.MaybeRawRecord<CreateUserIncidentsRow>,
      Knex.MaybeRawRecord<Partial<Omit<UserIncidentsRow, "uid">>>
    >;
    user_incidents_summaries: Knex.CompositeTableType<
      UserIncidentsSummariesRow,
      Knex.MaybeRawRecord<CreateUserIncidentsSummariesRow>,
      Knex.MaybeRawRecord<Partial<Omit<UserIncidentsSummariesRow, "uid">>>
    >;
    user_login_attempts_log: Knex.CompositeTableType<
      UserLoginAttemptsLogRow,
      Knex.MaybeRawRecord<CreateUserLoginAttemptsLogRow>,
      Knex.MaybeRawRecord<Partial<Omit<UserLoginAttemptsLogRow, "uid">>>
    >;
    user_pricing_offers: Knex.CompositeTableType<
      UserPricingOffersRow,
      Knex.MaybeRawRecord<CreateUserPricingOffersRow>,
      Knex.MaybeRawRecord<Partial<Omit<UserPricingOffersRow, "uid">>>
    >;
    users: Knex.CompositeTableType<
      UsersRow,
      Knex.MaybeRawRecord<CreateUsersRow>,
      Knex.MaybeRawRecord<Partial<Omit<UsersRow, "uid">>>
    >;
    waitlist_seats: Knex.CompositeTableType<
      WaitlistSeatsRow,
      Knex.MaybeRawRecord<CreateWaitlistSeatsRow>,
      Knex.MaybeRawRecord<Partial<Omit<WaitlistSeatsRow, "uid">>>
    >;
    zoom_meetings: Knex.CompositeTableType<
      ZoomMeetingsRow,
      Knex.MaybeRawRecord<CreateZoomMeetingsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ZoomMeetingsRow, "uid">>>
    >;
    zoom_recordings: Knex.CompositeTableType<
      ZoomRecordingsRow,
      Knex.MaybeRawRecord<CreateZoomRecordingsRow>,
      Knex.MaybeRawRecord<Partial<Omit<ZoomRecordingsRow, "uid">>>
    >;
    zoom_users: Knex.CompositeTableType<
      ZoomUsersRow,
      Knex.MaybeRawRecord<CreateZoomUsersRow>,
      Knex.MaybeRawRecord<Partial<Omit<ZoomUsersRow, "uid">>>
    >;
  }
}
